var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { NacelleGraphQLConnector } from "@nacelle/client-js-sdk";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var backoff = {};
var options = {};
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign = Object.assign || function(t2) {
    for (var s2, i2 = 1, n = arguments.length; i2 < n; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(options, "__esModule", { value: true });
var defaultOptions = {
  delayFirstAttempt: false,
  jitter: "none",
  maxDelay: Infinity,
  numOfAttempts: 10,
  retry: function() {
    return true;
  },
  startingDelay: 100,
  timeMultiple: 2
};
function getSanitizedOptions(options2) {
  var sanitized = __assign(__assign({}, defaultOptions), options2);
  if (sanitized.numOfAttempts < 1) {
    sanitized.numOfAttempts = 1;
  }
  return sanitized;
}
options.getSanitizedOptions = getSanitizedOptions;
var delay_factory = {};
var skipFirst_delay = {};
var delay_base = {};
var jitter_factory = {};
var full_jitter = {};
Object.defineProperty(full_jitter, "__esModule", { value: true });
function fullJitter(delay) {
  var jitteredDelay = Math.random() * delay;
  return Math.round(jitteredDelay);
}
full_jitter.fullJitter = fullJitter;
var no_jitter = {};
Object.defineProperty(no_jitter, "__esModule", { value: true });
function noJitter(delay) {
  return delay;
}
no_jitter.noJitter = noJitter;
Object.defineProperty(jitter_factory, "__esModule", { value: true });
var full_jitter_1 = full_jitter;
var no_jitter_1 = no_jitter;
function JitterFactory(options2) {
  switch (options2.jitter) {
    case "full":
      return full_jitter_1.fullJitter;
    case "none":
    default:
      return no_jitter_1.noJitter;
  }
}
jitter_factory.JitterFactory = JitterFactory;
Object.defineProperty(delay_base, "__esModule", { value: true });
var jitter_factory_1 = jitter_factory;
var Delay = function() {
  function Delay2(options2) {
    this.options = options2;
    this.attempt = 0;
  }
  Delay2.prototype.apply = function() {
    var _this = this;
    return new Promise(function(resolve) {
      return setTimeout(resolve, _this.jitteredDelay);
    });
  };
  Delay2.prototype.setAttemptNumber = function(attempt) {
    this.attempt = attempt;
  };
  Object.defineProperty(Delay2.prototype, "jitteredDelay", {
    get: function() {
      var jitter = jitter_factory_1.JitterFactory(this.options);
      return jitter(this.delay);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Delay2.prototype, "delay", {
    get: function() {
      var constant = this.options.startingDelay;
      var base = this.options.timeMultiple;
      var power = this.numOfDelayedAttempts;
      var delay = constant * Math.pow(base, power);
      return Math.min(delay, this.options.maxDelay);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Delay2.prototype, "numOfDelayedAttempts", {
    get: function() {
      return this.attempt;
    },
    enumerable: true,
    configurable: true
  });
  return Delay2;
}();
delay_base.Delay = Delay;
var __extends$1 = commonjsGlobal && commonjsGlobal.__extends || function() {
  var extendStatics = function(d2, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b2) {
      d3.__proto__ = b2;
    } || function(d3, b2) {
      for (var p2 in b2)
        if (b2.hasOwnProperty(p2))
          d3[p2] = b2[p2];
    };
    return extendStatics(d2, b);
  };
  return function(d2, b) {
    extendStatics(d2, b);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$1 = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f2 = 1, y && (t2 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t2 = y["return"]) && t2.call(y), 0) : y.next) && !(t2 = t2.call(y, op[1])).done)
          return t2;
        if (y = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
Object.defineProperty(skipFirst_delay, "__esModule", { value: true });
var delay_base_1$1 = delay_base;
var SkipFirstDelay = function(_super) {
  __extends$1(SkipFirstDelay2, _super);
  function SkipFirstDelay2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SkipFirstDelay2.prototype.apply = function() {
    return __awaiter$1(this, void 0, void 0, function() {
      return __generator$1(this, function(_a) {
        return [2, this.isFirstAttempt ? true : _super.prototype.apply.call(this)];
      });
    });
  };
  Object.defineProperty(SkipFirstDelay2.prototype, "isFirstAttempt", {
    get: function() {
      return this.attempt === 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SkipFirstDelay2.prototype, "numOfDelayedAttempts", {
    get: function() {
      return this.attempt - 1;
    },
    enumerable: true,
    configurable: true
  });
  return SkipFirstDelay2;
}(delay_base_1$1.Delay);
skipFirst_delay.SkipFirstDelay = SkipFirstDelay;
var always_delay = {};
var __extends = commonjsGlobal && commonjsGlobal.__extends || function() {
  var extendStatics = function(d2, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b2) {
      d3.__proto__ = b2;
    } || function(d3, b2) {
      for (var p2 in b2)
        if (b2.hasOwnProperty(p2))
          d3[p2] = b2[p2];
    };
    return extendStatics(d2, b);
  };
  return function(d2, b) {
    extendStatics(d2, b);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(always_delay, "__esModule", { value: true });
var delay_base_1 = delay_base;
var AlwaysDelay = function(_super) {
  __extends(AlwaysDelay2, _super);
  function AlwaysDelay2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return AlwaysDelay2;
}(delay_base_1.Delay);
always_delay.AlwaysDelay = AlwaysDelay;
Object.defineProperty(delay_factory, "__esModule", { value: true });
var skip_first_delay_1 = skipFirst_delay;
var always_delay_1 = always_delay;
function DelayFactory(options2, attempt) {
  var delay = initDelayClass(options2);
  delay.setAttemptNumber(attempt);
  return delay;
}
delay_factory.DelayFactory = DelayFactory;
function initDelayClass(options2) {
  if (!options2.delayFirstAttempt) {
    return new skip_first_delay_1.SkipFirstDelay(options2);
  }
  return new always_delay_1.AlwaysDelay(options2);
}
var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f2 = 1, y && (t2 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t2 = y["return"]) && t2.call(y), 0) : y.next) && !(t2 = t2.call(y, op[1])).done)
          return t2;
        if (y = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
Object.defineProperty(backoff, "__esModule", { value: true });
var options_1 = options;
var delay_factory_1 = delay_factory;
function backOff(request, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return __awaiter(this, void 0, void 0, function() {
    var sanitizedOptions, backOff2;
    return __generator(this, function(_a) {
      switch (_a.label) {
        case 0:
          sanitizedOptions = options_1.getSanitizedOptions(options2);
          backOff2 = new BackOff(request, sanitizedOptions);
          return [4, backOff2.execute()];
        case 1:
          return [2, _a.sent()];
      }
    });
  });
}
var backOff_1 = backoff.backOff = backOff;
var BackOff = function() {
  function BackOff2(request, options2) {
    this.request = request;
    this.options = options2;
    this.attemptNumber = 0;
  }
  BackOff2.prototype.execute = function() {
    return __awaiter(this, void 0, void 0, function() {
      var e_1, shouldRetry2;
      return __generator(this, function(_a) {
        switch (_a.label) {
          case 0:
            if (!!this.attemptLimitReached)
              return [3, 7];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4, , 6]);
            return [4, this.applyDelay()];
          case 2:
            _a.sent();
            return [4, this.request()];
          case 3:
            return [2, _a.sent()];
          case 4:
            e_1 = _a.sent();
            this.attemptNumber++;
            return [4, this.options.retry(e_1, this.attemptNumber)];
          case 5:
            shouldRetry2 = _a.sent();
            if (!shouldRetry2 || this.attemptLimitReached) {
              throw e_1;
            }
            return [3, 6];
          case 6:
            return [3, 0];
          case 7:
            throw new Error("Something went wrong.");
        }
      });
    });
  };
  Object.defineProperty(BackOff2.prototype, "attemptLimitReached", {
    get: function() {
      return this.attemptNumber >= this.options.numOfAttempts;
    },
    enumerable: true,
    configurable: true
  });
  BackOff2.prototype.applyDelay = function() {
    return __awaiter(this, void 0, void 0, function() {
      var delay;
      return __generator(this, function(_a) {
        switch (_a.label) {
          case 0:
            delay = delay_factory_1.DelayFactory(this.options, this.attemptNumber);
            return [4, delay.apply()];
          case 1:
            _a.sent();
            return [2];
        }
      });
    });
  };
  return BackOff2;
}();
var browserPonyfill = { exports: {} };
(function(module, exports) {
  var global2 = typeof self !== "undefined" ? self : commonjsGlobal;
  var __self__ = function() {
    function F2() {
      this.fetch = false;
      this.DOMException = global2.DOMException;
    }
    F2.prototype = global2;
    return new F2();
  }();
  (function(self2) {
    (function(exports2) {
      var support = {
        searchParams: "URLSearchParams" in self2,
        iterable: "Symbol" in self2 && "iterator" in Symbol,
        blob: "FileReader" in self2 && "Blob" in self2 && function() {
          try {
            new Blob();
            return true;
          } catch (e) {
            return false;
          }
        }(),
        formData: "FormData" in self2,
        arrayBuffer: "ArrayBuffer" in self2
      };
      function isDataView(obj) {
        return obj && DataView.prototype.isPrototypeOf(obj);
      }
      if (support.arrayBuffer) {
        var viewClasses = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ];
        var isArrayBufferView = ArrayBuffer.isView || function(obj) {
          return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
      }
      function normalizeName(name) {
        if (typeof name !== "string") {
          name = String(name);
        }
        if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
          throw new TypeError("Invalid character in header field name");
        }
        return name.toLowerCase();
      }
      function normalizeValue(value) {
        if (typeof value !== "string") {
          value = String(value);
        }
        return value;
      }
      function iteratorFor(items) {
        var iterator = {
          next: function() {
            var value = items.shift();
            return { done: value === void 0, value };
          }
        };
        if (support.iterable) {
          iterator[Symbol.iterator] = function() {
            return iterator;
          };
        }
        return iterator;
      }
      function Headers(headers) {
        this.map = {};
        if (headers instanceof Headers) {
          headers.forEach(function(value, name) {
            this.append(name, value);
          }, this);
        } else if (Array.isArray(headers)) {
          headers.forEach(function(header) {
            this.append(header[0], header[1]);
          }, this);
        } else if (headers) {
          Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
          }, this);
        }
      }
      Headers.prototype.append = function(name, value) {
        name = normalizeName(name);
        value = normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ", " + value : value;
      };
      Headers.prototype["delete"] = function(name) {
        delete this.map[normalizeName(name)];
      };
      Headers.prototype.get = function(name) {
        name = normalizeName(name);
        return this.has(name) ? this.map[name] : null;
      };
      Headers.prototype.has = function(name) {
        return this.map.hasOwnProperty(normalizeName(name));
      };
      Headers.prototype.set = function(name, value) {
        this.map[normalizeName(name)] = normalizeValue(value);
      };
      Headers.prototype.forEach = function(callback, thisArg) {
        for (var name in this.map) {
          if (this.map.hasOwnProperty(name)) {
            callback.call(thisArg, this.map[name], name, this);
          }
        }
      };
      Headers.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
          items.push(name);
        });
        return iteratorFor(items);
      };
      Headers.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
          items.push(value);
        });
        return iteratorFor(items);
      };
      Headers.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
          items.push([name, value]);
        });
        return iteratorFor(items);
      };
      if (support.iterable) {
        Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
      }
      function consumed(body) {
        if (body.bodyUsed) {
          return Promise.reject(new TypeError("Already read"));
        }
        body.bodyUsed = true;
      }
      function fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
          reader.onload = function() {
            resolve(reader.result);
          };
          reader.onerror = function() {
            reject(reader.error);
          };
        });
      }
      function readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
      }
      function readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsText(blob);
        return promise;
      }
      function readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);
        for (var i2 = 0; i2 < view.length; i2++) {
          chars[i2] = String.fromCharCode(view[i2]);
        }
        return chars.join("");
      }
      function bufferClone(buf) {
        if (buf.slice) {
          return buf.slice(0);
        } else {
          var view = new Uint8Array(buf.byteLength);
          view.set(new Uint8Array(buf));
          return view.buffer;
        }
      }
      function Body() {
        this.bodyUsed = false;
        this._initBody = function(body) {
          this._bodyInit = body;
          if (!body) {
            this._bodyText = "";
          } else if (typeof body === "string") {
            this._bodyText = body;
          } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
            this._bodyBlob = body;
          } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
            this._bodyFormData = body;
          } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
            this._bodyText = body.toString();
          } else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            this._bodyInit = new Blob([this._bodyArrayBuffer]);
          } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
            this._bodyArrayBuffer = bufferClone(body);
          } else {
            this._bodyText = body = Object.prototype.toString.call(body);
          }
          if (!this.headers.get("content-type")) {
            if (typeof body === "string") {
              this.headers.set("content-type", "text/plain;charset=UTF-8");
            } else if (this._bodyBlob && this._bodyBlob.type) {
              this.headers.set("content-type", this._bodyBlob.type);
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
            }
          }
        };
        if (support.blob) {
          this.blob = function() {
            var rejected = consumed(this);
            if (rejected) {
              return rejected;
            }
            if (this._bodyBlob) {
              return Promise.resolve(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            } else if (this._bodyFormData) {
              throw new Error("could not read FormData body as blob");
            } else {
              return Promise.resolve(new Blob([this._bodyText]));
            }
          };
          this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
            } else {
              return this.blob().then(readBlobAsArrayBuffer);
            }
          };
        }
        this.text = function() {
          var rejected = consumed(this);
          if (rejected) {
            return rejected;
          }
          if (this._bodyBlob) {
            return readBlobAsText(this._bodyBlob);
          } else if (this._bodyArrayBuffer) {
            return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
          } else if (this._bodyFormData) {
            throw new Error("could not read FormData body as text");
          } else {
            return Promise.resolve(this._bodyText);
          }
        };
        if (support.formData) {
          this.formData = function() {
            return this.text().then(decode);
          };
        }
        this.json = function() {
          return this.text().then(JSON.parse);
        };
        return this;
      }
      var methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return methods.indexOf(upcased) > -1 ? upcased : method;
      }
      function Request(input, options2) {
        options2 = options2 || {};
        var body = options2.body;
        if (input instanceof Request) {
          if (input.bodyUsed) {
            throw new TypeError("Already read");
          }
          this.url = input.url;
          this.credentials = input.credentials;
          if (!options2.headers) {
            this.headers = new Headers(input.headers);
          }
          this.method = input.method;
          this.mode = input.mode;
          this.signal = input.signal;
          if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
          }
        } else {
          this.url = String(input);
        }
        this.credentials = options2.credentials || this.credentials || "same-origin";
        if (options2.headers || !this.headers) {
          this.headers = new Headers(options2.headers);
        }
        this.method = normalizeMethod(options2.method || this.method || "GET");
        this.mode = options2.mode || this.mode || null;
        this.signal = options2.signal || this.signal;
        this.referrer = null;
        if ((this.method === "GET" || this.method === "HEAD") && body) {
          throw new TypeError("Body not allowed for GET or HEAD requests");
        }
        this._initBody(body);
      }
      Request.prototype.clone = function() {
        return new Request(this, { body: this._bodyInit });
      };
      function decode(body) {
        var form = new FormData();
        body.trim().split("&").forEach(function(bytes) {
          if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
          }
        });
        return form;
      }
      function parseHeaders(rawHeaders) {
        var headers = new Headers();
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
        preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
          var parts = line.split(":");
          var key = parts.shift().trim();
          if (key) {
            var value = parts.join(":").trim();
            headers.append(key, value);
          }
        });
        return headers;
      }
      Body.call(Request.prototype);
      function Response(bodyInit, options2) {
        if (!options2) {
          options2 = {};
        }
        this.type = "default";
        this.status = options2.status === void 0 ? 200 : options2.status;
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = "statusText" in options2 ? options2.statusText : "OK";
        this.headers = new Headers(options2.headers);
        this.url = options2.url || "";
        this._initBody(bodyInit);
      }
      Body.call(Response.prototype);
      Response.prototype.clone = function() {
        return new Response(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Headers(this.headers),
          url: this.url
        });
      };
      Response.error = function() {
        var response = new Response(null, { status: 0, statusText: "" });
        response.type = "error";
        return response;
      };
      var redirectStatuses = [301, 302, 303, 307, 308];
      Response.redirect = function(url, status) {
        if (redirectStatuses.indexOf(status) === -1) {
          throw new RangeError("Invalid status code");
        }
        return new Response(null, { status, headers: { location: url } });
      };
      exports2.DOMException = self2.DOMException;
      try {
        new exports2.DOMException();
      } catch (err) {
        exports2.DOMException = function(message, name) {
          this.message = message;
          this.name = name;
          var error = Error(message);
          this.stack = error.stack;
        };
        exports2.DOMException.prototype = Object.create(Error.prototype);
        exports2.DOMException.prototype.constructor = exports2.DOMException;
      }
      function fetch2(input, init) {
        return new Promise(function(resolve, reject) {
          var request = new Request(input, init);
          if (request.signal && request.signal.aborted) {
            return reject(new exports2.DOMException("Aborted", "AbortError"));
          }
          var xhr = new XMLHttpRequest();
          function abortXhr() {
            xhr.abort();
          }
          xhr.onload = function() {
            var options2 = {
              status: xhr.status,
              statusText: xhr.statusText,
              headers: parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            options2.url = "responseURL" in xhr ? xhr.responseURL : options2.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            resolve(new Response(body, options2));
          };
          xhr.onerror = function() {
            reject(new TypeError("Network request failed"));
          };
          xhr.ontimeout = function() {
            reject(new TypeError("Network request failed"));
          };
          xhr.onabort = function() {
            reject(new exports2.DOMException("Aborted", "AbortError"));
          };
          xhr.open(request.method, request.url, true);
          if (request.credentials === "include") {
            xhr.withCredentials = true;
          } else if (request.credentials === "omit") {
            xhr.withCredentials = false;
          }
          if ("responseType" in xhr && support.blob) {
            xhr.responseType = "blob";
          }
          request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
          });
          if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
              if (xhr.readyState === 4) {
                request.signal.removeEventListener("abort", abortXhr);
              }
            };
          }
          xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
        });
      }
      fetch2.polyfill = true;
      if (!self2.fetch) {
        self2.fetch = fetch2;
        self2.Headers = Headers;
        self2.Request = Request;
        self2.Response = Response;
      }
      exports2.Headers = Headers;
      exports2.Request = Request;
      exports2.Response = Response;
      exports2.fetch = fetch2;
      Object.defineProperty(exports2, "__esModule", { value: true });
      return exports2;
    })({});
  })(__self__);
  __self__.fetch.ponyfill = true;
  delete __self__.fetch.polyfill;
  var ctx = __self__;
  exports = ctx.fetch;
  exports.default = ctx.fetch;
  exports.fetch = ctx.fetch;
  exports.Headers = ctx.Headers;
  exports.Request = ctx.Request;
  exports.Response = ctx.Response;
  module.exports = exports;
})(browserPonyfill, browserPonyfill.exports);
var fetch$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserPonyfill.exports);
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);
  if (!booleanCondition) {
    throw new Error(message);
  }
}
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
function inspect(value) {
  return formatValue(value, []);
}
function formatValue(value, seenValues) {
  switch (typeof value) {
    case "string":
      return JSON.stringify(value);
    case "function":
      return value.name ? `[function ${value.name}]` : "[function]";
    case "object":
      return formatObjectValue(value, seenValues);
    default:
      return String(value);
  }
}
function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return "null";
  }
  if (previouslySeenValues.includes(value)) {
    return "[Circular]";
  }
  const seenValues = [...previouslySeenValues, value];
  if (isJSONable(value)) {
    const jsonValue = value.toJSON();
    if (jsonValue !== value) {
      return typeof jsonValue === "string" ? jsonValue : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }
  return formatObject(value, seenValues);
}
function isJSONable(value) {
  return typeof value.toJSON === "function";
}
function formatObject(object, seenValues) {
  const entries = Object.entries(object);
  if (entries.length === 0) {
    return "{}";
  }
  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return "[" + getObjectTag(object) + "]";
  }
  const properties = entries.map(
    ([key, value]) => key + ": " + formatValue(value, seenValues)
  );
  return "{ " + properties.join(", ") + " }";
}
function formatArray(array, seenValues) {
  if (array.length === 0) {
    return "[]";
  }
  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return "[Array]";
  }
  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];
  for (let i2 = 0; i2 < len; ++i2) {
    items.push(formatValue(array[i2], seenValues));
  }
  if (remaining === 1) {
    items.push("... 1 more item");
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }
  return "[" + items.join(", ") + "]";
}
function getObjectTag(object) {
  const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
  if (tag === "Object" && typeof object.constructor === "function") {
    const name = object.constructor.name;
    if (typeof name === "string" && name !== "") {
      return name;
    }
  }
  return tag;
}
class Location {
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Token {
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = null;
    this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const QueryDocumentKeys = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
function isNode(maybeNode) {
  const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === "string" && kindValues.has(maybeKind);
}
var OperationTypeNode;
(function(OperationTypeNode2) {
  OperationTypeNode2["QUERY"] = "query";
  OperationTypeNode2["MUTATION"] = "mutation";
  OperationTypeNode2["SUBSCRIPTION"] = "subscription";
})(OperationTypeNode || (OperationTypeNode = {}));
var Kind;
(function(Kind2) {
  Kind2["NAME"] = "Name";
  Kind2["DOCUMENT"] = "Document";
  Kind2["OPERATION_DEFINITION"] = "OperationDefinition";
  Kind2["VARIABLE_DEFINITION"] = "VariableDefinition";
  Kind2["SELECTION_SET"] = "SelectionSet";
  Kind2["FIELD"] = "Field";
  Kind2["ARGUMENT"] = "Argument";
  Kind2["FRAGMENT_SPREAD"] = "FragmentSpread";
  Kind2["INLINE_FRAGMENT"] = "InlineFragment";
  Kind2["FRAGMENT_DEFINITION"] = "FragmentDefinition";
  Kind2["VARIABLE"] = "Variable";
  Kind2["INT"] = "IntValue";
  Kind2["FLOAT"] = "FloatValue";
  Kind2["STRING"] = "StringValue";
  Kind2["BOOLEAN"] = "BooleanValue";
  Kind2["NULL"] = "NullValue";
  Kind2["ENUM"] = "EnumValue";
  Kind2["LIST"] = "ListValue";
  Kind2["OBJECT"] = "ObjectValue";
  Kind2["OBJECT_FIELD"] = "ObjectField";
  Kind2["DIRECTIVE"] = "Directive";
  Kind2["NAMED_TYPE"] = "NamedType";
  Kind2["LIST_TYPE"] = "ListType";
  Kind2["NON_NULL_TYPE"] = "NonNullType";
  Kind2["SCHEMA_DEFINITION"] = "SchemaDefinition";
  Kind2["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
  Kind2["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
  Kind2["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
  Kind2["FIELD_DEFINITION"] = "FieldDefinition";
  Kind2["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
  Kind2["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
  Kind2["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
  Kind2["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
  Kind2["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
  Kind2["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
  Kind2["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
  Kind2["SCHEMA_EXTENSION"] = "SchemaExtension";
  Kind2["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
  Kind2["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
  Kind2["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
  Kind2["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
  Kind2["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
  Kind2["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})(Kind || (Kind = {}));
const BREAK = Object.freeze({});
function visit(root, visitor, visitorKeys = QueryDocumentKeys) {
  const enterLeaveMap = /* @__PURE__ */ new Map();
  for (const kind of Object.values(Kind)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  let stack = void 0;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = void 0;
  let parent = void 0;
  const path = [];
  const ancestors = [];
  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;
    if (isLeaving) {
      key = ancestors.length === 0 ? void 0 : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();
      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;
          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;
            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node)
          );
          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }
      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];
      if (node === null || node === void 0) {
        continue;
      }
      path.push(key);
    }
    let result;
    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;
      isNode(node) || devAssert(false, `Invalid AST Node: ${inspect(node)}.`);
      const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
      result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
      if (result === BREAK) {
        break;
      }
      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== void 0) {
        edits.push([key, result]);
        if (!isLeaving) {
          if (isNode(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }
    if (result === void 0 && isEdited) {
      edits.push([key, node]);
    }
    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;
      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
      index = -1;
      edits = [];
      if (parent) {
        ancestors.push(parent);
      }
      parent = node;
    }
  } while (stack !== void 0);
  if (edits.length !== 0) {
    return edits[edits.length - 1][1];
  }
  return root;
}
function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];
  if (typeof kindVisitor === "object") {
    return kindVisitor;
  } else if (typeof kindVisitor === "function") {
    return {
      enter: kindVisitor,
      leave: void 0
    };
  }
  return {
    enter: visitor.enter,
    leave: visitor.leave
  };
}
function isWhiteSpace(code) {
  return code === 9 || code === 32;
}
function isDigit(code) {
  return code >= 48 && code <= 57;
}
function isLetter(code) {
  return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}
function isNameStart(code) {
  return isLetter(code) || code === 95;
}
function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 95;
}
function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;
  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;
  for (let i2 = 0; i2 < lines.length; ++i2) {
    var _firstNonEmptyLine;
    const line = lines[i2];
    const indent2 = leadingWhitespace(line);
    if (indent2 === line.length) {
      continue;
    }
    firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i2;
    lastNonEmptyLine = i2;
    if (i2 !== 0 && indent2 < commonIndent) {
      commonIndent = indent2;
    }
  }
  return lines.map((line, i2) => i2 === 0 ? line : line.slice(commonIndent)).slice(
    (_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0,
    lastNonEmptyLine + 1
  );
}
function leadingWhitespace(str) {
  let i2 = 0;
  while (i2 < str.length && isWhiteSpace(str.charCodeAt(i2))) {
    ++i2;
  }
  return i2;
}
function printBlockString(value, options2) {
  const escapedValue = value.replace(/"""/g, '\\"""');
  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1;
  const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line) => line.length === 0 || isWhiteSpace(line.charCodeAt(0)));
  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""');
  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith("\\");
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines = !(options2 !== null && options2 !== void 0 && options2.minimize) && (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
  let result = "";
  const skipLeadingNewLine = isSingleLine && isWhiteSpace(value.charCodeAt(0));
  if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) {
    result += "\n";
  }
  result += escapedValue;
  if (printAsMultipleLines || forceTrailingNewline) {
    result += "\n";
  }
  return '"""' + result + '"""';
}
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
}
const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
}
const escapeSequences = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
];
function print(ast) {
  return visit(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value
  },
  Variable: {
    leave: (node) => "$" + node.name
  },
  Document: {
    leave: (node) => join(node.definitions, "\n\n")
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap("(", join(node.variableDefinitions, ", "), ")");
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, " ")
        ],
        " "
      );
      return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) => variable + ": " + type + wrap(" = ", defaultValue) + wrap(" ", join(directives, " "))
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections)
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap("", alias, ": ") + name;
      let argsLine = prefix + wrap("(", join(args, ", "), ")");
      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap("(\n", indent(join(args, "\n")), "\n)");
      }
      return join([argsLine, join(directives, " "), selectionSet], " ");
    }
  },
  Argument: {
    leave: ({ name, value }) => name + ": " + value
  },
  FragmentSpread: {
    leave: ({ name, directives }) => "..." + name + wrap(" ", join(directives, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) => join(
      [
        "...",
        wrap("on ", typeCondition),
        join(directives, " "),
        selectionSet
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name, typeCondition, variableDefinitions, directives, selectionSet }) => `fragment ${name}${wrap("(", join(variableDefinitions, ", "), ")")} on ${typeCondition} ${wrap("", join(directives, " "), " ")}` + selectionSet
  },
  IntValue: {
    leave: ({ value }) => value
  },
  FloatValue: {
    leave: ({ value }) => value
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) => isBlockString ? printBlockString(value) : printString(value)
  },
  BooleanValue: {
    leave: ({ value }) => value ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value }) => value
  },
  ListValue: {
    leave: ({ values }) => "[" + join(values, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields }) => "{" + join(fields, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name, value }) => name + ": " + value
  },
  Directive: {
    leave: ({ name, arguments: args }) => "@" + name + wrap("(", join(args, ", "), ")")
  },
  NamedType: {
    leave: ({ name }) => name
  },
  ListType: {
    leave: ({ type }) => "[" + type + "]"
  },
  NonNullType: {
    leave: ({ type }) => type + "!"
  },
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) => wrap("", description, "\n") + join(["schema", join(directives, " "), block(operationTypes)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ": " + type
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) => wrap("", description, "\n") + join(["scalar", name, join(directives, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) => wrap("", description, "\n") + join(
      [
        "type",
        name,
        wrap("implements ", join(interfaces, " & ")),
        join(directives, " "),
        block(fields)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) => wrap("", description, "\n") + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + ": " + type + wrap(" ", join(directives, " "))
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) => wrap("", description, "\n") + join(
      [name + ": " + type, wrap("= ", defaultValue), join(directives, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) => wrap("", description, "\n") + join(
      [
        "interface",
        name,
        wrap("implements ", join(interfaces, " & ")),
        join(directives, " "),
        block(fields)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) => wrap("", description, "\n") + join(
      ["union", name, join(directives, " "), wrap("= ", join(types, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) => wrap("", description, "\n") + join(["enum", name, join(directives, " "), block(values)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) => wrap("", description, "\n") + join([name, join(directives, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) => wrap("", description, "\n") + join(["input", name, join(directives, " "), block(fields)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) => wrap("", description, "\n") + "directive @" + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + join(locations, " | ")
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) => join(
      ["extend schema", join(directives, " "), block(operationTypes)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) => join(["extend scalar", name, join(directives, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) => join(
      [
        "extend type",
        name,
        wrap("implements ", join(interfaces, " & ")),
        join(directives, " "),
        block(fields)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) => join(
      [
        "extend interface",
        name,
        wrap("implements ", join(interfaces, " & ")),
        join(directives, " "),
        block(fields)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) => join(
      [
        "extend union",
        name,
        join(directives, " "),
        wrap("= ", join(types, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) => join(["extend enum", name, join(directives, " "), block(values)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) => join(["extend input", name, join(directives, " "), block(fields)], " ")
  }
};
function join(maybeArray, separator = "") {
  var _maybeArray$filter$jo;
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x) => x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
function block(array) {
  return wrap("{\n", indent(join(array, "\n")), "\n}");
}
function wrap(start, maybeString, end = "") {
  return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function indent(str) {
  return wrap("  ", str.replace(/\n/g, "\n  "));
}
function hasMultilineItems(maybeArray) {
  var _maybeArray$some;
  return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str) => str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}
function isObjectLike(value) {
  return typeof value == "object" && value !== null;
}
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);
  if (!booleanCondition) {
    throw new Error(
      message != null ? message : "Unexpected invariant triggered."
    );
  }
}
const LineRegExp = /\r\n|[\n\r]/g;
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;
  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === "number" || invariant(false);
    if (match.index >= position) {
      break;
    }
    lastLineStart = match.index + match[0].length;
    line += 1;
  }
  return {
    line,
    column: position + 1 - lastLineStart
  };
}
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start)
  );
}
function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = "".padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}
`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex];
  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];
    for (let i2 = 0; i2 < locationLine.length; i2 += 80) {
      subLines.push(locationLine.slice(i2, i2 + 80));
    }
    return locationStr + printPrefixedLines([
      [`${lineNum} |`, subLines[0]],
      ...subLines.slice(1, subLineIndex + 1).map((subLine) => ["|", subLine]),
      ["|", "^".padStart(subLineColumnNum)],
      ["|", subLines[subLineIndex + 1]]
    ]);
  }
  return locationStr + printPrefixedLines([
    [`${lineNum - 1} |`, lines[lineIndex - 1]],
    [`${lineNum} |`, locationLine],
    ["|", "^".padStart(columnNum)],
    [`${lineNum + 1} |`, lines[lineIndex + 1]]
  ]);
}
function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== void 0);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines.map(([prefix, line]) => prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}
function toNormalizedOptions(args) {
  const firstArg = args[0];
  if (firstArg == null || "kind" in firstArg || "length" in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5]
    };
  }
  return firstArg;
}
class GraphQLError extends Error {
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;
    const { nodes, source, positions, path, originalError, extensions } = toNormalizedOptions(rawArgs);
    super(message);
    this.name = "GraphQLError";
    this.path = path !== null && path !== void 0 ? path : void 0;
    this.originalError = originalError !== null && originalError !== void 0 ? originalError : void 0;
    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : void 0
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node) => node.loc).filter((loc) => loc != null)
    );
    this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
    this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc) => loc.start);
    this.locations = positions && source ? positions.map((pos) => getLocation(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0 ? void 0 : originalError.extensions
    ) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : void 0;
    this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : /* @__PURE__ */ Object.create(null);
    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    });
    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(this, "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let output = this.message;
    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += "\n\n" + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += "\n\n" + printSourceLocation(this.source, location);
      }
    }
    return output;
  }
  toJSON() {
    const formattedError = {
      message: this.message
    };
    if (this.locations != null) {
      formattedError.locations = this.locations;
    }
    if (this.path != null) {
      formattedError.path = this.path;
    }
    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }
    return formattedError;
  }
}
function undefinedIfEmpty(array) {
  return array === void 0 || array.length === 0 ? void 0 : array;
}
function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position]
  });
}
var DirectiveLocation;
(function(DirectiveLocation2) {
  DirectiveLocation2["QUERY"] = "QUERY";
  DirectiveLocation2["MUTATION"] = "MUTATION";
  DirectiveLocation2["SUBSCRIPTION"] = "SUBSCRIPTION";
  DirectiveLocation2["FIELD"] = "FIELD";
  DirectiveLocation2["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
  DirectiveLocation2["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
  DirectiveLocation2["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
  DirectiveLocation2["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
  DirectiveLocation2["SCHEMA"] = "SCHEMA";
  DirectiveLocation2["SCALAR"] = "SCALAR";
  DirectiveLocation2["OBJECT"] = "OBJECT";
  DirectiveLocation2["FIELD_DEFINITION"] = "FIELD_DEFINITION";
  DirectiveLocation2["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
  DirectiveLocation2["INTERFACE"] = "INTERFACE";
  DirectiveLocation2["UNION"] = "UNION";
  DirectiveLocation2["ENUM"] = "ENUM";
  DirectiveLocation2["ENUM_VALUE"] = "ENUM_VALUE";
  DirectiveLocation2["INPUT_OBJECT"] = "INPUT_OBJECT";
  DirectiveLocation2["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})(DirectiveLocation || (DirectiveLocation = {}));
var TokenKind;
(function(TokenKind2) {
  TokenKind2["SOF"] = "<SOF>";
  TokenKind2["EOF"] = "<EOF>";
  TokenKind2["BANG"] = "!";
  TokenKind2["DOLLAR"] = "$";
  TokenKind2["AMP"] = "&";
  TokenKind2["PAREN_L"] = "(";
  TokenKind2["PAREN_R"] = ")";
  TokenKind2["SPREAD"] = "...";
  TokenKind2["COLON"] = ":";
  TokenKind2["EQUALS"] = "=";
  TokenKind2["AT"] = "@";
  TokenKind2["BRACKET_L"] = "[";
  TokenKind2["BRACKET_R"] = "]";
  TokenKind2["BRACE_L"] = "{";
  TokenKind2["PIPE"] = "|";
  TokenKind2["BRACE_R"] = "}";
  TokenKind2["NAME"] = "Name";
  TokenKind2["INT"] = "Int";
  TokenKind2["FLOAT"] = "Float";
  TokenKind2["STRING"] = "String";
  TokenKind2["BLOCK_STRING"] = "BlockString";
  TokenKind2["COMMENT"] = "Comment";
})(TokenKind || (TokenKind = {}));
class Lexer {
  constructor(source) {
    const startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  advance() {
    this.lastToken = this.token;
    const token = this.token = this.lookahead();
    return token;
  }
  lookahead() {
    let token = this.token;
    if (token.kind !== TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          const nextToken = readNextToken(this, token.end);
          token.next = nextToken;
          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === TokenKind.COMMENT);
    }
    return token;
  }
}
function isPunctuatorTokenKind(kind) {
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}
function isUnicodeScalarValue(code) {
  return code >= 0 && code <= 55295 || code >= 57344 && code <= 1114111;
}
function isSupplementaryCodePoint(body, location) {
  return isLeadingSurrogate(body.charCodeAt(location)) && isTrailingSurrogate(body.charCodeAt(location + 1));
}
function isLeadingSurrogate(code) {
  return code >= 55296 && code <= 56319;
}
function isTrailingSurrogate(code) {
  return code >= 56320 && code <= 57343;
}
function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);
  if (code === void 0) {
    return TokenKind.EOF;
  } else if (code >= 32 && code <= 126) {
    const char = String.fromCodePoint(code);
    return char === '"' ? `'"'` : `"${char}"`;
  }
  return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new Token(kind, start, end, line, col, value);
}
function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;
  while (position < bodyLength) {
    const code = body.charCodeAt(position);
    switch (code) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++position;
        continue;
      case 10:
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;
      case 13:
        if (body.charCodeAt(position + 1) === 10) {
          position += 2;
        } else {
          ++position;
        }
        ++lexer.line;
        lexer.lineStart = position;
        continue;
      case 35:
        return readComment(lexer, position);
      case 33:
        return createToken(lexer, TokenKind.BANG, position, position + 1);
      case 36:
        return createToken(lexer, TokenKind.DOLLAR, position, position + 1);
      case 38:
        return createToken(lexer, TokenKind.AMP, position, position + 1);
      case 40:
        return createToken(lexer, TokenKind.PAREN_L, position, position + 1);
      case 41:
        return createToken(lexer, TokenKind.PAREN_R, position, position + 1);
      case 46:
        if (body.charCodeAt(position + 1) === 46 && body.charCodeAt(position + 2) === 46) {
          return createToken(lexer, TokenKind.SPREAD, position, position + 3);
        }
        break;
      case 58:
        return createToken(lexer, TokenKind.COLON, position, position + 1);
      case 61:
        return createToken(lexer, TokenKind.EQUALS, position, position + 1);
      case 64:
        return createToken(lexer, TokenKind.AT, position, position + 1);
      case 91:
        return createToken(lexer, TokenKind.BRACKET_L, position, position + 1);
      case 93:
        return createToken(lexer, TokenKind.BRACKET_R, position, position + 1);
      case 123:
        return createToken(lexer, TokenKind.BRACE_L, position, position + 1);
      case 124:
        return createToken(lexer, TokenKind.PIPE, position, position + 1);
      case 125:
        return createToken(lexer, TokenKind.BRACE_R, position, position + 1);
      case 34:
        if (body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
          return readBlockString(lexer, position);
        }
        return readString(lexer, position);
    }
    if (isDigit(code) || code === 45) {
      return readNumber(lexer, position, code);
    }
    if (isNameStart(code)) {
      return readName(lexer, position);
    }
    throw syntaxError(
      lexer.source,
      position,
      code === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position) ? `Unexpected character: ${printCodePointAt(lexer, position)}.` : `Invalid character: ${printCodePointAt(lexer, position)}.`
    );
  }
  return createToken(lexer, TokenKind.EOF, bodyLength, bodyLength);
}
function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  while (position < bodyLength) {
    const code = body.charCodeAt(position);
    if (code === 10 || code === 13) {
      break;
    }
    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }
  return createToken(
    lexer,
    TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position)
  );
}
function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false;
  if (code === 45) {
    code = body.charCodeAt(++position);
  }
  if (code === 48) {
    code = body.charCodeAt(++position);
    if (isDigit(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position
        )}.`
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  }
  if (code === 46) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  }
  if (code === 69 || code === 101) {
    isFloat = true;
    code = body.charCodeAt(++position);
    if (code === 43 || code === 45) {
      code = body.charCodeAt(++position);
    }
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  }
  if (code === 46 || isNameStart(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position
      )}.`
    );
  }
  return createToken(
    lexer,
    isFloat ? TokenKind.FLOAT : TokenKind.INT,
    start,
    position,
    body.slice(start, position)
  );
}
function readDigits(lexer, start, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start
      )}.`
    );
  }
  const body = lexer.source.body;
  let position = start + 1;
  while (isDigit(body.charCodeAt(position))) {
    ++position;
  }
  return position;
}
function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = "";
  while (position < bodyLength) {
    const code = body.charCodeAt(position);
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, TokenKind.STRING, start, position + 1, value);
    }
    if (code === 92) {
      value += body.slice(chunkStart, position);
      const escape = body.charCodeAt(position + 1) === 117 ? body.charCodeAt(position + 2) === 123 ? readEscapedUnicodeVariableWidth(lexer, position) : readEscapedUnicodeFixedWidth(lexer, position) : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    }
    if (code === 10 || code === 13) {
      break;
    }
    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position
        )}.`
      );
    }
  }
  throw syntaxError(lexer.source, position, "Unterminated string.");
}
function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3;
  while (size < 12) {
    const code = body.charCodeAt(position + size++);
    if (code === 125) {
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }
      return {
        value: String.fromCodePoint(point),
        size
      };
    }
    point = point << 4 | readHexDigit(code);
    if (point < 0) {
      break;
    }
  }
  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size
    )}".`
  );
}
function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);
  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6
    };
  }
  if (isLeadingSurrogate(code)) {
    if (body.charCodeAt(position + 6) === 92 && body.charCodeAt(position + 7) === 117) {
      const trailingCode = read16BitHexCode(body, position + 8);
      if (isTrailingSurrogate(trailingCode)) {
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12
        };
      }
    }
  }
  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`
  );
}
function read16BitHexCode(body, position) {
  return readHexDigit(body.charCodeAt(position)) << 12 | readHexDigit(body.charCodeAt(position + 1)) << 8 | readHexDigit(body.charCodeAt(position + 2)) << 4 | readHexDigit(body.charCodeAt(position + 3));
}
function readHexDigit(code) {
  return code >= 48 && code <= 57 ? code - 48 : code >= 65 && code <= 70 ? code - 55 : code >= 97 && code <= 102 ? code - 87 : -1;
}
function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);
  switch (code) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: "\n",
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2
    )}".`
  );
}
function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = "";
  const blockLines = [];
  while (position < bodyLength) {
    const code = body.charCodeAt(position);
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        TokenKind.BLOCK_STRING,
        start,
        position + 3,
        dedentBlockStringLines(blockLines).join("\n")
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    }
    if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1;
      position += 4;
      continue;
    }
    if (code === 10 || code === 13) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      if (code === 13 && body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }
      currentLine = "";
      chunkStart = position;
      lineStart = position;
      continue;
    }
    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position
        )}.`
      );
    }
  }
  throw syntaxError(lexer.source, position, "Unterminated string.");
}
function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  while (position < bodyLength) {
    const code = body.charCodeAt(position);
    if (isNameContinue(code)) {
      ++position;
    } else {
      break;
    }
  }
  return createToken(
    lexer,
    TokenKind.NAME,
    start,
    position,
    body.slice(start, position)
  );
}
const instanceOf = function instanceOf2(value, constructor) {
  return value instanceof constructor;
};
class Source {
  constructor(body, name = "GraphQL request", locationOffset = {
    line: 1,
    column: 1
  }) {
    typeof body === "string" || devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(
      false,
      "line in locationOffset is 1-indexed and must be positive."
    );
    this.locationOffset.column > 0 || devAssert(
      false,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function isSource(source) {
  return instanceOf(source, Source);
}
function parse(source, options2) {
  const parser = new Parser(source, options2);
  return parser.parseDocument();
}
class Parser {
  constructor(source, options2 = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options2;
    this._tokenCounter = 0;
  }
  parseName() {
    const token = this.expectToken(TokenKind.NAME);
    return this.node(token, {
      kind: Kind.NAME,
      value: token.value
    });
  }
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Kind.DOCUMENT,
      definitions: this.many(
        TokenKind.SOF,
        this.parseDefinition,
        TokenKind.EOF
      )
    });
  }
  parseDefinition() {
    if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    }
    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      }
      switch (keywordToken.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(keywordToken);
  }
  parseOperationDefinition() {
    const start = this._lexer.token;
    if (this.peek(TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    }
    const operation = this.parseOperationType();
    let name;
    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }
    return this.node(start, {
      kind: Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseOperationType() {
    const operationToken = this.expectToken(TokenKind.NAME);
    switch (operationToken.value) {
      case "query":
        return OperationTypeNode.QUERY;
      case "mutation":
        return OperationTypeNode.MUTATION;
      case "subscription":
        return OperationTypeNode.SUBSCRIPTION;
    }
    throw this.unexpected(operationToken);
  }
  parseVariableDefinitions() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseVariableDefinition,
      TokenKind.PAREN_R
    );
  }
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return this.node(start, {
      kind: Kind.VARIABLE,
      name: this.parseName()
    });
  }
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Kind.SELECTION_SET,
      selections: this.many(
        TokenKind.BRACE_L,
        this.parseSelection,
        TokenKind.BRACE_R
      )
    });
  }
  parseSelection() {
    return this.peek(TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;
    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }
    return this.node(start, {
      kind: Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst)
    });
  }
  parseConstArgument() {
    return this.parseArgument(true);
  }
  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword("on");
    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return this.node(start, {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false)
      });
    }
    return this.node(start, {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword("fragment");
    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet()
      });
    }
    return this.node(start, {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseFragmentName() {
    if (this._lexer.token.value === "on") {
      throw this.unexpected();
    }
    return this.parseName();
  }
  parseValueLiteral(isConst) {
    const token = this._lexer.token;
    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);
      case TokenKind.BRACE_L:
        return this.parseObject(isConst);
      case TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.INT,
          value: token.value
        });
      case TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.FLOAT,
          value: token.value
        });
      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();
      case TokenKind.NAME:
        this.advanceLexer();
        switch (token.value) {
          case "true":
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: true
            });
          case "false":
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: false
            });
          case "null":
            return this.node(token, {
              kind: Kind.NULL
            });
          default:
            return this.node(token, {
              kind: Kind.ENUM,
              value: token.value
            });
        }
      case TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(TokenKind.DOLLAR);
          if (this._lexer.token.kind === TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`
            );
          } else {
            throw this.unexpected(token);
          }
        }
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }
  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING
    });
  }
  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);
    return this.node(this._lexer.token, {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R)
    });
  }
  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);
    return this.node(this._lexer.token, {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R)
    });
  }
  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst)
    });
  }
  parseDirectives(isConst) {
    const directives = [];
    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }
    return directives;
  }
  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return this.node(start, {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst)
    });
  }
  parseTypeReference() {
    const start = this._lexer.token;
    let type;
    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: Kind.LIST_TYPE,
        type: innerType
      });
    } else {
      type = this.parseNamedType();
    }
    if (this.expectOptionalToken(TokenKind.BANG)) {
      return this.node(start, {
        kind: Kind.NON_NULL_TYPE,
        type
      });
    }
    return type;
  }
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Kind.NAMED_TYPE,
      name: this.parseName()
    });
  }
  peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("schema");
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R
    );
    return this.node(start, {
      kind: Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes
    });
  }
  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type
    });
  }
  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("scalar");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives
    });
  }
  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("type");
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields
    });
  }
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(TokenKind.AMP, this.parseNamedType) : [];
  }
  parseFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseFieldDefinition,
      TokenKind.BRACE_R
    );
  }
  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives
    });
  }
  parseArgumentDefs() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseInputValueDef,
      TokenKind.PAREN_R
    );
  }
  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;
    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives
    });
  }
  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("interface");
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields
    });
  }
  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("union");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types
    });
  }
  parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS) ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType) : [];
  }
  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("enum");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values
    });
  }
  parseEnumValuesDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      TokenKind.BRACE_R
    );
  }
  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives
    });
  }
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    }
    return this.parseName();
  }
  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("input");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields
    });
  }
  parseInputFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseInputValueDef,
      TokenKind.BRACE_R
    );
  }
  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();
    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    }
    throw this.unexpected(keywordToken);
  }
  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("schema");
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R
    );
    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }
    return this.node(start, {
      kind: Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes
    });
  }
  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("scalar");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    if (directives.length === 0) {
      throw this.unexpected();
    }
    return this.node(start, {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives
    });
  }
  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("type");
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return this.node(start, {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields
    });
  }
  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("interface");
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields
    });
  }
  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("union");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }
    return this.node(start, {
      kind: Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types
    });
  }
  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("enum");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }
    return this.node(start, {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values
    });
  }
  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("input");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields
    });
  }
  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("directive");
    this.expectToken(TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations
    });
  }
  parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();
    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }
    throw this.unexpected(start);
  }
  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new Location(
        startToken,
        this._lexer.lastToken,
        this._lexer.source
      );
    }
    return node;
  }
  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  expectToken(kind) {
    const token = this._lexer.token;
    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }
    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`
    );
  }
  expectOptionalToken(kind) {
    const token = this._lexer.token;
    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }
    return false;
  }
  expectKeyword(value) {
    const token = this._lexer.token;
    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`
      );
    }
  }
  expectOptionalKeyword(value) {
    const token = this._lexer.token;
    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }
    return false;
  }
  unexpected(atToken) {
    const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`
    );
  }
  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];
    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }
    return nodes;
  }
  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];
      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));
      return nodes;
    }
    return [];
  }
  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];
    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));
    return nodes;
  }
  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];
    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));
    return nodes;
  }
  advanceLexer() {
    const { maxTokens } = this._options;
    const token = this._lexer.advance();
    if (maxTokens !== void 0 && token.kind !== TokenKind.EOF) {
      ++this._tokenCounter;
      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`
        );
      }
    }
  }
}
function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}
function l$1(a, b) {
  b.tag = a;
  return b;
}
function m() {
}
function p$1(a) {
  return function(b) {
    var c2 = a.length;
    let d2 = false, e = false, f2 = false, g = 0;
    b(
      l$1(0, [
        function(h2) {
          if (h2) {
            d2 = true;
          } else if (e) {
            f2 = true;
          } else {
            for (e = f2 = true; f2 && !d2; ) {
              g < c2 ? (h2 = a[g], g = g + 1 | 0, f2 = false, b(l$1(1, [h2]))) : (d2 = true, b(0));
            }
            e = false;
          }
        }
      ])
    );
  };
}
function r() {
}
function t(a) {
  a(0);
}
function C(a) {
  return a(0);
}
function D(a) {
  return function(b) {
    return function(c2) {
      let e = m, f2 = false, g = [], h2 = false;
      b(function(b2) {
        "number" == typeof b2 ? h2 || (h2 = true, 0 === g.length && c2(0)) : b2.tag ? h2 || (f2 = false, function(a2) {
          function b3(a3) {
            "number" == typeof a3 ? 0 !== g.length && (g = g.filter(d2), a3 = 0 === g.length, h2 && a3 ? c2(0) : !f2 && a3 && (f2 = true, e(0))) : a3.tag ? 0 !== g.length && (c2(l$1(1, [a3[0]])), k(0)) : (k = a3 = a3[0], g = g.concat(a3), a3(0));
          }
          function d2(a3) {
            return a3 !== k;
          }
          let k = m;
          1 === a2.length ? a2(b3) : a2.bind(null, b3);
        }(a(b2[0])), f2 || (f2 = true, e(0))) : e = b2[0];
      });
      c2(
        l$1(0, [
          function(a2) {
            a2 ? (h2 || (h2 = true, e(a2)), g.forEach(function(c3) {
              return c3(a2);
            }), g = []) : (f2 || h2 ? f2 = false : (f2 = true, e(0)), g.forEach(C));
          }
        ])
      );
    };
  };
}
function E(a) {
  return a;
}
function H(a) {
  return function(b) {
    return function(c2) {
      let d2 = false;
      return b(function(e) {
        if ("number" == typeof e) {
          d2 || (d2 = true, c2(e));
        } else if (e.tag) {
          d2 || (a(e[0]), c2(e));
        } else {
          var g = e[0];
          c2(
            l$1(0, [
              function(a2) {
                if (!d2) {
                  return a2 && (d2 = true), g(a2);
                }
              }
            ])
          );
        }
      });
    };
  };
}
function J$1(a) {
  a(0);
}
function K(a) {
  return function(b) {
    return function(c2) {
      function d2(a2) {
        h2 && ("number" == typeof a2 ? (h2 = false, n ? c2(a2) : f2 || (f2 = true, e(0))) : a2.tag ? (c2(a2), k ? k = false : g(0)) : (g = a2 = a2[0], k = false, a2(0)));
      }
      let e = m, f2 = false, g = m, h2 = false, k = false, n = false;
      b(function(b2) {
        "number" == typeof b2 ? n || (n = true, h2 || c2(0)) : b2.tag ? n || (h2 && (g(1), g = m), f2 ? f2 = false : (f2 = true, e(0)), b2 = a(b2[0]), h2 = true, b2(d2)) : e = b2[0];
      });
      c2(
        l$1(0, [
          function(a2) {
            if (a2) {
              if (n || (n = true, e(1)), h2) {
                return h2 = false, g(1);
              }
            } else {
              n || f2 || (f2 = true, e(0)), h2 && !k && (k = true, g(0));
            }
          }
        ])
      );
    };
  };
}
function N(a) {
  return function(b) {
    let c2 = m, d2 = false;
    b(function(e) {
      "number" == typeof e ? d2 = true : e.tag ? d2 || (a(e[0]), c2(0)) : (c2 = e = e[0], e(0));
    });
    return {
      unsubscribe: function() {
        if (!d2) {
          return d2 = true, c2(1);
        }
      }
    };
  };
}
function O() {
}
function filter$1(a) {
  return function(b) {
    return function(c2) {
      let d2 = m;
      return b(function(b2) {
        "number" == typeof b2 ? c2(b2) : b2.tag ? a(b2[0]) ? c2(b2) : d2(0) : (d2 = b2[0], c2(b2));
      });
    };
  };
}
function fromValue$1(a) {
  return function(b) {
    let c2 = false;
    b(
      l$1(0, [
        function(d2) {
          d2 ? c2 = true : c2 || (c2 = true, b(l$1(1, [a])), b(0));
        }
      ])
    );
  };
}
function make$1(a) {
  return function(b) {
    let c2 = r, d2 = false;
    c2 = a({
      next: function(a2) {
        d2 || b(l$1(1, [a2]));
      },
      complete: function() {
        d2 || (d2 = true, b(0));
      }
    });
    b(
      l$1(0, [
        function(a2) {
          if (a2 && !d2) {
            return d2 = true, c2();
          }
        }
      ])
    );
  };
}
function makeSubject$1() {
  let a = [], b = false;
  return {
    source: function(c2) {
      function b2(a2) {
        return a2 !== c2;
      }
      a = a.concat(c2);
      c2(
        l$1(0, [
          function(c3) {
            c3 && (a = a.filter(b2));
          }
        ])
      );
    },
    next: function(c2) {
      b || a.forEach(function(a2) {
        a2(l$1(1, [c2]));
      });
    },
    complete: function() {
      b || (b = true, a.forEach(t));
    }
  };
}
function map$1(a) {
  return function(b) {
    return function(c2) {
      return b(function(b2) {
        b2 = "number" == typeof b2 ? 0 : b2.tag ? l$1(1, [a(b2[0])]) : l$1(0, [b2[0]]);
        c2(b2);
      });
    };
  };
}
function merge$1(a) {
  return D(E)(p$1(a));
}
function onEnd$1(a) {
  return function(b) {
    return function(c2) {
      let d2 = false;
      return b(function(b2) {
        if ("number" == typeof b2) {
          if (d2) {
            return;
          }
          d2 = true;
          c2(b2);
          return a();
        }
        if (b2.tag) {
          d2 || c2(b2);
        } else {
          var e = b2[0];
          c2(
            l$1(0, [
              function(c3) {
                if (!d2) {
                  return c3 ? (d2 = true, e(c3), a()) : e(c3);
                }
              }
            ])
          );
        }
      });
    };
  };
}
function onStart$1(a) {
  return function(b) {
    return function(c2) {
      return b(function(b2) {
        "number" == typeof b2 ? c2(b2) : b2.tag ? c2(b2) : (c2(b2), a());
      });
    };
  };
}
function pipe() {
  for (var a = arguments, b = arguments[0], c2 = 1, d2 = arguments.length; c2 < d2; c2++) {
    b = a[c2](b);
  }
  return b;
}
function publish$1(a) {
  return N(O)(a);
}
function share$1(a) {
  function b(a2) {
    "number" == typeof a2 ? (c2.forEach(J$1), c2 = []) : a2.tag ? (e = false, c2.forEach(function(b2) {
      b2(a2);
    })) : d2 = a2[0];
  }
  let c2 = [], d2 = m, e = false;
  return function(f2) {
    function g(a2) {
      return a2 !== f2;
    }
    c2 = c2.concat(f2);
    1 === c2.length && a(b);
    f2(
      l$1(0, [
        function(a2) {
          if (a2) {
            if (c2 = c2.filter(g), 0 === c2.length) {
              return d2(1);
            }
          } else {
            e || (e = true, d2(a2));
          }
        }
      ])
    );
  };
}
function take$1(a) {
  return function(b) {
    return function(c2) {
      let d2 = false, e = 0, f2 = m;
      b(function(b2) {
        "number" == typeof b2 ? d2 || (d2 = true, c2(0)) : b2.tag ? e < a && !d2 && (e = e + 1 | 0, c2(b2), !d2 && e >= a && (d2 = true, c2(0), f2(1))) : (b2 = b2[0], 0 >= a ? (d2 = true, c2(0), b2(1)) : f2 = b2);
      });
      c2(
        l$1(0, [
          function(b2) {
            if (!d2) {
              if (b2) {
                return d2 = true, f2(1);
              }
              if (e < a) {
                return f2(0);
              }
            }
          }
        ])
      );
    };
  };
}
function takeUntil$1(a) {
  return function(b) {
    return function(c2) {
      function d2(a2) {
        "number" != typeof a2 && (a2.tag ? (e = true, f2(1), c2(0)) : (g = a2 = a2[0], a2(0)));
      }
      let e = false, f2 = m, g = m;
      b(function(b2) {
        "number" == typeof b2 ? e || (e = true, g(1), c2(0)) : b2.tag ? e || c2(b2) : (f2 = b2[0], a(d2));
      });
      c2(
        l$1(0, [
          function(a2) {
            if (!e) {
              return a2 ? (e = true, f2(1), g(1)) : f2(0);
            }
          }
        ])
      );
    };
  };
}
"function" == typeof Symbol ? Symbol.observable || (Symbol.observable = Symbol("observable")) : "@@observable";
function rehydrateGraphQlError(r2) {
  if ("string" == typeof r2) {
    return new GraphQLError(r2);
  } else if ("object" == typeof r2 && r2.message) {
    return new GraphQLError(r2.message, r2.nodes, r2.source, r2.positions, r2.path, r2, r2.extensions || {});
  } else {
    return r2;
  }
}
var o = function(e) {
  function CombinedError(r2) {
    var t2 = r2.networkError;
    var n = r2.response;
    var a = (r2.graphQLErrors || []).map(rehydrateGraphQlError);
    var o2 = function generateErrorMessage(e2, r3) {
      var t3 = "";
      if (void 0 !== e2) {
        return t3 = "[Network] " + e2.message;
      }
      if (void 0 !== r3) {
        r3.forEach(function(e3) {
          t3 += "[GraphQL] " + e3.message + "\n";
        });
      }
      return t3.trim();
    }(t2, a);
    e.call(this, o2);
    this.name = "CombinedError";
    this.message = o2;
    this.graphQLErrors = a;
    this.networkError = t2;
    this.response = n;
  }
  if (e) {
    CombinedError.__proto__ = e;
  }
  (CombinedError.prototype = Object.create(e && e.prototype)).constructor = CombinedError;
  CombinedError.prototype.toString = function toString() {
    return this.message;
  };
  return CombinedError;
}(Error);
function phash(e, r2) {
  e |= 0;
  for (var t2 = 0, n = 0 | r2.length; t2 < n; t2++) {
    e = (e << 5) + e + r2.charCodeAt(t2);
  }
  return e;
}
function hash(e) {
  return phash(5381, e) >>> 0;
}
var i = /* @__PURE__ */ new Set();
var s = /* @__PURE__ */ new WeakMap();
function stringify(e) {
  if (null === e || i.has(e)) {
    return "null";
  } else if ("object" != typeof e) {
    return JSON.stringify(e) || "";
  } else if (e.toJSON) {
    return stringify(e.toJSON());
  } else if (Array.isArray(e)) {
    var r2 = "[";
    for (var t2 = 0, n = e.length; t2 < n; t2++) {
      if (t2 > 0) {
        r2 += ",";
      }
      var a = stringify(e[t2]);
      r2 += a.length > 0 ? a : "null";
    }
    return r2 += "]";
  }
  var o2 = Object.keys(e).sort();
  if (!o2.length && e.constructor && e.constructor !== Object) {
    var u2 = s.get(e) || Math.random().toString(36).slice(2);
    s.set(e, u2);
    return '{"__key":"' + u2 + '"}';
  }
  i.add(e);
  var f2 = "{";
  for (var c2 = 0, l2 = o2.length; c2 < l2; c2++) {
    var p2 = o2[c2];
    var h2 = stringify(e[p2]);
    if (h2) {
      if (f2.length > 1) {
        f2 += ",";
      }
      f2 += stringify(p2) + ":" + h2;
    }
  }
  i.delete(e);
  return f2 += "}";
}
function stringifyVariables(e) {
  i.clear();
  return stringify(e);
}
var u = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;
var f = /([\s,]|#[^\n\r]+)+/g;
function replaceOutsideStrings(e, r2) {
  return r2 % 2 == 0 ? e.replace(f, " ").trim() : e;
}
function stringifyDocument(e) {
  var r2 = ("string" != typeof e ? e.loc && e.loc.source.body || print(e) : e).split(u).map(replaceOutsideStrings).join("");
  if ("string" != typeof e) {
    var t2 = "definitions" in e && getOperationName(e);
    if (t2) {
      r2 = "# " + t2 + "\n" + r2;
    }
    if (!e.loc) {
      e.loc = {
        start: 0,
        end: r2.length,
        source: {
          body: r2,
          name: "gql",
          locationOffset: {
            line: 1,
            column: 1
          }
        }
      };
    }
  }
  return r2;
}
var c = /* @__PURE__ */ new Map();
function keyDocument(e) {
  var r2;
  var n;
  if ("string" == typeof e) {
    r2 = hash(stringifyDocument(e));
    n = c.get(r2) || parse(e, {
      noLocation: true
    });
  } else {
    r2 = e.__key || hash(stringifyDocument(e));
    n = c.get(r2) || e;
  }
  if (!n.loc) {
    stringifyDocument(n);
  }
  n.__key = r2;
  c.set(r2, n);
  return n;
}
function createRequest(e, r2) {
  if (!r2) {
    r2 = {};
  }
  var t2 = keyDocument(e);
  return {
    key: phash(t2.__key, stringifyVariables(r2)) >>> 0,
    query: t2,
    variables: r2
  };
}
function getOperationName(e) {
  for (var t2 = 0, n = e.definitions.length; t2 < n; t2++) {
    var a = e.definitions[t2];
    if (a.kind === Kind.OPERATION_DEFINITION && a.name) {
      return a.name.value;
    }
  }
}
function _extends$1() {
  _extends$1 = Object.assign || function(e) {
    for (var r2 = 1; r2 < arguments.length; r2++) {
      var t2 = arguments[r2];
      for (var n in t2) {
        if (Object.prototype.hasOwnProperty.call(t2, n)) {
          e[n] = t2[n];
        }
      }
    }
    return e;
  };
  return _extends$1.apply(this, arguments);
}
function makeResult(e, r2, t2) {
  if (!("data" in r2) && !("errors" in r2) || "path" in r2) {
    throw new Error("No Content");
  }
  return {
    operation: e,
    data: r2.data,
    error: Array.isArray(r2.errors) ? new o({
      graphQLErrors: r2.errors,
      response: t2
    }) : void 0,
    extensions: "object" == typeof r2.extensions && r2.extensions || void 0,
    hasNext: !!r2.hasNext
  };
}
function mergeResultPatch(e, r2, t2) {
  var n = _extends$1({}, e);
  n.hasNext = !!r2.hasNext;
  if (!("path" in r2)) {
    if ("data" in r2) {
      n.data = r2.data;
    }
    return n;
  }
  if (Array.isArray(r2.errors)) {
    n.error = new o({
      graphQLErrors: n.error ? n.error.graphQLErrors.concat(r2.errors) : r2.errors,
      response: t2
    });
  }
  var a = n.data = _extends$1({}, n.data);
  var i2 = 0;
  var s2;
  while (i2 < r2.path.length) {
    a = a[s2 = r2.path[i2++]] = Array.isArray(a[s2]) ? [].concat(a[s2]) : _extends$1({}, a[s2]);
  }
  _extends$1(a, r2.data);
  return n;
}
function makeErrorResult(e, r2, t2) {
  return {
    operation: e,
    data: void 0,
    error: new o({
      networkError: r2,
      response: t2
    }),
    extensions: void 0
  };
}
function shouldUseGet(e) {
  return "query" === e.kind && !!e.context.preferGetMethod;
}
function makeFetchBody(e) {
  return {
    query: print(e.query),
    operationName: getOperationName(e.query),
    variables: e.variables || void 0,
    extensions: void 0
  };
}
function makeFetchURL(e, r2) {
  var t2 = shouldUseGet(e);
  var n = e.context.url;
  if (!t2 || !r2) {
    return n;
  }
  var a = [];
  if (r2.operationName) {
    a.push("operationName=" + encodeURIComponent(r2.operationName));
  }
  if (r2.query) {
    a.push("query=" + encodeURIComponent(r2.query.replace(/#[^\n\r]+/g, " ").trim()));
  }
  if (r2.variables) {
    a.push("variables=" + encodeURIComponent(stringifyVariables(r2.variables)));
  }
  if (r2.extensions) {
    a.push("extensions=" + encodeURIComponent(stringifyVariables(r2.extensions)));
  }
  var o2 = n + "?" + a.join("&");
  if (o2.length > 2047) {
    e.context.preferGetMethod = false;
    return n;
  }
  return o2;
}
function makeFetchOptions(e, r2) {
  var t2 = shouldUseGet(e);
  var n = {
    accept: "application/graphql+json, application/json"
  };
  if (!t2) {
    n["content-type"] = "application/json";
  }
  var a = ("function" == typeof e.context.fetchOptions ? e.context.fetchOptions() : e.context.fetchOptions) || {};
  if (a.headers) {
    for (var o2 in a.headers) {
      n[o2.toLowerCase()] = a.headers[o2];
    }
  }
  return _extends$1({}, a, {
    body: !t2 && r2 ? JSON.stringify(r2) : void 0,
    method: t2 ? "GET" : "POST",
    headers: n
  });
}
var l = "undefined" != typeof Symbol ? Symbol.asyncIterator : null;
var p = "undefined" != typeof TextDecoder ? new TextDecoder() : null;
var h = /content-type:[^\r\n]*application\/json/i;
var d = /boundary="?([^=";]+)"?/i;
function makeFetchSource(e, r2, t2) {
  var n = "manual" === t2.redirect ? 400 : 300;
  var o2 = e.context.fetch;
  return make$1(function(a) {
    var i2 = a.next;
    var s2 = a.complete;
    var u2 = "undefined" != typeof AbortController ? new AbortController() : null;
    if (u2) {
      t2.signal = u2.signal;
    }
    var f2 = false;
    function executeIncrementalFetch(e2, r3, t3) {
      var n2 = t3.headers && t3.headers.get("Content-Type") || "";
      if (/text\//i.test(n2)) {
        return t3.text().then(function(n3) {
          e2(makeErrorResult(r3, new Error(n3), t3));
        });
      } else if (!/multipart\/mixed/i.test(n2)) {
        return t3.text().then(function(n3) {
          e2(makeResult(r3, JSON.parse(n3), t3));
        });
      }
      var a2 = "---";
      var o3 = n2.match(d);
      if (o3) {
        a2 = "--" + o3[1];
      }
      var i3;
      var cancel = function() {
      };
      if (l && t3[l]) {
        var s3 = t3[l]();
        i3 = s3.next.bind(s3);
      } else if ("body" in t3 && t3.body) {
        var u3 = t3.body.getReader();
        cancel = u3.cancel.bind(u3);
        i3 = u3.read.bind(u3);
      } else {
        throw new TypeError("Streaming requests unsupported");
      }
      var c3 = "";
      var v2 = true;
      var m3 = null;
      var g = null;
      return i3().then(function next(n3) {
        if (!n3.done) {
          var o4 = function toString(e3) {
            return "Buffer" === e3.constructor.name ? e3.toString() : p.decode(e3);
          }(n3.value);
          var s4 = o4.indexOf(a2);
          if (s4 > -1) {
            s4 += c3.length;
          } else {
            s4 = c3.indexOf(a2);
          }
          c3 += o4;
          while (s4 > -1) {
            var u4 = c3.slice(0, s4);
            var l2 = c3.slice(s4 + a2.length);
            if (v2) {
              v2 = false;
            } else {
              var d2 = u4.indexOf("\r\n\r\n") + 4;
              var y = u4.slice(0, d2);
              var x = u4.slice(d2, u4.lastIndexOf("\r\n"));
              var b = void 0;
              if (h.test(y)) {
                try {
                  b = JSON.parse(x);
                  m3 = g = g ? mergeResultPatch(g, b, t3) : makeResult(r3, b, t3);
                } catch (e3) {
                }
              }
              if ("--" === l2.slice(0, 2) || b && !b.hasNext) {
                if (!g) {
                  return e2(makeResult(r3, {}, t3));
                }
                break;
              }
            }
            s4 = (c3 = l2).indexOf(a2);
          }
        } else {
          f2 = true;
        }
        if (m3) {
          e2(m3);
          m3 = null;
        }
        if (!n3.done && (!g || g.hasNext)) {
          return i3().then(next);
        }
      }).finally(cancel);
    }
    var c2 = false;
    var v = false;
    var m2;
    Promise.resolve().then(function() {
      if (c2) {
        return;
      }
      return (o2 || fetch)(r2, t2);
    }).then(function(r3) {
      if (!r3) {
        return;
      }
      v = (m2 = r3).status < 200 || m2.status >= n;
      return executeIncrementalFetch(i2, e, m2);
    }).then(s2).catch(function(r3) {
      if (f2) {
        throw r3;
      }
      var t3 = makeErrorResult(e, v ? m2.statusText ? new Error(m2.statusText) : r3 : r3, m2);
      i2(t3);
      s2();
    });
    return function() {
      c2 = true;
      if (u2) {
        u2.abort();
      }
    };
  });
}
function collectTypes(e, n) {
  if (Array.isArray(e)) {
    for (var r2 = 0; r2 < e.length; r2++) {
      collectTypes(e[r2], n);
    }
  } else if ("object" == typeof e && null !== e) {
    for (var t2 in e) {
      if ("__typename" === t2 && "string" == typeof e[t2]) {
        n[e[t2]] = 0;
      } else {
        collectTypes(e[t2], n);
      }
    }
  }
  return n;
}
function collectTypesFromResponse(e) {
  return Object.keys(collectTypes(e, {}));
}
var formatNode = function(e) {
  if (e.selectionSet && !e.selectionSet.selections.some(function(e2) {
    return e2.kind === Kind.FIELD && "__typename" === e2.name.value && !e2.alias;
  })) {
    return _extends$1({}, e, {
      selectionSet: _extends$1({}, e.selectionSet, {
        selections: e.selectionSet.selections.concat([{
          kind: Kind.FIELD,
          name: {
            kind: Kind.NAME,
            value: "__typename"
          }
        }])
      })
    });
  }
};
var F = /* @__PURE__ */ new Map();
function formatDocument(n) {
  var r2 = keyDocument(n);
  var a = F.get(r2.__key);
  if (!a) {
    a = visit(r2, {
      Field: formatNode,
      InlineFragment: formatNode
    });
    Object.defineProperty(a, "__key", {
      value: r2.__key,
      enumerable: false
    });
    F.set(r2.__key, a);
  }
  return a;
}
function maskTypename(e) {
  if (!e || "object" != typeof e) {
    return e;
  }
  return Object.keys(e).reduce(function(n, r2) {
    var t2 = e[r2];
    if ("__typename" === r2) {
      Object.defineProperty(n, "__typename", {
        enumerable: false,
        value: t2
      });
    } else if (Array.isArray(t2)) {
      n[r2] = t2.map(maskTypename);
    } else if (t2 && "object" == typeof t2 && "__typename" in t2) {
      n[r2] = maskTypename(t2);
    } else {
      n[r2] = t2;
    }
    return n;
  }, Array.isArray(e) ? [] : {});
}
function withPromise(e) {
  e.toPromise = function() {
    return new Promise(function(n) {
      var r2 = N(function(e2) {
        if (!e2.stale && !e2.hasNext) {
          Promise.resolve().then(function() {
            r2.unsubscribe();
            n(e2);
          });
        }
      })(e);
    });
  };
  return e;
}
function makeOperation(e, n, r2) {
  if (!r2) {
    r2 = n.context;
  }
  return {
    key: n.key,
    query: n.query,
    variables: n.variables,
    kind: e,
    context: r2
  };
}
function addMetadata(e, n) {
  return makeOperation(e.kind, e, _extends$1({}, e.context, {
    meta: _extends$1({}, e.context.meta, n)
  }));
}
function noop() {
}
function shouldSkip(e) {
  var n = e.kind;
  return "mutation" !== n && "query" !== n;
}
function cacheExchange(e) {
  var n = e.forward;
  var r2 = e.client;
  var a = /* @__PURE__ */ new Map();
  var i2 = /* @__PURE__ */ Object.create(null);
  function mapTypeNames(e2) {
    var n2 = makeOperation(e2.kind, e2);
    n2.query = formatDocument(e2.query);
    return n2;
  }
  function isOperationCached(e2) {
    var n2 = e2.context.requestPolicy;
    return "query" === e2.kind && "network-only" !== n2 && ("cache-only" === n2 || a.has(e2.key));
  }
  return function(e2) {
    var u2 = share$1(e2);
    var c2 = map$1(function(e3) {
      var n2 = a.get(e3.key);
      var i3 = _extends$1({}, n2, {
        operation: addMetadata(e3, {
          cacheOutcome: n2 ? "hit" : "miss"
        })
      });
      if ("cache-and-network" === e3.context.requestPolicy) {
        i3.stale = true;
        reexecuteOperation(r2, e3);
      }
      return i3;
    })(filter$1(function(e3) {
      return !shouldSkip(e3) && isOperationCached(e3);
    })(u2));
    var s2 = H(function(e3) {
      var n2 = e3.operation;
      if (!n2) {
        return;
      }
      var o2 = collectTypesFromResponse(e3.data).concat(n2.context.additionalTypenames || []);
      if ("mutation" === e3.operation.kind) {
        var u3 = /* @__PURE__ */ new Set();
        for (var c3 = 0; c3 < o2.length; c3++) {
          var s3 = o2[c3];
          var f2 = i2[s3] || (i2[s3] = /* @__PURE__ */ new Set());
          f2.forEach(function(e4) {
            u3.add(e4);
          });
          f2.clear();
        }
        u3.forEach(function(e4) {
          if (a.has(e4)) {
            n2 = a.get(e4).operation;
            a.delete(e4);
            reexecuteOperation(r2, n2);
          }
        });
      } else if ("query" === n2.kind && e3.data) {
        a.set(n2.key, e3);
        for (var p2 = 0; p2 < o2.length; p2++) {
          var l2 = o2[p2];
          (i2[l2] || (i2[l2] = /* @__PURE__ */ new Set())).add(n2.key);
        }
      }
    })(n(filter$1(function(e3) {
      return "query" !== e3.kind || "cache-only" !== e3.context.requestPolicy;
    })(map$1(function(e3) {
      return addMetadata(e3, {
        cacheOutcome: "miss"
      });
    })(merge$1([map$1(mapTypeNames)(filter$1(function(e3) {
      return !shouldSkip(e3) && !isOperationCached(e3);
    })(u2)), filter$1(function(e3) {
      return shouldSkip(e3);
    })(u2)])))));
    return merge$1([c2, s2]);
  };
}
function reexecuteOperation(e, n) {
  return e.reexecuteOperation(makeOperation(n.kind, n, _extends$1({}, n.context, {
    requestPolicy: "network-only"
  })));
}
function subscriptionExchange(e) {
  var n = e.forwardSubscription;
  var t2 = e.enableAllOperations;
  var a = e.isSubscriptionOperation;
  return function(e2) {
    var i2 = e2.client;
    var u2 = e2.forward;
    var c2 = a || function(e3) {
      var n2 = e3.kind;
      return "subscription" === n2 || !!t2 && ("query" === n2 || "mutation" === n2);
    };
    return function(e3) {
      var t3 = share$1(e3);
      var a2 = D(function(e4) {
        var a3 = e4.key;
        var u3 = filter$1(function(e5) {
          return "teardown" === e5.kind && e5.key === a3;
        })(t3);
        return takeUntil$1(u3)(function createSubscriptionSource(e5) {
          var t4 = n({
            key: e5.key.toString(36),
            query: print(e5.query),
            variables: e5.variables,
            context: _extends$1({}, e5.context)
          });
          return make$1(function(n2) {
            var r2 = n2.next;
            var a4 = n2.complete;
            var o2 = false;
            var u4;
            Promise.resolve().then(function() {
              if (o2) {
                return;
              }
              u4 = t4.subscribe({
                next: function(n3) {
                  return r2(makeResult(e5, n3));
                },
                error: function(n3) {
                  return r2(makeErrorResult(e5, n3));
                },
                complete: function() {
                  if (!o2) {
                    o2 = true;
                    if ("subscription" === e5.kind) {
                      i2.reexecuteOperation(makeOperation("teardown", e5, e5.context));
                    }
                    a4();
                  }
                }
              });
            });
            return function() {
              o2 = true;
              if (u4) {
                u4.unsubscribe();
              }
            };
          });
        }(e4));
      })(filter$1(c2)(t3));
      var f2 = u2(filter$1(function(e4) {
        return !c2(e4);
      })(t3));
      return merge$1([a2, f2]);
    };
  };
}
function dedupExchange(e) {
  var n = e.forward;
  var t2 = /* @__PURE__ */ new Set();
  function filterIncomingOperation(e2) {
    var n2 = e2.key;
    var a = e2.kind;
    if ("teardown" === a) {
      t2.delete(n2);
      return true;
    }
    if ("query" !== a && "subscription" !== a) {
      return true;
    }
    var o2 = t2.has(n2);
    t2.add(n2);
    return !o2;
  }
  function afterOperationResult(e2) {
    if (!e2.hasNext) {
      t2.delete(e2.operation.key);
    }
  }
  return function(e2) {
    var r2 = filter$1(filterIncomingOperation)(e2);
    return H(afterOperationResult)(n(r2));
  };
}
function fetchExchange(e) {
  var n = e.forward;
  return function(e2) {
    var t2 = share$1(e2);
    var a = D(function(e3) {
      var n2 = e3.key;
      var a2 = filter$1(function(e4) {
        return "teardown" === e4.kind && e4.key === n2;
      })(t2);
      var o3 = makeFetchBody(e3);
      var i2 = makeFetchURL(e3, o3);
      var u2 = makeFetchOptions(e3, o3);
      return H(function(n3) {
      })(takeUntil$1(a2)(makeFetchSource(e3, i2, u2)));
    })(filter$1(function(e3) {
      return "query" === e3.kind || "mutation" === e3.kind;
    })(t2));
    var o2 = n(filter$1(function(e3) {
      return "query" !== e3.kind && "mutation" !== e3.kind;
    })(t2));
    return merge$1([a, o2]);
  };
}
function fallbackExchange(e) {
  return function(e2) {
    return filter$1(function() {
      return false;
    })(H(function(e3) {
      if ("teardown" !== e3.kind && false) {
        var r2 = 'No exchange has handled operations of kind "' + e3.kind + `". Check whether you've added an exchange responsible for these operations.`;
        console.warn(r2);
      }
    })(e2));
  };
}
function composeExchanges(e) {
  return function(n) {
    var r2 = n.client;
    return e.reduceRight(function(e2, n2) {
      return n2({
        client: r2,
        forward: e2,
        dispatchDebug: function dispatchDebug$1(e3) {
        }
      });
    }, n.forward);
  };
}
var L = [dedupExchange, cacheExchange, fetchExchange];
var J = function Client(e) {
  var n = /* @__PURE__ */ new Map();
  var r2 = /* @__PURE__ */ new Map();
  var t2 = [];
  var a = makeSubject$1();
  var i2 = a.source;
  var u2 = a.next;
  var c2 = false;
  function dispatchOperation(e2) {
    if (e2) {
      u2(e2);
    }
    if (!c2) {
      c2 = true;
      while (c2 && (e2 = t2.shift())) {
        u2(e2);
      }
      c2 = false;
    }
  }
  function makeResultSource(e2) {
    var a2 = filter$1(function(n2) {
      return n2.operation.kind === e2.kind && n2.operation.key === e2.key && (!n2.operation.context._instance || n2.operation.context._instance === e2.context._instance);
    })(y);
    if (f2.maskTypename) {
      a2 = map$1(function(e3) {
        return _extends$1({}, e3, {
          data: maskTypename(e3.data)
        });
      })(a2);
    }
    if ("mutation" === e2.kind) {
      return take$1(1)(onStart$1(function() {
        return u2(e2);
      })(a2));
    }
    return share$1(onEnd$1(function() {
      n.delete(e2.key);
      r2.delete(e2.key);
      for (var a3 = t2.length - 1; a3 >= 0; a3--) {
        if (t2[a3].key === e2.key) {
          t2.splice(a3, 1);
        }
      }
      u2(makeOperation("teardown", e2, e2.context));
    })(H(function(r3) {
      n.set(e2.key, r3);
    })(K(function(n2) {
      if ("query" !== e2.kind || n2.stale) {
        return fromValue$1(n2);
      }
      return merge$1([fromValue$1(n2), map$1(function() {
        return _extends$1({}, n2, {
          stale: true
        });
      })(take$1(1)(filter$1(function(n3) {
        return "query" === n3.kind && n3.key === e2.key && "cache-only" !== n3.context.requestPolicy;
      })(i2)))]);
    })(takeUntil$1(filter$1(function(n2) {
      return "teardown" === n2.kind && n2.key === e2.key;
    })(i2))(a2)))));
  }
  var s2 = this instanceof Client ? this : Object.create(Client.prototype);
  var f2 = _extends$1(s2, {
    url: e.url,
    fetchOptions: e.fetchOptions,
    fetch: e.fetch,
    suspense: !!e.suspense,
    requestPolicy: e.requestPolicy || "cache-first",
    preferGetMethod: !!e.preferGetMethod,
    maskTypename: !!e.maskTypename,
    operations$: i2,
    reexecuteOperation: function reexecuteOperation2(e2) {
      if ("mutation" === e2.kind || r2.has(e2.key)) {
        t2.push(e2);
        Promise.resolve().then(dispatchOperation);
      }
    },
    createOperationContext: function createOperationContext(e2) {
      if (!e2) {
        e2 = {};
      }
      return _extends$1({}, {
        _instance: void 0,
        url: f2.url,
        fetchOptions: f2.fetchOptions,
        fetch: f2.fetch,
        preferGetMethod: f2.preferGetMethod
      }, e2, {
        suspense: e2.suspense || false !== e2.suspense && f2.suspense,
        requestPolicy: e2.requestPolicy || f2.requestPolicy
      });
    },
    createRequestOperation: function createRequestOperation(e2, n2, r3) {
      var a2 = f2.createOperationContext(r3);
      if ("mutation" === e2) {
        a2._instance = [];
      }
      return makeOperation(e2, n2, a2);
    },
    executeRequestOperation: function executeRequestOperation(e2) {
      if ("mutation" === e2.kind) {
        return makeResultSource(e2);
      }
      return make$1(function(t3) {
        var a2 = r2.get(e2.key);
        if (!a2) {
          r2.set(e2.key, a2 = makeResultSource(e2));
        }
        var i3 = "cache-and-network" === e2.context.requestPolicy || "network-only" === e2.context.requestPolicy;
        return N(t3.next)(onEnd$1(function() {
          c2 = false;
          t3.complete();
        })(onStart$1(function() {
          var r3 = n.get(e2.key);
          if ("subscription" === e2.kind) {
            return dispatchOperation(e2);
          } else if (i3) {
            dispatchOperation(e2);
          }
          if (null != r3 && r3 === n.get(e2.key)) {
            t3.next(i3 ? _extends$1({}, r3, {
              stale: true
            }) : r3);
          } else if (!i3) {
            dispatchOperation(e2);
          }
        })(a2))).unsubscribe;
      });
    },
    executeQuery: function executeQuery(e2, n2) {
      var r3 = f2.createRequestOperation("query", e2, n2);
      return f2.executeRequestOperation(r3);
    },
    executeSubscription: function executeSubscription(e2, n2) {
      var r3 = f2.createRequestOperation("subscription", e2, n2);
      return f2.executeRequestOperation(r3);
    },
    executeMutation: function executeMutation(e2, n2) {
      var r3 = f2.createRequestOperation("mutation", e2, n2);
      return f2.executeRequestOperation(r3);
    },
    query: function query(e2, n2, r3) {
      if (!r3 || "boolean" != typeof r3.suspense) {
        r3 = _extends$1({}, r3, {
          suspense: false
        });
      }
      return withPromise(f2.executeQuery(createRequest(e2, n2), r3));
    },
    readQuery: function readQuery(e2, n2, r3) {
      var t3 = null;
      N(function(e3) {
        t3 = e3;
      })(f2.query(e2, n2, r3)).unsubscribe();
      return t3;
    },
    subscription: function subscription(e2, n2, r3) {
      return f2.executeSubscription(createRequest(e2, n2), r3);
    },
    mutation: function mutation(e2, n2, r3) {
      return withPromise(f2.executeMutation(createRequest(e2, n2), r3));
    }
  });
  var p2 = noop;
  var h2 = composeExchanges(void 0 !== e.exchanges ? e.exchanges : L);
  var y = share$1(h2({
    client: f2,
    dispatchDebug: p2,
    forward: fallbackExchange()
  })(i2));
  publish$1(y);
  return f2;
};
var W = J;
function extendedTypeof(val) {
  if (val === null) {
    return "null";
  }
  if (Array.isArray(val)) {
    return "array";
  }
  return typeof val;
}
function isObject$1(val) {
  return extendedTypeof(val) === "object";
}
function areGraphQLErrors(obj) {
  return Array.isArray(obj) && obj.length > 0 && obj.every((ob) => "message" in ob);
}
function limitCloseReason(reason, whenTooLong) {
  return reason.length < 124 ? reason : whenTooLong;
}
const GRAPHQL_TRANSPORT_WS_PROTOCOL = "graphql-transport-ws";
var CloseCode;
(function(CloseCode2) {
  CloseCode2[CloseCode2["InternalServerError"] = 4500] = "InternalServerError";
  CloseCode2[CloseCode2["InternalClientError"] = 4005] = "InternalClientError";
  CloseCode2[CloseCode2["BadRequest"] = 4400] = "BadRequest";
  CloseCode2[CloseCode2["BadResponse"] = 4004] = "BadResponse";
  CloseCode2[CloseCode2["Unauthorized"] = 4401] = "Unauthorized";
  CloseCode2[CloseCode2["Forbidden"] = 4403] = "Forbidden";
  CloseCode2[CloseCode2["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
  CloseCode2[CloseCode2["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
  CloseCode2[CloseCode2["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
  CloseCode2[CloseCode2["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
  CloseCode2[CloseCode2["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})(CloseCode || (CloseCode = {}));
var MessageType;
(function(MessageType2) {
  MessageType2["ConnectionInit"] = "connection_init";
  MessageType2["ConnectionAck"] = "connection_ack";
  MessageType2["Ping"] = "ping";
  MessageType2["Pong"] = "pong";
  MessageType2["Subscribe"] = "subscribe";
  MessageType2["Next"] = "next";
  MessageType2["Error"] = "error";
  MessageType2["Complete"] = "complete";
})(MessageType || (MessageType = {}));
function validateMessage(val) {
  if (!isObject$1(val)) {
    throw new Error(`Message is expected to be an object, but got ${extendedTypeof(val)}`);
  }
  if (!val.type) {
    throw new Error(`Message is missing the 'type' property`);
  }
  if (typeof val.type !== "string") {
    throw new Error(`Message is expects the 'type' property to be a string, but got ${extendedTypeof(val.type)}`);
  }
  switch (val.type) {
    case MessageType.ConnectionInit:
    case MessageType.ConnectionAck:
    case MessageType.Ping:
    case MessageType.Pong: {
      if ("payload" in val && !isObject$1(val.payload)) {
        throw new Error(`"${val.type}" message expects the 'payload' property to be an object or missing, but got "${val.payload}"`);
      }
      break;
    }
    case MessageType.Subscribe: {
      if (typeof val.id !== "string") {
        throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
      }
      if (!val.id) {
        throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
      }
      if (!isObject$1(val.payload)) {
        throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${extendedTypeof(val.payload)}`);
      }
      if (typeof val.payload.query !== "string") {
        throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${extendedTypeof(val.payload.query)}`);
      }
      if (val.payload.variables != null && !isObject$1(val.payload.variables)) {
        throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${extendedTypeof(val.payload.variables)}`);
      }
      if (val.payload.operationName != null && extendedTypeof(val.payload.operationName) !== "string") {
        throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${extendedTypeof(val.payload.operationName)}`);
      }
      if (val.payload.extensions != null && !isObject$1(val.payload.extensions)) {
        throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${extendedTypeof(val.payload.extensions)}`);
      }
      break;
    }
    case MessageType.Next: {
      if (typeof val.id !== "string") {
        throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
      }
      if (!val.id) {
        throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
      }
      if (!isObject$1(val.payload)) {
        throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${extendedTypeof(val.payload)}`);
      }
      break;
    }
    case MessageType.Error: {
      if (typeof val.id !== "string") {
        throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
      }
      if (!val.id) {
        throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
      }
      if (!areGraphQLErrors(val.payload)) {
        throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
      }
      break;
    }
    case MessageType.Complete: {
      if (typeof val.id !== "string") {
        throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
      }
      if (!val.id) {
        throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
      }
      break;
    }
    default:
      throw new Error(`Invalid message 'type' property "${val.type}"`);
  }
  return val;
}
function parseMessage(data, reviver) {
  return validateMessage(typeof data === "string" ? JSON.parse(data, reviver) : data);
}
function stringifyMessage(msg, replacer) {
  validateMessage(msg);
  return JSON.stringify(msg, replacer);
}
function createClient(options2) {
  const {
    url,
    connectionParams,
    lazy = true,
    onNonLazyError = console.error,
    lazyCloseTimeout: lazyCloseTimeoutMs = 0,
    keepAlive = 0,
    disablePong,
    connectionAckWaitTimeout = 0,
    retryAttempts = 5,
    retryWait = function randomisedExponentialBackoff(retries2) {
      return __async(this, null, function* () {
        let retryDelay = 1e3;
        for (let i2 = 0; i2 < retries2; i2++) {
          retryDelay *= 2;
        }
        yield new Promise((resolve) => setTimeout(resolve, retryDelay + Math.floor(Math.random() * (3e3 - 300) + 300)));
      });
    },
    shouldRetry: shouldRetry2 = isLikeCloseEvent,
    isFatalConnectionProblem,
    on,
    webSocketImpl,
    generateID = function generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c2) => {
        const r2 = Math.random() * 16 | 0, v = c2 == "x" ? r2 : r2 & 3 | 8;
        return v.toString(16);
      });
    },
    jsonMessageReplacer: replacer,
    jsonMessageReviver: reviver
  } = options2;
  let ws;
  if (webSocketImpl) {
    if (!isWebSocket(webSocketImpl)) {
      throw new Error("Invalid WebSocket implementation provided");
    }
    ws = webSocketImpl;
  } else if (typeof WebSocket !== "undefined") {
    ws = WebSocket;
  } else if (typeof global !== "undefined") {
    ws = global.WebSocket || global.MozWebSocket;
  } else if (typeof window !== "undefined") {
    ws = window.WebSocket || window.MozWebSocket;
  }
  if (!ws)
    throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  const WebSocketImpl = ws;
  const emitter = (() => {
    const message = (() => {
      const listeners2 = {};
      return {
        on(id, listener) {
          listeners2[id] = listener;
          return () => {
            delete listeners2[id];
          };
        },
        emit(message2) {
          var _a2;
          if ("id" in message2)
            (_a2 = listeners2[message2.id]) === null || _a2 === void 0 ? void 0 : _a2.call(listeners2, message2);
        }
      };
    })();
    const listeners = {
      connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [on.connecting] : [],
      opened: (on === null || on === void 0 ? void 0 : on.opened) ? [on.opened] : [],
      connected: (on === null || on === void 0 ? void 0 : on.connected) ? [on.connected] : [],
      ping: (on === null || on === void 0 ? void 0 : on.ping) ? [on.ping] : [],
      pong: (on === null || on === void 0 ? void 0 : on.pong) ? [on.pong] : [],
      message: (on === null || on === void 0 ? void 0 : on.message) ? [message.emit, on.message] : [message.emit],
      closed: (on === null || on === void 0 ? void 0 : on.closed) ? [on.closed] : [],
      error: (on === null || on === void 0 ? void 0 : on.error) ? [on.error] : []
    };
    return {
      onMessage: message.on,
      on(event, listener) {
        const l2 = listeners[event];
        l2.push(listener);
        return () => {
          l2.splice(l2.indexOf(listener), 1);
        };
      },
      emit(event, ...args) {
        for (const listener of [...listeners[event]]) {
          listener(...args);
        }
      }
    };
  })();
  function errorOrClosed(cb) {
    const listening = [
      emitter.on("error", (err) => {
        listening.forEach((unlisten) => unlisten());
        cb(err);
      }),
      emitter.on("closed", (event) => {
        listening.forEach((unlisten) => unlisten());
        cb(event);
      })
    ];
  }
  let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
  function connect() {
    return __async(this, null, function* () {
      clearTimeout(lazyCloseTimeout);
      const [socket, throwOnClose] = yield connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied) => (() => __async(this, null, function* () {
        if (retrying) {
          yield retryWait(retries);
          if (!locks) {
            connecting = void 0;
            return denied({ code: 1e3, reason: "All Subscriptions Gone" });
          }
          retries++;
        }
        emitter.emit("connecting");
        const socket2 = new WebSocketImpl(typeof url === "function" ? yield url() : url, GRAPHQL_TRANSPORT_WS_PROTOCOL);
        let connectionAckTimeout, queuedPing;
        function enqueuePing() {
          if (isFinite(keepAlive) && keepAlive > 0) {
            clearTimeout(queuedPing);
            queuedPing = setTimeout(() => {
              if (socket2.readyState === WebSocketImpl.OPEN) {
                socket2.send(stringifyMessage({ type: MessageType.Ping }));
                emitter.emit("ping", false, void 0);
              }
            }, keepAlive);
          }
        }
        errorOrClosed((errOrEvent) => {
          connecting = void 0;
          clearTimeout(connectionAckTimeout);
          clearTimeout(queuedPing);
          denied(errOrEvent);
          if (isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
            socket2.close(4499, "Terminated");
            socket2.onerror = null;
            socket2.onclose = null;
          }
        });
        socket2.onerror = (err) => emitter.emit("error", err);
        socket2.onclose = (event) => emitter.emit("closed", event);
        socket2.onopen = () => __async(this, null, function* () {
          try {
            emitter.emit("opened", socket2);
            const payload = typeof connectionParams === "function" ? yield connectionParams() : connectionParams;
            if (socket2.readyState !== WebSocketImpl.OPEN)
              return;
            socket2.send(stringifyMessage(payload ? {
              type: MessageType.ConnectionInit,
              payload
            } : {
              type: MessageType.ConnectionInit
            }, replacer));
            if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) {
              connectionAckTimeout = setTimeout(() => {
                socket2.close(CloseCode.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
              }, connectionAckWaitTimeout);
            }
            enqueuePing();
          } catch (err) {
            emitter.emit("error", err);
            socket2.close(CloseCode.InternalClientError, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, "Internal client error"));
          }
        });
        let acknowledged = false;
        socket2.onmessage = ({ data }) => {
          try {
            const message = parseMessage(data, reviver);
            emitter.emit("message", message);
            if (message.type === "ping" || message.type === "pong") {
              emitter.emit(message.type, true, message.payload);
              if (message.type === "pong") {
                enqueuePing();
              } else if (!disablePong) {
                socket2.send(stringifyMessage(message.payload ? {
                  type: MessageType.Pong,
                  payload: message.payload
                } : {
                  type: MessageType.Pong
                }));
                emitter.emit("pong", false, message.payload);
              }
              return;
            }
            if (acknowledged)
              return;
            if (message.type !== MessageType.ConnectionAck)
              throw new Error(`First message cannot be of type ${message.type}`);
            clearTimeout(connectionAckTimeout);
            acknowledged = true;
            emitter.emit("connected", socket2, message.payload);
            retrying = false;
            retries = 0;
            connected([
              socket2,
              new Promise((_, reject) => errorOrClosed(reject))
            ]);
          } catch (err) {
            socket2.onmessage = null;
            emitter.emit("error", err);
            socket2.close(CloseCode.BadResponse, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, "Bad response"));
          }
        };
      }))());
      if (socket.readyState === WebSocketImpl.CLOSING)
        yield throwOnClose;
      let release = () => {
      };
      const released = new Promise((resolve) => release = resolve);
      return [
        socket,
        release,
        Promise.race([
          released.then(() => {
            if (!locks) {
              const complete = () => socket.close(1e3, "Normal Closure");
              if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) {
                lazyCloseTimeout = setTimeout(() => {
                  if (socket.readyState === WebSocketImpl.OPEN)
                    complete();
                }, lazyCloseTimeoutMs);
              } else {
                complete();
              }
            }
          }),
          throwOnClose
        ])
      ];
    });
  }
  function shouldRetryConnectOrThrow(errOrCloseEvent) {
    if (isLikeCloseEvent(errOrCloseEvent) && (isFatalInternalCloseCode(errOrCloseEvent.code) || [
      CloseCode.InternalServerError,
      CloseCode.InternalClientError,
      CloseCode.BadRequest,
      CloseCode.BadResponse,
      CloseCode.Unauthorized,
      CloseCode.SubprotocolNotAcceptable,
      CloseCode.SubscriberAlreadyExists,
      CloseCode.TooManyInitialisationRequests
    ].includes(errOrCloseEvent.code)))
      throw errOrCloseEvent;
    if (disposed)
      return false;
    if (isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1e3)
      return locks > 0;
    if (!retryAttempts || retries >= retryAttempts)
      throw errOrCloseEvent;
    if (!shouldRetry2(errOrCloseEvent))
      throw errOrCloseEvent;
    if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent))
      throw errOrCloseEvent;
    return retrying = true;
  }
  if (!lazy) {
    (() => __async(this, null, function* () {
      locks++;
      for (; ; ) {
        try {
          const [, , throwOnClose] = yield connect();
          yield throwOnClose;
        } catch (errOrCloseEvent) {
          try {
            if (!shouldRetryConnectOrThrow(errOrCloseEvent))
              return;
          } catch (errOrCloseEvent2) {
            return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent2);
          }
        }
      }
    }))();
  }
  return {
    on: emitter.on,
    subscribe(payload, sink) {
      const id = generateID(payload);
      let done = false, errored = false, releaser = () => {
        locks--;
        done = true;
      };
      (() => __async(this, null, function* () {
        locks++;
        for (; ; ) {
          try {
            const [socket, release, waitForReleaseOrThrowOnClose] = yield connect();
            if (done)
              return release();
            const unlisten = emitter.onMessage(id, (message) => {
              switch (message.type) {
                case MessageType.Next: {
                  sink.next(message.payload);
                  return;
                }
                case MessageType.Error: {
                  errored = true, done = true;
                  sink.error(message.payload);
                  releaser();
                  return;
                }
                case MessageType.Complete: {
                  done = true;
                  releaser();
                  return;
                }
              }
            });
            socket.send(stringifyMessage({
              id,
              type: MessageType.Subscribe,
              payload
            }, replacer));
            releaser = () => {
              if (!done && socket.readyState === WebSocketImpl.OPEN)
                socket.send(stringifyMessage({
                  id,
                  type: MessageType.Complete
                }, replacer));
              locks--;
              done = true;
              release();
            };
            yield waitForReleaseOrThrowOnClose.finally(unlisten);
            return;
          } catch (errOrCloseEvent) {
            if (!shouldRetryConnectOrThrow(errOrCloseEvent))
              return;
          }
        }
      }))().then(() => {
        if (!errored)
          sink.complete();
      }).catch((err) => {
        sink.error(err);
      });
      return () => {
        if (!done)
          releaser();
      };
    },
    dispose() {
      return __async(this, null, function* () {
        disposed = true;
        if (connecting) {
          const [socket] = yield connecting;
          socket.close(1e3, "Normal Closure");
        }
      });
    },
    terminate() {
      if (connecting) {
        emitter.emit("closed", {
          code: 4499,
          reason: "Terminated",
          wasClean: false
        });
      }
    }
  };
}
function isLikeCloseEvent(val) {
  return isObject$1(val) && "code" in val && "reason" in val;
}
function isFatalInternalCloseCode(code) {
  if ([
    1e3,
    1001,
    1006,
    1005,
    1012,
    1013,
    1013
  ].includes(code))
    return false;
  return code >= 1e3 && code <= 1999;
}
function isWebSocket(val) {
  return typeof val === "function" && "constructor" in val && "CLOSED" in val && "CLOSING" in val && "CONNECTING" in val && "OPEN" in val;
}
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function() {
    return exports;
  };
  var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap2(innerFn, outerFn, self2, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
    return generator._invoke = function(innerFn2, self3, context2) {
      var state = "suspendedStart";
      return function(method, arg) {
        if ("executing" === state)
          throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method)
            throw arg;
          return doneResult();
        }
        for (context2.method = method, context2.arg = arg; ; ) {
          var delegate = context2.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context2);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel)
                continue;
              return delegateResult;
            }
          }
          if ("next" === context2.method)
            context2.sent = context2._sent = context2.arg;
          else if ("throw" === context2.method) {
            if ("suspendedStart" === state)
              throw state = "completed", context2.arg;
            context2.dispatchException(context2.arg);
          } else
            "return" === context2.method && context2.abrupt("return", context2.arg);
          state = "executing";
          var record = tryCatch(innerFn2, self3, context2);
          if ("normal" === record.type) {
            if (state = context2.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel)
              continue;
            return {
              value: record.arg,
              done: context2.done
            };
          }
          "throw" === record.type && (state = "completed", context2.method = "throw", context2.arg = record.arg);
        }
      };
    }(innerFn, self2, context), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap2;
  var ContinueSentinel = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function() {
    return this;
  });
  var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg, value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value2) {
          invoke("next", value2, resolve, reject);
        }, function(err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function(unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function(error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    this._invoke = function(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (void 0 === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method))
          return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type)
      return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod)
        return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next)
        return iterable;
      if (!isNaN(iterable.length)) {
        var i2 = -1, next = function next2() {
          for (; ++i2 < iterable.length; )
            if (hasOwn.call(iterable, i2))
              return next2.value = iterable[i2], next2.done = false, next2;
          return next2.value = void 0, next2.done = true, next2;
        };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: void 0,
      done: true
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function(genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function(arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap2(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
    return this;
  }), define(Gp, "toString", function() {
    return "[object Generator]";
  }), exports.keys = function(object) {
    var keys = [];
    for (var key in object)
      keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length; ) {
        var key2 = keys.pop();
        if (key2 in object)
          return next.value = key2, next.done = false, next;
      }
      return next.done = true, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset)
        for (var name in this)
          "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
    },
    stop: function() {
      this.done = true;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type)
        throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function(exception) {
      if (this.done)
        throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
      }
      for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
        var entry = this.tryEntries[i2], record = entry.completion;
        if ("root" === entry.tryLoc)
          return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc)
              return handle(entry.catchLoc, true);
            if (this.prev < entry.finallyLoc)
              return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc)
              return handle(entry.catchLoc, true);
          } else {
            if (!hasFinally)
              throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc)
              return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function(type, arg) {
      for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
        var entry = this.tryEntries[i2];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function(record, afterLoc) {
      if ("throw" === record.type)
        throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function(finallyLoc) {
      for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
        var entry = this.tryEntries[i2];
        if (entry.finallyLoc === finallyLoc)
          return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function(tryLoc) {
      for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
        var entry = this.tryEntries[i2];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName,
        nextLoc
      }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray(o2, minLen);
  var n = Object.prototype.toString.call(o2).slice(8, -1);
  if (n === "Object" && o2.constructor)
    n = o2.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o2);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _createForOfIteratorHelperLoose(o2, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it)
    return (it = it.call(o2)).next.bind(it);
  if (Array.isArray(o2) || (it = _unsupportedIterableToArray(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
    if (it)
      o2 = it;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length)
        return {
          done: true
        };
      return {
        done: false,
        value: o2[i2++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var DEFAULT_PAGE_FETCH_LIMIT = 50;
var DEFAULT_COLLECTION_PAGE_FETCH_LIMIT = 5;
var DEFAULT_MAX_ENTRIES = -1;
var DEFAULT_MAX_ENTRIES_PER_COLLECTION = 5;
var X_NACELLE_SPACE_TOKEN = "x-nacelle-space-token";
var X_NACELLE_PREVIEW_TOKEN = "x-nacelle-preview-token";
var MISSING_SUB_PARAM_MSG = "The params subscriptionToken && subscriptionEndpoint were not all provided";
var ENTRY_DEPTH_PARAM_WARNING_LIMIT = 5;
var QUERY_COMPLEXITY_ERROR_MESSAGE = "Not enough complexity points available";
var QUERY_COMPLEXITY_ERROR_CODE = "COMPLEXITY_ERROR";
var INTERNAL_SERVER_ERROR_CODE = "INTERNAL_SERVER_ERROR";
var RETRY_STARTING_DELAY_IN_MS = 500;
var RETRY_MAX_DELAY_IN_MS = 5e3;
var RETRY_NUMBER_OF_ATTEMPTS = 5;
var RETRY_TIME_MULTIPLE = 2;
var FIRST_FILTER_FALLBACK_VALUE = 1;
var FIRST_FILTER_OPTIMIZATION_VALUE = 2;
var EntryType;
(function(EntryType2) {
  EntryType2["PRODUCT"] = "product";
  EntryType2["PRODUCT_CONTENT"] = "product-content";
  EntryType2["VARIANT"] = "variant";
  EntryType2["VARIANT_CONTENT"] = "variant-content";
  EntryType2["CONTENT"] = "content";
  EntryType2["CONTENT_COLLECTION"] = "content-collection";
  EntryType2["PRODUCT_COLLECTION"] = "product-collection";
  EntryType2["COLLECTION_CONTENT"] = "collection-content";
})(EntryType || (EntryType = {}));
var DataSourceName;
(function(DataSourceName2) {
  DataSourceName2["SHOPIFY"] = "shopify";
  DataSourceName2["CONTENTFUL"] = "contentful";
  DataSourceName2["SANITY"] = "sanity";
})(DataSourceName || (DataSourceName = {}));
var ContentSearchFields;
(function(ContentSearchFields2) {
  ContentSearchFields2["Handle"] = "HANDLE";
  ContentSearchFields2["Title"] = "TITLE";
  ContentSearchFields2["Type"] = "TYPE";
})(ContentSearchFields || (ContentSearchFields = {}));
var NavigationPropertyType;
(function(NavigationPropertyType2) {
  NavigationPropertyType2["Blog"] = "BLOG";
  NavigationPropertyType2["Collection"] = "COLLECTION";
  NavigationPropertyType2["External"] = "EXTERNAL";
  NavigationPropertyType2["General"] = "GENERAL";
  NavigationPropertyType2["Page"] = "PAGE";
  NavigationPropertyType2["Product"] = "PRODUCT";
})(NavigationPropertyType || (NavigationPropertyType = {}));
var ProductCollectionSearchFields;
(function(ProductCollectionSearchFields2) {
  ProductCollectionSearchFields2["Handle"] = "HANDLE";
  ProductCollectionSearchFields2["Title"] = "TITLE";
})(ProductCollectionSearchFields || (ProductCollectionSearchFields = {}));
var ProductCollectionSortOrder;
(function(ProductCollectionSortOrder2) {
  ProductCollectionSortOrder2["Asc"] = "ASC";
  ProductCollectionSortOrder2["Desc"] = "DESC";
})(ProductCollectionSortOrder || (ProductCollectionSortOrder = {}));
var ProductSearchFields;
(function(ProductSearchFields2) {
  ProductSearchFields2["Handle"] = "HANDLE";
  ProductSearchFields2["Sku"] = "SKU";
  ProductSearchFields2["Tags"] = "TAGS";
  ProductSearchFields2["Title"] = "TITLE";
})(ProductSearchFields || (ProductSearchFields = {}));
var Locales;
(function(Locales2) {
  Locales2["en"] = "en";
  Locales2["en_US"] = "en-US";
  Locales2["en_GB"] = "en-GB";
  Locales2["fr"] = "fr";
  Locales2["de"] = "de";
  Locales2["pl"] = "pl";
  Locales2["nl"] = "nl";
  Locales2["fi"] = "fi";
  Locales2["sv"] = "sv";
  Locales2["it"] = "it";
  Locales2["es"] = "es";
  Locales2["pt"] = "pt";
  Locales2["ru"] = "ru";
  Locales2["pt_BR"] = "pt-BR";
  Locales2["es_MX"] = "es-MX";
  Locales2["zh_CN"] = "zh-CN";
  Locales2["zh_TW"] = "zh-TW";
  Locales2["jp"] = "ja";
  Locales2["ko"] = "ko";
})(Locales || (Locales = {}));
var ChunkFilterName;
(function(ChunkFilterName2) {
  ChunkFilterName2["NACELLE_ENTRY_ID"] = "nacelleEntryIds";
  ChunkFilterName2["HANDLES"] = "handles";
})(ChunkFilterName || (ChunkFilterName = {}));
var metafield = "\n  id\n  key\n  namespace\n  value\n";
var contentCollection = "\n  createdAt\n  indexedAt\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  sourceEntryId\n  sourceId\n  tags\n  updatedAt\n";
var content = "\n  createdAt\n  fields\n  handle\n  indexedAt\n  locale\n  nacelleEntryId\n  published\n  sourceEntryId\n  sourceId\n  tags\n  title\n  type\n  updatedAt\n";
var media = "\n  altText\n  id\n  mimeType\n  src\n  thumbnailSrc\n  type\n";
var seo = "\n  title\n  description\n";
var collectionContent = "\n  collectionEntryId\n  createdAt\n  description\n  featuredMedia {\n    " + media + "\n  }\n  fields\n  handle\n  indexedAt\n  locale\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  # published\n  sourceEntryId\n  sourceId\n  title\n  updatedAt\n  seo {\n    " + seo + "\n  }\n";
var contentCollectionsQuery = "\nquery contentCollectionsQuery(\n  $filter: ContentCollectionFilterInput,\n  $maxReturnedEntriesPerCollection: Int\n) {\n  contentCollections(filter: $filter) {\n    " + contentCollection + "\n    entries(first: $maxReturnedEntriesPerCollection) {\n      " + content + "\n    }\n    content {\n      " + collectionContent + "\n    }\n  }\n}\n";
var contentCollectionEntriesQuery = "\nquery contentCollectionEntries(\n  $filter: ContentCollectionFilterInput,\n  $contentFirst: Int,\n  $contentAfter: String\n) {\n  contentCollections(filter: $filter) {\n    entries(first: $contentFirst, after: $contentAfter) {\n      " + content + "\n    }\n  }\n}\n";
var allContentCollectionsQuery = "\nquery allContentCollectionsQuery(\n  $filter: ContentCollectionFilterInput,\n  $maxReturnedEntriesPerCollection: Int\n) {\n  allContentCollections(filter: $filter) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        " + contentCollection + "\n        contentConnection(first: $maxReturnedEntriesPerCollection) {\n          totalCount\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            node {\n              " + content + "\n            }\n          }\n        }\n        content {\n          " + collectionContent + "\n        }\n      }\n    }\n  }\n}\n";
var allContentCollectionEntriesQuery = "\nquery contentCollectionEntries(\n  $filter: ContentCollectionFilterInput,\n  $entriesFirst: Int,\n  $entriesAfter: String\n) {\n  allContentCollections(filter: $filter) {\n    edges {\n      node {\n        contentConnection(first: $entriesFirst, after: $entriesAfter) {\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            node {\n              " + content + "\n            }\n          }\n        }\n      }\n    }\n  }\n}\n";
var contentQuery = "\nquery content(\n  $filter: ContentFilterInput\n) {\n  content(filter: $filter) {\n    " + content + "\n  }\n}\n";
var allContentQuery = "\nquery allContent($filter: ContentFilterInput) {\n  allContent(filter: $filter) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        " + content + "\n      }\n    }\n  }\n}\n";
var navigation = "\nfragment NavigationItem on NavigationGroupItem {\n	title\n	type\n	url\n	media {\n		url\n	}\n	properties {\n		key\n		value\n	}\n}\n\nquery ($filter: NavigationFilterInput) {\n	navigation(filter: $filter) {\n		groupId\n		title\n		updatedAt\n		updatedBy\n		items {\n			...NavigationItem\n			items {\n				...NavigationItem\n				items {\n					...NavigationItem\n					items {\n						...NavigationItem\n						items {\n							...NavigationItem\n						}\n					}\n				}\n			}\n		}\n	}\n}\n\n";
var option = "\n  name\n  values\n";
var productContent = "\n  createdAt\n  description\n  featuredMedia {\n    " + media + "\n  }\n  fields\n  handle\n  indexedAt\n  locale\n  media {\n    " + media + "\n  }\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  options {\n    " + option + "\n  }\n  productEntryId\n  published\n  seo {\n    " + seo + "\n  }\n  sourceEntryId\n  sourceId\n  title\n  updatedAt\n";
var variantContentFragment = "\n  createdAt\n  description\n  featuredMedia {\n    " + media + "\n  }\n  fields\n  indexedAt\n  locale\n  media {\n    " + media + "\n  }\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  productEntryId\n  productHandle\n  published\n  selectedOptions {\n    label\n    name\n    value\n  }\n  sourceEntryId\n  sourceId\n  swatchSrc\n  title\n  updatedAt\n  variantEntryId\n";
var productPriceBreaksFragment = "\n  metafields {\n    " + metafield + "\n  }\n  price\n  quantityMax\n  quantityMin\n";
var productPriceRulesFragment = "\n  comparedAtPrice\n  country\n  id\n  metafields {\n    " + metafield + "\n  }\n  price\n  priceBreaks {\n    " + productPriceBreaksFragment + "\n  }\n  priceCurrency\n  title\n";
var variantFragment = "\n  availableForSale\n  compareAtPrice\n  content {\n    " + variantContentFragment + "\n  }\n  createdAt\n  indexedAt\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  price\n  priceCurrency\n  priceRules {\n    " + productPriceRulesFragment + "\n  }\n  productEntryId\n  productHandle\n  quantityAvailable\n  sku\n  sourceEntryId\n  sourceId\n  updatedAt\n  weight\n  weightUnit\n";
var productFragmentSubset = "\n  availableForSale\n  createdAt\n  indexedAt\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  productType\n  sourceEntryId\n  sourceId\n  tags\n  updatedAt\n  vendor\n";
var product = "\n  " + productFragmentSubset + "\n  variants {\n    " + variantFragment + "\n  }\n  content {\n    " + productContent + "\n  }\n";
var productCollectionFragmentSubset = "\n  createdAt\n  indexedAt\n  metafields {\n    " + metafield + "\n  }\n  nacelleEntryId\n  sourceEntryId\n  sourceId\n  tags\n  updatedAt\n";
var productCollectionsQuery = "\nquery productCollections(\n  $filter: ProductCollectionFilterInput,\n  $maxReturnedEntriesPerCollection: Int\n) {\n  productCollections(filter: $filter) {\n    " + productCollectionFragmentSubset + "\n    content {\n      " + collectionContent + "\n    }\n    products(first: $maxReturnedEntriesPerCollection) {\n      " + product + "\n    }\n  }\n}\n";
var productCollectionEntriesQuery = "\nquery productCollectionEntries(\n  $filter: ProductCollectionFilterInput,\n  $entriesFirst: Int,\n  $entriesAfter: String\n) {\n  productCollections(filter: $filter) {\n    products(first: $entriesFirst, after: $entriesAfter) {\n      " + product + "\n    }\n  }\n}\n";
var allProductCollectionsQuery$1 = "\nquery allProductCollections(\n  $filter: ProductCollectionFilterInput,\n  $maxReturnedEntriesPerCollection: Int\n) {\n  allProductCollections(filter: $filter) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        " + productCollectionFragmentSubset + "\n        content {\n          " + collectionContent + "\n        }\n        productConnection(first: $maxReturnedEntriesPerCollection) {\n          totalCount\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            node {\n              " + product + "\n            }\n          }\n        }\n      }\n    }\n  }\n}\n";
var allProductCollectionEntriesQuery = "\nquery productCollectionEntries(\n  $filter: ProductCollectionFilterInput,\n  $entriesFirst: Int,\n  $entriesAfter: String\n) {\n  allProductCollections(filter: $filter) {\n    edges {\n      node {\n        productConnection(first: $entriesFirst, after: $entriesAfter) {\n          pageInfo {\n            hasNextPage\n          }\n          edges {\n            cursor\n            node {\n              " + product + "\n            }\n          }\n        }\n      }\n    }\n  }\n}\n";
var productsQuery = "\nquery products(\n  $filter: ProductFilterInput,\n) {\n  products(filter: $filter) {\n    " + productFragmentSubset + "\n    variants {\n      " + variantFragment + "\n    }\n    content {\n      " + productContent + "\n    }\n  }\n}\n";
var allProductsQuery = "\nquery allProducts($filter: ProductFilterInput) {\n  allProducts(filter: $filter) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        " + productFragmentSubset + "\n        variants {\n          " + variantFragment + "\n        }\n        content {\n          " + productContent + "\n        }\n      }\n    }\n  }\n}\n";
var spaceQuery = "\nquery {\n  spaceProperties {\n		properties {\n			items {\n				key\n				value\n			}\n			namespace\n		}\n		updatedAt\n		updatedBy\n	}\n}\n";
var productSubscription = "\nsubscription Subscription($productInventoryUpdatedFilter: InventoryItemsSubscriptionFilterInput) {\n  productInventoryUpdated (filter: $productInventoryUpdatedFilter) {\n    nacelleEntryId\n    entryType\n    availableForSale\n  }\n}";
var productVariantSubscription = "subscription Subscription($variantInventoryUpdatedFilter: InventoryItemsSubscriptionFilterInput) {\n    variantInventoryUpdated (filter: $variantInventoryUpdatedFilter) {\n      nacelleEntryId\n      entryType\n      availableForSale\n    }\n  }";
var productInventoryQuery = "\nquery ProductInventoryItems($filter: InventoryItemsQueryFilterInput) {\n  productInventoryItems(filter: $filter) {\n    nacelleEntryId\n    entryType\n    availableForSale\n  }\n} \n";
var productVariantInventoryQuery = "\nquery variantInventoryItems($filter: InventoryItemsQueryFilterInput) {\n  variantInventoryItems(filter: $filter) {\n    nacelleEntryId\n    entryType\n    availableForSale\n  }\n} \n";
function keepFetchingItems(fetchedItems, totalItems, maxReturnedEntries) {
  var lessItemsThanRequested = maxReturnedEntries ? maxReturnedEntries === -1 || totalItems.length < maxReturnedEntries : true;
  return fetchedItems.length > 0 && lessItemsThanRequested;
}
function keepFetchingItemsUsingNextPage(hasNextPage, totalItems, maxReturnedEntries) {
  var lessItemsThanRequested = typeof maxReturnedEntries === "undefined" || maxReturnedEntries === -1 ? true : maxReturnedEntries !== 0 && totalItems.length < maxReturnedEntries;
  return Boolean(hasNextPage) && lessItemsThanRequested;
}
var isGraphQLError = function isGraphQLError2(data) {
  return Boolean(data.errors && data.errors.length > 0);
};
var retryStatusCodes = [
  429,
  500,
  502,
  503,
  504
];
var retryApolloErrorCodes = [INTERNAL_SERVER_ERROR_CODE];
function shouldRetryByResponseError(error) {
  var _error$extensions$cod, _error$extensions;
  var apolloErrorCode = (_error$extensions$cod = (_error$extensions = error.extensions) == null ? void 0 : _error$extensions.code) != null ? _error$extensions$cod : "";
  var isQueryComplexityError = apolloErrorCode === QUERY_COMPLEXITY_ERROR_CODE;
  if (isQueryComplexityError) {
    var _error$extensions$req, _error$extensions2, _error$extensions$thr, _error$extensions3, _error$extensions3$th;
    var requestedQueryCost = (_error$extensions$req = (_error$extensions2 = error.extensions) == null ? void 0 : _error$extensions2.requestedQueryCost) != null ? _error$extensions$req : 0;
    var totalCapacity = (_error$extensions$thr = (_error$extensions3 = error.extensions) == null ? void 0 : (_error$extensions3$th = _error$extensions3.throttleStatus) == null ? void 0 : _error$extensions3$th.totalCapacity) != null ? _error$extensions$thr : 0;
    var shouldRetryComplexityError = totalCapacity > requestedQueryCost;
    return shouldRetryComplexityError;
  }
  return retryApolloErrorCodes.includes(apolloErrorCode);
}
function shouldRetry(response, responseData) {
  if (retryStatusCodes.includes(response.status)) {
    return {
      shouldRetry: true,
      reason: "Request failed with status: " + response.status + " - " + response.statusText
    };
  }
  if (isGraphQLError(responseData)) {
    var _responseData$errors$, _responseData$errors;
    var apolloErrorsToRetry = (_responseData$errors$ = (_responseData$errors = responseData.errors) == null ? void 0 : _responseData$errors.filter(shouldRetryByResponseError)) != null ? _responseData$errors$ : [];
    if (apolloErrorsToRetry.length > 0) {
      var _apolloErrorsToRetry$ = apolloErrorsToRetry[0], message = _apolloErrorsToRetry$.message, _apolloErrorsToRetry$2 = _apolloErrorsToRetry$.extensions, extensions = _apolloErrorsToRetry$2 === void 0 ? {} : _apolloErrorsToRetry$2;
      var reason = message + " - " + JSON.stringify(extensions);
      return {
        shouldRetry: true,
        reason
      };
    }
  }
  return {
    shouldRetry: false
  };
}
var version = "1.8.0";
var _excluded$1 = ["headers"];
var backOffOptions = {
  delayFirstAttempt: true,
  jitter: "full",
  numOfAttempts: RETRY_NUMBER_OF_ATTEMPTS,
  startingDelay: RETRY_STARTING_DELAY_IN_MS,
  maxDelay: RETRY_MAX_DELAY_IN_MS,
  timeMultiple: RETRY_TIME_MULTIPLE
};
var HttpClientFetch = /* @__PURE__ */ function() {
  function HttpClientFetch2(options2) {
    this.options = void 0;
    var defaultOptions2 = {
      timeout: 24e4
    };
    var defaultHeaders = {
      "Content-Type": "application/json",
      "x-nacelle-sdk-version": version
    };
    var _ref = options2 || {}, headers = _ref.headers, otherOptions = _objectWithoutPropertiesLoose(_ref, _excluded$1);
    this.options = _extends({
      headers: _extends({}, defaultHeaders, headers)
    }, defaultOptions2, otherOptions);
  }
  var _proto = HttpClientFetch2.prototype;
  _proto.get = /* @__PURE__ */ function() {
    var _get = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(url) {
      var response, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch$1(url, _extends({}, this.options, {
                method: "GET"
              }));
            case 2:
              response = _context.sent;
              _context.next = 5;
              return response.json();
            case 5:
              data = _context.sent;
              return _context.abrupt("return", {
                headers: response.headers,
                status: response.status,
                statusText: response.statusText,
                data
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    function get(_x) {
      return _get.apply(this, arguments);
    }
    return get;
  }();
  _proto.post = /* @__PURE__ */ function() {
    var _post = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3(url, data) {
      var _this = this;
      var attempt, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              attempt = 1;
              _context3.next = 3;
              return backOff_1(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2() {
                var innerResponse, responseData, retryResponse, errorMessage;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return fetch$1(url, _extends({}, _this.options, {
                          method: "POST",
                          body: JSON.stringify(data)
                        }));
                      case 3:
                        innerResponse = _context2.sent;
                        _context2.next = 6;
                        return innerResponse.json();
                      case 6:
                        responseData = _context2.sent;
                        retryResponse = shouldRetry(innerResponse, responseData);
                        if (!retryResponse.shouldRetry) {
                          _context2.next = 10;
                          break;
                        }
                        throw Error(retryResponse.reason);
                      case 10:
                        return _context2.abrupt("return", _extends({}, innerResponse, {
                          responseData
                        }));
                      case 13:
                        _context2.prev = 13;
                        _context2.t0 = _context2["catch"](0);
                        errorMessage = "Failed POST request - Retry attempt " + attempt + " - " + _context2.t0;
                        console.warn(errorMessage);
                        attempt++;
                        throw _context2.t0;
                      case 19:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[0, 13]]);
              })), backOffOptions);
            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", {
                headers: response.headers,
                status: response.status,
                statusText: response.statusText,
                data: response.responseData
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    function post(_x2, _x3) {
      return _post.apply(this, arguments);
    }
    return post;
  }();
  return HttpClientFetch2;
}();
function convertWsToHttp(url) {
  return url.replace(/(ws:\/\/|wss:\/\/){0,1}(.*)/, function(g1, g2, g3) {
    var prefix = "";
    if (g2 === "wss://") {
      prefix = "https://";
    } else {
      prefix = "http://";
    }
    return prefix + g3;
  });
}
function buildChunks(chunkSize, filterName, filterValues, limit) {
  if (filterValues === void 0) {
    filterValues = [];
  }
  if (limit === void 0) {
    limit = DEFAULT_MAX_ENTRIES;
  }
  var chunkedParameters = [];
  var maxLength = limit < 0 || limit > filterValues.length ? filterValues.length : limit;
  for (var i2 = 0; i2 < maxLength; i2 += chunkSize) {
    var chunkLength = Math.min(i2 + chunkSize, maxLength);
    var chunkValues = filterValues.slice(i2, chunkLength);
    var chunkValuesEntry = {
      filterName,
      values: chunkValues
    };
    chunkedParameters.push(chunkValuesEntry);
  }
  return chunkedParameters;
}
var handleGraphqlErrors = function handleGraphqlErrors2(connectorParams, errors) {
  var errorMessage = "Storefront GraphQL Error:";
  if (errors && errors.length > 0) {
    var _errors$reduce = errors.reduce(function(categories, error) {
      var _error$extensions;
      switch ((_error$extensions = error.extensions) == null ? void 0 : _error$extensions.code) {
        case "UNAUTHENTICATED":
          categories.unauthenticated.push(error);
          break;
        case "COMPLEXITY_ERROR":
          categories.complexityErrors.push(error);
          break;
        default:
          categories.otherErrors.push(error);
          break;
      }
      return categories;
    }, {
      unauthenticated: [],
      otherErrors: [],
      complexityErrors: []
    }), unauthenticated = _errors$reduce.unauthenticated, otherErrors = _errors$reduce.otherErrors, complexityErrors = _errors$reduce.complexityErrors;
    if (complexityErrors.length > 0) {
      var _complexityErrors$ = complexityErrors[0], message = _complexityErrors$.message, extensions = _complexityErrors$.extensions;
      throw new Error(message + "/" + JSON.stringify(extensions));
    }
    unauthenticated.forEach(function(error) {
      if (error.message.indexOf("x-nacelle-space-token") > -1 || error.message.indexOf("Token is invalid") > -1) {
        errorMessage += " The Storefront SDK client is trying to use an invalid Storefront API token, " + connectorParams.token + ", for " + connectorParams.endpoint + ".\nPlease verify that the client is initialized with the correct token parameter.'";
      }
    });
    otherErrors.forEach(function(error, index, arr) {
      var _ref = error.extensions || {}, nacelleErrorId = _ref.nacelleErrorId, failedEntries = _ref.failedEntries;
      var displayIndex = arr.length > 1 ? " (" + (index + 1) + " of " + arr.length + ") " : "";
      var displayErrorId = nacelleErrorId ? " (Error Ref Id: " + nacelleErrorId + ")" : "";
      var stringifiedFailedEntries = failedEntries ? " - Error Details: " + JSON.stringify(failedEntries) : "";
      errorMessage += "" + displayIndex + error.message + displayErrorId + stringifiedFailedEntries;
    });
    if (connectorParams.debugMode) {
      console.info("Storefront SDK Debug: GraphQL Error Details", JSON.stringify(errors));
    }
    throw new Error(errorMessage);
  }
};
var handleFailedResponse = function handleFailedResponse2(currentFirstFilter, errorMessage) {
  var optimizedFirstFilter = FIRST_FILTER_FALLBACK_VALUE;
  var isQueryComplexityError = errorMessage == null ? void 0 : errorMessage.includes(QUERY_COMPLEXITY_ERROR_MESSAGE);
  if (isQueryComplexityError) {
    optimizedFirstFilter = Math.round(currentFirstFilter / FIRST_FILTER_OPTIMIZATION_VALUE);
  }
  var isQueryOptimized = currentFirstFilter === optimizedFirstFilter;
  var shouldThrowError = !isQueryComplexityError || isQueryOptimized;
  if (shouldThrowError) {
    throw new Error(errorMessage);
  }
  return optimizedFirstFilter;
};
function nodesFromEdges(edges) {
  return edges ? edges.map(function(_ref) {
    var node = _ref.node;
    return node;
  }) : [];
}
function lastEdgeCursor(edges) {
  return edges && edges.length > 0 ? edges[edges.length - 1].cursor : void 0;
}
function mapCollectionConnectionToArray(collection, connectionKey, placementKey) {
  var _extends2;
  var connection = collection[connectionKey];
  return _extends({}, collection, (_extends2 = {}, _extends2[placementKey] = nodesFromEdges(connection.edges), _extends2));
}
function checkDeprecatedQuery(params) {
  return Boolean(params && typeof params.startAfterEntryId !== "undefined" && params.startAfterEntryId.length > 0);
}
var _excluded = ["cursor", "startAfterEntryId", "nacelleEntryIds", "handles", "locale", "maxReturnedEntries", "advancedOptions", "edgesToNodes"];
var StorefrontConnector = /* @__PURE__ */ function() {
  function StorefrontConnector2(params) {
    this.token = void 0;
    this.endpoint = void 0;
    this.previewToken = void 0;
    this.locale = void 0;
    this.httpClient = void 0;
    this.debugMode = void 0;
    this.endpoint = params.endpoint;
    this.token = params.token;
    this.previewToken = params.previewToken;
    this.locale = params.locale;
    this.debugMode = params.debugMode || false;
    if (this.debugMode) {
      console.info("credentials:", {
        endpoint: this.endpoint,
        token: this.token
      });
    }
    var headers = {};
    headers[X_NACELLE_SPACE_TOKEN] = this.token;
    if (this.previewToken) {
      var currentEndpoint = new URL(this.endpoint);
      currentEndpoint.searchParams.append("preview", "true");
      this.endpoint = currentEndpoint.toString();
      headers[X_NACELLE_PREVIEW_TOKEN] = this.previewToken;
    }
    this.httpClient = params.httpClient || new HttpClientFetch({
      headers
    });
  }
  var _proto = StorefrontConnector2.prototype;
  _proto.request = /* @__PURE__ */ function() {
    var _request = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(params) {
      var query, queryName, variables, data, response, graphqlResponse, queryResponseData, _queryResponseData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              query = params.query, queryName = params.queryName, variables = params.variables;
              data = {
                query,
                variables
              };
              if (this.debugMode) {
                console.info("storefront request", {
                  query: JSON.stringify(query),
                  variables: JSON.stringify(variables)
                });
              }
              _context.next = 6;
              return this.httpClient.post(this.endpoint, data);
            case 6:
              response = _context.sent;
              if (response) {
                _context.next = 9;
                break;
              }
              throw new Error("No valid response from " + queryName);
            case 9:
              graphqlResponse = response.data;
              if (isGraphQLError(graphqlResponse)) {
                handleGraphqlErrors(this, graphqlResponse.errors);
              }
              if (!graphqlResponse.data) {
                _context.next = 18;
                break;
              }
              if (!(queryName && graphqlResponse.data[queryName] !== "undefined")) {
                _context.next = 15;
                break;
              }
              queryResponseData = graphqlResponse.data[queryName];
              return _context.abrupt("return", {
                success: true,
                data: queryResponseData
              });
            case 15:
              if (queryName) {
                _context.next = 18;
                break;
              }
              _queryResponseData = graphqlResponse.data;
              return _context.abrupt("return", {
                success: true,
                data: _queryResponseData
              });
            case 18:
              throw new Error("Response did not include " + queryName + ".\n        " + JSON.stringify(graphqlResponse, null, 2));
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", {
                success: false,
                error: _context.t0.message,
                data: null
              });
            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 21]]);
    }));
    function request(_x) {
      return _request.apply(this, arguments);
    }
    return request;
  }();
  _proto.requestCollectionEntries = /* @__PURE__ */ function() {
    var _requestCollectionEntries = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(options2) {
      var params, query, queryName, key, cursor, collectionEntryId, handle, startAfterEntryId, _params$maxReturnedEn, maxReturnedEntries, locale, advancedOptions, _params$edgesToNodes, edgesToNodes, isDeprecatedQuery, entriesFirst, entriesAfter, allEntries, keepFetching, response, collection, entries, edges, _collection, _entries, pageInfo, collectionEdges, hasNextPage, items;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = options2.params, query = options2.query, queryName = options2.queryName, key = options2.key;
              cursor = params.cursor, collectionEntryId = params.collectionEntryId, handle = params.handle, startAfterEntryId = params.startAfterEntryId, _params$maxReturnedEn = params.maxReturnedEntries, maxReturnedEntries = _params$maxReturnedEn === void 0 ? DEFAULT_MAX_ENTRIES_PER_COLLECTION : _params$maxReturnedEn, locale = params.locale, advancedOptions = params.advancedOptions, _params$edgesToNodes = params.edgesToNodes, edgesToNodes = _params$edgesToNodes === void 0 ? true : _params$edgesToNodes;
              if (collectionEntryId && handle) {
                console.warn("You have supplied both a collectionEntryId and handle. This method will use collectionEntryId for querying.");
              }
              if (!(!collectionEntryId && !handle)) {
                _context2.next = 5;
                break;
              }
              throw new Error("You must provide either a collectionEntryId or handle.");
            case 5:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              if (isDeprecatedQuery) {
                console.warn("You are using the parameter, startAfterEntryId, for a deprecated \nStorefront API query, " + queryName + ". This method and query will still return \nresults, but you will have better improved results and pagination support \nusing the parameter, cursor, instead.");
              }
              entriesFirst = Math.min.apply(Math, [(advancedOptions == null ? void 0 : advancedOptions.entriesPerPage) || DEFAULT_MAX_ENTRIES_PER_COLLECTION, maxReturnedEntries].filter(function(v) {
                return v > 0;
              }));
              entriesAfter = isDeprecatedQuery ? startAfterEntryId : cursor;
              allEntries = [];
              keepFetching = false;
            case 11:
              _context2.next = 13;
              return this.request({
                query,
                queryName,
                variables: _extends({
                  filter: _extends({}, collectionEntryId && {
                    nacelleEntryIds: [collectionEntryId]
                  }, !collectionEntryId && handle ? {
                    handles: [handle]
                  } : {}, locale ? {
                    locale
                  } : {
                    locale: this.locale
                  }),
                  entriesFirst
                }, entriesAfter && {
                  entriesAfter
                })
              });
            case 13:
              response = _context2.sent;
              if (!(response.success && response.data)) {
                _context2.next = 18;
                break;
              }
              if (isDeprecatedQuery) {
                collection = response.data[0];
                entries = collection[key];
                if (entries) {
                  allEntries = allEntries.concat(entries);
                  entriesAfter = entries.length > 0 ? entries[entries.length - 1].nacelleEntryId : void 0;
                  keepFetching = keepFetchingItems(entries, allEntries, maxReturnedEntries);
                }
              } else {
                edges = response.data.edges;
                if (edges.length === 0) {
                  console.warn("No collections matching query");
                } else {
                  _collection = nodesFromEdges(edges)[0];
                  _entries = _collection[key];
                  if (_entries) {
                    pageInfo = _entries.pageInfo, collectionEdges = _entries.edges;
                    hasNextPage = pageInfo.hasNextPage;
                    items = edgesToNodes ? nodesFromEdges(collectionEdges) : collectionEdges;
                    allEntries = allEntries.concat(items);
                    entriesAfter = lastEdgeCursor(collectionEdges);
                    keepFetching = keepFetchingItemsUsingNextPage(hasNextPage, allEntries, maxReturnedEntries);
                  }
                }
              }
              _context2.next = 19;
              break;
            case 18:
              throw new Error(response.error);
            case 19:
              if (keepFetching) {
                _context2.next = 11;
                break;
              }
            case 20:
              return _context2.abrupt("return", allEntries);
            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
    function requestCollectionEntries(_x2) {
      return _requestCollectionEntries.apply(this, arguments);
    }
    return requestCollectionEntries;
  }();
  _proto.getEntriesFromResponse = function getEntriesFromResponse(responseData, isDeprecatedQuery, edgesToNodes) {
    if (isDeprecatedQuery) {
      return responseData;
    }
    var edges = responseData.edges;
    return edgesToNodes ? nodesFromEdges(edges) : edges;
  };
  _proto.calculateFilterFromChunk = function calculateFilterFromChunk(chunk, filterArgs) {
    var _ref;
    filterArgs.first = chunk.values.length;
    var parameterFilterValues = filterArgs.first > 0 ? (_ref = {}, _ref[chunk.filterName] = chunk.values, _ref) : {};
    return _extends({}, filterArgs, parameterFilterValues);
  };
  _proto.requestEntriesByFilter = /* @__PURE__ */ function() {
    var _requestEntriesByFilter = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3(requestEntriesByFilterParams) {
      var queryParams, limitParams, chunkParams, filterArgs, filterValues, query, queryName, edgesToNodes, isDeprecatedQuery, isCollectionQuery, maxReturnedEntries, maxReturnedEntriesPerCollection, chunkSize, chunkFilterName, allEntries, processedChunks, shouldKeepFetching, currentChunkSize, currentChunkParameters, chunkedParameters, targetEntriesLength, filter, response, entries, shouldKeepProcessingChunks, shouldKeepSearchingEntries, remainingFilterValues;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              queryParams = requestEntriesByFilterParams.queryParams, limitParams = requestEntriesByFilterParams.limitParams, chunkParams = requestEntriesByFilterParams.chunkParams, filterArgs = requestEntriesByFilterParams.filterArgs, filterValues = requestEntriesByFilterParams.filterValues;
              if (!(filterValues.length === 0)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return", []);
            case 3:
              query = queryParams.query, queryName = queryParams.queryName, edgesToNodes = queryParams.edgesToNodes, isDeprecatedQuery = queryParams.isDeprecatedQuery, isCollectionQuery = queryParams.isCollectionQuery;
              maxReturnedEntries = limitParams.maxReturnedEntries, maxReturnedEntriesPerCollection = limitParams.maxReturnedEntriesPerCollection;
              chunkSize = chunkParams.chunkSize, chunkFilterName = chunkParams.chunkFilterName;
              allEntries = [];
              processedChunks = 0;
              shouldKeepFetching = true;
              currentChunkSize = chunkSize;
              chunkedParameters = buildChunks(currentChunkSize, chunkFilterName, filterValues, maxReturnedEntries);
              targetEntriesLength = maxReturnedEntries < 0 || maxReturnedEntries > filterValues.length ? filterValues.length : maxReturnedEntries;
            case 12:
              currentChunkParameters = chunkedParameters[processedChunks];
              filter = this.calculateFilterFromChunk(currentChunkParameters, filterArgs);
              _context3.next = 16;
              return this.request({
                query,
                queryName,
                variables: _extends({
                  filter
                }, isCollectionQuery && {
                  maxReturnedEntriesPerCollection
                })
              });
            case 16:
              response = _context3.sent;
              if (response.success && response.data) {
                entries = this.getEntriesFromResponse(response.data, isDeprecatedQuery, edgesToNodes);
                allEntries = allEntries.concat(entries);
                processedChunks++;
                shouldKeepProcessingChunks = chunkedParameters.length > processedChunks;
                shouldKeepSearchingEntries = allEntries.length < targetEntriesLength;
                shouldKeepFetching = shouldKeepProcessingChunks && shouldKeepSearchingEntries;
              } else {
                currentChunkSize = handleFailedResponse(currentChunkSize, response.error);
                processedChunks = 0;
                remainingFilterValues = filterValues.slice(allEntries.length);
                chunkedParameters = buildChunks(currentChunkSize, chunkFilterName, remainingFilterValues, maxReturnedEntries);
              }
            case 18:
              if (shouldKeepFetching) {
                _context3.next = 12;
                break;
              }
            case 19:
              return _context3.abrupt("return", allEntries);
            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
    function requestEntriesByFilter(_x3) {
      return _requestEntriesByFilter.apply(this, arguments);
    }
    return requestEntriesByFilter;
  }();
  _proto.requestEntriesByNacelleEntryIds = /* @__PURE__ */ function() {
    var _requestEntriesByNacelleEntryIds = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee4(queryParams, limitParams, filterArgs, chunkSize, nacelleEntryIds) {
      var chunkParamsByIds, requestEntriesByNacelleEntryIdsParams;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              chunkParamsByIds = {
                chunkSize,
                chunkFilterName: ChunkFilterName.NACELLE_ENTRY_ID
              };
              requestEntriesByNacelleEntryIdsParams = {
                queryParams,
                limitParams,
                filterArgs,
                chunkParams: chunkParamsByIds,
                filterValues: nacelleEntryIds || []
              };
              return _context4.abrupt("return", this.requestEntriesByFilter(requestEntriesByNacelleEntryIdsParams));
            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));
    function requestEntriesByNacelleEntryIds(_x4, _x5, _x6, _x7, _x8) {
      return _requestEntriesByNacelleEntryIds.apply(this, arguments);
    }
    return requestEntriesByNacelleEntryIds;
  }();
  _proto.requestEntriesByHandles = /* @__PURE__ */ function() {
    var _requestEntriesByHandles = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee5(queryParams, limitParams, filterArgs, chunkSize, handles) {
      var chunkParamsByHandles, requestEntriesByHandlesParams;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              chunkParamsByHandles = {
                chunkSize,
                chunkFilterName: ChunkFilterName.HANDLES
              };
              requestEntriesByHandlesParams = {
                queryParams,
                limitParams,
                filterArgs,
                chunkParams: chunkParamsByHandles,
                filterValues: handles || []
              };
              return _context5.abrupt("return", this.requestEntriesByFilter(requestEntriesByHandlesParams));
            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));
    function requestEntriesByHandles(_x9, _x10, _x11, _x12, _x13) {
      return _requestEntriesByHandles.apply(this, arguments);
    }
    return requestEntriesByHandles;
  }();
  _proto.requestEntriesByPagination = /* @__PURE__ */ function() {
    var _requestEntriesByPagination = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee6(queryParams, limitParams, filterArgs) {
      var query, queryName, edgesToNodes, isDeprecatedQuery, isCollectionQuery, maxReturnedEntries, maxReturnedEntriesPerCollection, nextAfter, keepFetching, allEntries, variables, response, entries, _response$data, pageInfo, edges, hasNextPage, _entries2;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              query = queryParams.query, queryName = queryParams.queryName, edgesToNodes = queryParams.edgesToNodes, isDeprecatedQuery = queryParams.isDeprecatedQuery, isCollectionQuery = queryParams.isCollectionQuery;
              maxReturnedEntries = limitParams.maxReturnedEntries, maxReturnedEntriesPerCollection = limitParams.maxReturnedEntriesPerCollection;
              nextAfter = filterArgs.after;
              keepFetching = true;
              allEntries = [];
            case 5:
              variables = _extends({
                filter: _extends({}, filterArgs, {
                  after: nextAfter
                })
              }, isCollectionQuery && {
                maxReturnedEntriesPerCollection
              });
              _context6.next = 8;
              return this.request({
                query,
                queryName,
                variables
              });
            case 8:
              response = _context6.sent;
              if (response.success && response.data) {
                if (isDeprecatedQuery) {
                  entries = response.data;
                  allEntries = allEntries.concat(entries);
                  nextAfter = entries.length > 0 ? entries[entries.length - 1].nacelleEntryId : void 0;
                  keepFetching = keepFetchingItems(entries, allEntries, maxReturnedEntries);
                } else {
                  _response$data = response.data, pageInfo = _response$data.pageInfo, edges = _response$data.edges;
                  hasNextPage = pageInfo.hasNextPage;
                  _entries2 = edgesToNodes ? nodesFromEdges(edges) : edges;
                  allEntries = allEntries.concat(_entries2);
                  nextAfter = lastEdgeCursor(edges);
                  keepFetching = keepFetchingItemsUsingNextPage(hasNextPage, allEntries, maxReturnedEntries);
                }
              } else {
                filterArgs.first = handleFailedResponse(filterArgs.first, response.error);
              }
            case 10:
              if (keepFetching) {
                _context6.next = 5;
                break;
              }
            case 11:
              return _context6.abrupt("return", maxReturnedEntries > -1 ? allEntries.slice(0, maxReturnedEntries) : allEntries);
            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));
    function requestEntriesByPagination(_x14, _x15, _x16) {
      return _requestEntriesByPagination.apply(this, arguments);
    }
    return requestEntriesByPagination;
  }();
  _proto.requestEntries = /* @__PURE__ */ function() {
    var _requestEntries = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee7(query, queryName, params) {
      var _advancedOptions$entr;
      var _ref2, cursor, startAfterEntryId, nacelleEntryIds, handles, locale, _ref2$maxReturnedEntr, maxReturnedEntries, advancedOptions, _ref2$edgesToNodes, edgesToNodes, addlParams, _ref3, _ref3$maxReturnedEntr, maxReturnedEntriesPerCollection, isCollectionQuery, isDeprecatedQuery, nextAfter, first, filterArgs, chunkSize, queryParams, limitParams;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _ref2 = params || {}, cursor = _ref2.cursor, startAfterEntryId = _ref2.startAfterEntryId, nacelleEntryIds = _ref2.nacelleEntryIds, handles = _ref2.handles, locale = _ref2.locale, _ref2$maxReturnedEntr = _ref2.maxReturnedEntries, maxReturnedEntries = _ref2$maxReturnedEntr === void 0 ? DEFAULT_MAX_ENTRIES : _ref2$maxReturnedEntr, advancedOptions = _ref2.advancedOptions, _ref2$edgesToNodes = _ref2.edgesToNodes, edgesToNodes = _ref2$edgesToNodes === void 0 ? true : _ref2$edgesToNodes, addlParams = _objectWithoutPropertiesLoose(_ref2, _excluded);
              _ref3 = params || {}, _ref3$maxReturnedEntr = _ref3.maxReturnedEntriesPerCollection, maxReturnedEntriesPerCollection = _ref3$maxReturnedEntr === void 0 ? DEFAULT_MAX_ENTRIES_PER_COLLECTION : _ref3$maxReturnedEntr;
              isCollectionQuery = ["productCollections", "contentCollections", "allProductCollections", "allContentCollections"].includes(queryName);
              isDeprecatedQuery = checkDeprecatedQuery(params);
              if (isDeprecatedQuery) {
                console.warn("You are using the parameter, startAfterEntryId, for a deprecated \nStorefront API query, " + queryName + ". This method and query will still return \nresults, but you will have better improved results and pagination support \nusing the parameter, cursor, instead.");
              }
              if (addlParams.maxReturnedEntriesPerCollection) {
                delete addlParams.maxReturnedEntriesPerCollection;
              }
              nextAfter = isDeprecatedQuery ? startAfterEntryId : cursor;
              first = Math.min.apply(Math, [(advancedOptions == null ? void 0 : advancedOptions.entriesPerPage) || DEFAULT_PAGE_FETCH_LIMIT, maxReturnedEntries].filter(function(v) {
                return v > 0;
              }));
              filterArgs = _extends({
                first,
                after: nextAfter
              }, locale ? {
                locale
              } : {
                locale: this.locale
              }, addlParams);
              chunkSize = (_advancedOptions$entr = advancedOptions == null ? void 0 : advancedOptions.entriesPerPage) != null ? _advancedOptions$entr : DEFAULT_PAGE_FETCH_LIMIT;
              queryParams = {
                query,
                queryName,
                isDeprecatedQuery,
                isCollectionQuery,
                edgesToNodes
              };
              limitParams = {
                maxReturnedEntries,
                maxReturnedEntriesPerCollection
              };
              if (nacelleEntryIds && handles) {
                console.warn("You have supplied both a nacelleEntryIds and handles. This method will use nacelleEntryIds for querying.");
              }
              if (!nacelleEntryIds) {
                _context7.next = 15;
                break;
              }
              return _context7.abrupt("return", this.requestEntriesByNacelleEntryIds(queryParams, limitParams, filterArgs, chunkSize, nacelleEntryIds));
            case 15:
              if (!handles) {
                _context7.next = 17;
                break;
              }
              return _context7.abrupt("return", this.requestEntriesByHandles(queryParams, limitParams, filterArgs, chunkSize, handles));
            case 17:
              return _context7.abrupt("return", this.requestEntriesByPagination(queryParams, limitParams, filterArgs));
            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));
    function requestEntries(_x17, _x18, _x19) {
      return _requestEntries.apply(this, arguments);
    }
    return requestEntries;
  }();
  _proto.products = /* @__PURE__ */ function() {
    var _products = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee8(params) {
      var isDeprecatedQuery, query, queryName;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? productsQuery : allProductsQuery;
              queryName = isDeprecatedQuery ? "products" : "allProducts";
              return _context8.abrupt("return", this.requestEntries(query, queryName, params));
            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));
    function products(_x20) {
      return _products.apply(this, arguments);
    }
    return products;
  }();
  _proto.productCollections = /* @__PURE__ */ function() {
    var _productCollections = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee9(params) {
      var _ref4, _ref4$edgesToNodes, edgesToNodes, _ref4$advancedOptions, advancedOptions, isDeprecatedQuery, query, queryName, collections;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _ref4 = params || {}, _ref4$edgesToNodes = _ref4.edgesToNodes, edgesToNodes = _ref4$edgesToNodes === void 0 ? true : _ref4$edgesToNodes, _ref4$advancedOptions = _ref4.advancedOptions, advancedOptions = _ref4$advancedOptions === void 0 ? {} : _ref4$advancedOptions;
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? productCollectionsQuery : allProductCollectionsQuery$1;
              queryName = isDeprecatedQuery ? "productCollections" : "allProductCollections";
              if (typeof advancedOptions.entriesPerPage === "undefined") {
                advancedOptions.entriesPerPage = DEFAULT_COLLECTION_PAGE_FETCH_LIMIT;
              }
              if (advancedOptions.entriesPerPage > 100) {
                console.warn("You have set the `entriesPerPage` option to a high value. We recommended keeping this value small for collections to avoid issues.");
              }
              _context9.next = 8;
              return this.requestEntries(query, queryName, _extends({}, params, {
                advancedOptions
              }));
            case 8:
              collections = _context9.sent;
              if (!isDeprecatedQuery) {
                _context9.next = 11;
                break;
              }
              return _context9.abrupt("return", collections);
            case 11:
              if (!edgesToNodes) {
                _context9.next = 13;
                break;
              }
              return _context9.abrupt("return", collections.map(function(collection) {
                return mapCollectionConnectionToArray(collection, "productConnection", "products");
              }));
            case 13:
              return _context9.abrupt("return", collections.map(function(edge) {
                return _extends({}, edge, {
                  node: mapCollectionConnectionToArray(edge.node, "productConnection", "products")
                });
              }));
            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));
    function productCollections(_x21) {
      return _productCollections.apply(this, arguments);
    }
    return productCollections;
  }();
  _proto.content = /* @__PURE__ */ function() {
    var _content = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee10(params) {
      var _params$entryDepth;
      var isDeprecatedQuery, query, queryName;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? contentQuery : allContentQuery;
              if (Number((_params$entryDepth = params == null ? void 0 : params.entryDepth) != null ? _params$entryDepth : 0) > ENTRY_DEPTH_PARAM_WARNING_LIMIT) {
                console.warn('SDK performance could be affected using "entryDepth" parameter greater than ' + ENTRY_DEPTH_PARAM_WARNING_LIMIT + ". Consider using a lower value when possible");
              }
              queryName = isDeprecatedQuery ? "content" : "allContent";
              return _context10.abrupt("return", this.requestEntries(query, queryName, params));
            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));
    function content2(_x22) {
      return _content.apply(this, arguments);
    }
    return content2;
  }();
  _proto.contentCollections = /* @__PURE__ */ function() {
    var _contentCollections = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee11(params) {
      var _ref5, _ref5$edgesToNodes, edgesToNodes, isDeprecatedQuery, query, queryName, collections;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _ref5 = params || {}, _ref5$edgesToNodes = _ref5.edgesToNodes, edgesToNodes = _ref5$edgesToNodes === void 0 ? true : _ref5$edgesToNodes;
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? contentCollectionsQuery : allContentCollectionsQuery;
              queryName = isDeprecatedQuery ? "contentCollections" : "allContentCollections";
              _context11.next = 6;
              return this.requestEntries(query, queryName, params);
            case 6:
              collections = _context11.sent;
              if (!isDeprecatedQuery) {
                _context11.next = 9;
                break;
              }
              return _context11.abrupt("return", collections);
            case 9:
              if (!edgesToNodes) {
                _context11.next = 11;
                break;
              }
              return _context11.abrupt("return", collections.map(function(collection) {
                return mapCollectionConnectionToArray(collection, "contentConnection", "entries");
              }));
            case 11:
              return _context11.abrupt("return", collections.map(function(edge) {
                return _extends({}, edge, {
                  node: mapCollectionConnectionToArray(edge.node, "contentConnection", "entries")
                });
              }));
            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));
    function contentCollections(_x23) {
      return _contentCollections.apply(this, arguments);
    }
    return contentCollections;
  }();
  _proto.navigation = /* @__PURE__ */ function() {
    var _navigation2 = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee12(params) {
      var requestParams, response;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              requestParams = {
                query: navigation,
                queryName: "navigation"
              };
              if (params) {
                requestParams.variables = {
                  filter: params
                };
              }
              _context12.next = 4;
              return this.request(requestParams);
            case 4:
              response = _context12.sent;
              if (!(response.success && response.data)) {
                _context12.next = 7;
                break;
              }
              return _context12.abrupt("return", response.data);
            case 7:
              throw new Error(response.error);
            case 8:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));
    function navigation$1(_x24) {
      return _navigation2.apply(this, arguments);
    }
    return navigation$1;
  }();
  _proto.query = /* @__PURE__ */ function() {
    var _query = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee13(params) {
      var query2, variables, response;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              query2 = params.query, variables = params.variables;
              _context13.next = 3;
              return this.request({
                query: query2,
                variables
              });
            case 3:
              response = _context13.sent;
              if (!(response.success && response.data)) {
                _context13.next = 6;
                break;
              }
              return _context13.abrupt("return", response.data);
            case 6:
              throw new Error(response.error);
            case 7:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));
    function query(_x25) {
      return _query.apply(this, arguments);
    }
    return query;
  }();
  _proto.setConfig = function setConfig(setConfigParams) {
    var _this$httpClient$opti;
    if (!((_this$httpClient$opti = this.httpClient.options) != null && _this$httpClient$opti.headers)) {
      throw new Error("[setConfig]: http client is missing headers.");
    }
    var currentEndpoint = new URL(this.endpoint);
    var previewTokenHeader = X_NACELLE_PREVIEW_TOKEN;
    if (setConfigParams.previewToken) {
      this.previewToken = setConfigParams.previewToken;
      currentEndpoint.searchParams.set("preview", "true");
      this.httpClient.options.headers[previewTokenHeader] = this.previewToken;
    } else {
      this.previewToken = void 0;
      currentEndpoint.searchParams["delete"]("preview");
      delete this.httpClient.options.headers[previewTokenHeader];
    }
    this.endpoint = currentEndpoint.toString();
    return {
      endpoint: this.endpoint,
      previewToken: this.previewToken
    };
  };
  _proto.spaceProperties = /* @__PURE__ */ function() {
    var _spaceProperties2 = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee14() {
      var response;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.request({
                query: spaceQuery,
                queryName: "spaceProperties"
              });
            case 2:
              response = _context14.sent;
              if (!(response.success && response.data)) {
                _context14.next = 5;
                break;
              }
              return _context14.abrupt("return", response.data);
            case 5:
              throw new Error(response.error);
            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));
    function spaceProperties() {
      return _spaceProperties2.apply(this, arguments);
    }
    return spaceProperties;
  }();
  _proto.productCollectionEntries = /* @__PURE__ */ function() {
    var _productCollectionEntries = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee15(params) {
      var isDeprecatedQuery, query, queryName, key;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? productCollectionEntriesQuery : allProductCollectionEntriesQuery;
              queryName = isDeprecatedQuery ? "productCollections" : "allProductCollections";
              key = isDeprecatedQuery ? "products" : "productConnection";
              return _context15.abrupt("return", this.requestCollectionEntries({
                query,
                queryName,
                key,
                params
              }));
            case 5:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));
    function productCollectionEntries(_x26) {
      return _productCollectionEntries.apply(this, arguments);
    }
    return productCollectionEntries;
  }();
  _proto.contentCollectionEntries = /* @__PURE__ */ function() {
    var _contentCollectionEntries = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee16(params) {
      var isDeprecatedQuery, query, queryName, key;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              isDeprecatedQuery = checkDeprecatedQuery(params);
              query = isDeprecatedQuery ? contentCollectionEntriesQuery : allContentCollectionEntriesQuery;
              queryName = isDeprecatedQuery ? "contentCollections" : "allContentCollections";
              key = isDeprecatedQuery ? "entries" : "contentConnection";
              return _context16.abrupt("return", this.requestCollectionEntries({
                query,
                queryName,
                key,
                params
              }));
            case 5:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));
    function contentCollectionEntries(_x27) {
      return _contentCollectionEntries.apply(this, arguments);
    }
    return contentCollectionEntries;
  }();
  return StorefrontConnector2;
}();
var SubscriptionConnector = function SubscriptionConnector2(params) {
  var _this = this;
  this.token = void 0;
  this.endpoint = void 0;
  this.wsClient = void 0;
  this.client = void 0;
  this.debugMode = void 0;
  this.productInventoryItems = /* @__PURE__ */ function() {
    var _ref = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(nacelleEntryIds) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.client) {
                _context.next = 2;
                break;
              }
              throw new Error("No wsClient");
            case 2:
              _context.next = 4;
              return _this.client.query(productInventoryQuery, {
                filter: {
                  nacelleEntryIds
                }
              }).toPromise();
            case 4:
              return _context.abrupt("return", _context.sent);
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  this.productVariantInventoryItems = /* @__PURE__ */ function() {
    var _ref2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(nacelleEntryIds) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.wsClient) {
                _context2.next = 2;
                break;
              }
              throw new Error("No wsClient");
            case 2:
              _context2.next = 4;
              return _this.client.query(productVariantInventoryQuery, {
                filter: {
                  nacelleEntryIds
                }
              }).toPromise();
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  this.subscribeToProductUpdate = function(observable, nacelleEntryIds) {
    if (!_this.wsClient) {
      throw new Error("No wsClient");
    }
    try {
      var _pipe = pipe(_this.wsClient.subscription(productSubscription, {
        productInventoryUpdatedFilter: {
          nacelleEntryIds
        }
      }), N(function(result) {
        if (result.error) {
          observable.onError(result);
        } else {
          observable.onNext(result);
        }
      })), unsubscribe = _pipe.unsubscribe;
      return unsubscribe;
    } catch (err) {
      observable.onError(err);
      return function() {
      };
    }
  };
  this.subscribeToProductVariantUpdate = function(observable, nacelleEntryIds) {
    if (!_this.wsClient) {
      throw new Error("No wsClient");
    }
    try {
      var _pipe2 = pipe(_this.wsClient.subscription(productVariantSubscription, {
        variantInventoryUpdatedFilter: {
          nacelleEntryIds
        }
      }), N(function(result) {
        if (result.error) {
          observable.onError(result);
        } else {
          observable.onNext(result);
        }
      })), unsubscribe = _pipe2.unsubscribe;
      return unsubscribe;
    } catch (err) {
      observable.onError(err);
      return function() {
      };
    }
  };
  this.endpoint = params.endpoint;
  this.token = params.token;
  this.debugMode = params.debugMode || false;
  if (this.debugMode) {
    console.info("credentials:", {
      endpoint: this.endpoint,
      token: this.token
    });
  }
  var headers = {
    "x-nacelle-tether-access-token": this.token
  };
  var subscriptionClient = createClient({
    url: this.endpoint,
    connectionParams: headers,
    isFatalConnectionProblem: function isFatalConnectionProblem(errOrCloseEvent) {
      var typeObj = errOrCloseEvent;
      if (typeObj.code === 4403) {
        console.error("Websocket server rejecting auth, check headers for correct x-nacelle-tether-access-token");
        return true;
      }
      return false;
    }
  });
  this.client = params.client || W({
    url: convertWsToHttp(this.endpoint)
  });
  this.wsClient = params.wsClient || W({
    url: this.endpoint,
    exchanges: [].concat(L, [subscriptionExchange({
      forwardSubscription: function forwardSubscription(operation) {
        return {
          subscribe: function subscribe(sink) {
            var dispose = subscriptionClient.subscribe(operation, sink);
            return {
              unsubscribe: dispose
            };
          }
        };
      }
    })])
  });
};
function Storefront(params) {
  if (typeof params.token === "undefined" || params.token.length === 0) {
    throw new Error("Nacelle space token is required.");
  }
  if (typeof params.storefrontEndpoint === "undefined" || params.storefrontEndpoint.length === 0) {
    throw new Error("Nacelle endpoint is required");
  }
  var locale = params.locale || "en-US";
  var debugMode = typeof params.debugMode !== "undefined" ? params.debugMode : false;
  if (debugMode) {
    console.info("\u{1F64C}  Storefront Debug Mode Unlocked! \u{1F64C}");
  }
  var connector = params.connector || new StorefrontConnector({
    token: params.token,
    previewToken: params.previewToken,
    endpoint: params.storefrontEndpoint,
    locale,
    debugMode
  });
  var subscriptionConnector = void 0;
  if (params.subscriptionToken && params.subscriptionEndpoint && typeof window !== "undefined") {
    subscriptionConnector = new SubscriptionConnector({
      token: params.subscriptionToken || "",
      endpoint: params.subscriptionEndpoint || "",
      debugMode
    });
  }
  function initializeSubscriptionConnector() {
    if (!subscriptionConnector && params.subscriptionToken && params.subscriptionEndpoint && typeof window !== "undefined") {
      subscriptionConnector = new SubscriptionConnector({
        token: params.subscriptionToken || "",
        endpoint: params.subscriptionEndpoint || "",
        debugMode
      });
    }
  }
  var currencyCode = params.currencyCode || "USD";
  var onDataError = params.onDataError || null;
  var afterSubscriptions = [];
  function applyAfter(_x, _x2) {
    return _applyAfter.apply(this, arguments);
  }
  function _applyAfter() {
    _applyAfter = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee12(method, responseObj) {
      var response, subs, _iterator, _step, sub;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              response = responseObj;
              subs = afterSubscriptions.filter(function(sub2) {
                return sub2.method === method;
              });
              _iterator = _createForOfIteratorHelperLoose(subs);
            case 3:
              if ((_step = _iterator()).done) {
                _context12.next = 10;
                break;
              }
              sub = _step.value;
              _context12.next = 7;
              return sub.callback(response);
            case 7:
              response = _context12.sent;
            case 8:
              _context12.next = 3;
              break;
            case 10:
              return _context12.abrupt("return", response);
            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    return _applyAfter.apply(this, arguments);
  }
  return {
    getConfig: function getConfig() {
      return {
        token: connector.token,
        storefrontEndpoint: connector.endpoint,
        previewToken: connector.previewToken,
        locale,
        currencyCode,
        afterSubscriptions
      };
    },
    products: function() {
      var _products = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(productsParams) {
        var _products2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return connector.products(productsParams);
              case 3:
                _products2 = _context.sent;
                return _context.abrupt("return", applyAfter("products", _products2));
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                if (!onDataError) {
                  _context.next = 11;
                  break;
                }
                return _context.abrupt("return", onDataError({
                  method: "products",
                  params: productsParams || null,
                  error: _context.t0
                }));
              case 11:
                throw _context.t0;
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
      function products(_x3) {
        return _products.apply(this, arguments);
      }
      return products;
    }(),
    productCollections: function() {
      var _productCollections = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(productCollectionsParams) {
        var _productCollections2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.info("storefront client, productCollections");
                _context2.prev = 1;
                _context2.next = 4;
                return connector.productCollections(productCollectionsParams);
              case 4:
                _productCollections2 = _context2.sent;
                return _context2.abrupt("return", applyAfter("productCollections", _productCollections2));
              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                if (!onDataError) {
                  _context2.next = 12;
                  break;
                }
                return _context2.abrupt("return", onDataError({
                  method: "productCollections",
                  params: productCollectionsParams || null,
                  error: _context2.t0
                }));
              case 12:
                throw _context2.t0;
              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));
      function productCollections(_x4) {
        return _productCollections.apply(this, arguments);
      }
      return productCollections;
    }(),
    productCollectionEntries: function() {
      var _productCollectionEntries = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3(collectionEntriesParams) {
        var products;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.info("storefront client, productCollectionEntries");
                _context3.prev = 1;
                _context3.next = 4;
                return connector.productCollectionEntries(collectionEntriesParams);
              case 4:
                products = _context3.sent;
                return _context3.abrupt("return", applyAfter("productCollectionEntries", products));
              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                if (!onDataError) {
                  _context3.next = 12;
                  break;
                }
                return _context3.abrupt("return", onDataError({
                  method: "productCollectionEntries",
                  params: collectionEntriesParams || null,
                  error: _context3.t0
                }));
              case 12:
                throw _context3.t0;
              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }));
      function productCollectionEntries(_x5) {
        return _productCollectionEntries.apply(this, arguments);
      }
      return productCollectionEntries;
    }(),
    contentCollectionEntries: function() {
      var _contentCollectionEntries = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee4(collectionEntriesParams) {
        var entries;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.info("storefront client, contentCollectionEntries");
                _context4.prev = 1;
                _context4.next = 4;
                return connector.contentCollectionEntries(collectionEntriesParams);
              case 4:
                entries = _context4.sent;
                return _context4.abrupt("return", applyAfter("contentCollectionEntries", entries));
              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);
                if (!onDataError) {
                  _context4.next = 12;
                  break;
                }
                return _context4.abrupt("return", onDataError({
                  method: "contentCollectionEntries",
                  params: collectionEntriesParams || null,
                  error: _context4.t0
                }));
              case 12:
                throw _context4.t0;
              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 8]]);
      }));
      function contentCollectionEntries(_x6) {
        return _contentCollectionEntries.apply(this, arguments);
      }
      return contentCollectionEntries;
    }(),
    content: function() {
      var _content = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee5(contentParams) {
        var _content2;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return connector.content(contentParams);
              case 3:
                _content2 = _context5.sent;
                return _context5.abrupt("return", applyAfter("content", _content2));
              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                if (!onDataError) {
                  _context5.next = 11;
                  break;
                }
                return _context5.abrupt("return", onDataError({
                  method: "content",
                  params: contentParams || null,
                  error: _context5.t0
                }));
              case 11:
                throw _context5.t0;
              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 7]]);
      }));
      function content2(_x7) {
        return _content.apply(this, arguments);
      }
      return content2;
    }(),
    contentCollections: function() {
      var _contentCollections = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee6(contentCollectionsParams) {
        var _contentCollections2;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return connector.contentCollections(contentCollectionsParams);
              case 3:
                _contentCollections2 = _context6.sent;
                return _context6.abrupt("return", applyAfter("contentCollections", _contentCollections2));
              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                if (!onDataError) {
                  _context6.next = 11;
                  break;
                }
                return _context6.abrupt("return", onDataError({
                  method: "contentCollections",
                  params: contentCollectionsParams || null,
                  error: _context6.t0
                }));
              case 11:
                throw _context6.t0;
              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 7]]);
      }));
      function contentCollections(_x8) {
        return _contentCollections.apply(this, arguments);
      }
      return contentCollections;
    }(),
    productInventoryItems: function() {
      var _productInventoryItems = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee7(nacelleEntryIds) {
        var _subscriptionConnecto;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                initializeSubscriptionConnector();
                if (subscriptionConnector) {
                  _context7.next = 4;
                  break;
                }
                throw Error(MISSING_SUB_PARAM_MSG);
              case 4:
                _context7.next = 6;
                return (_subscriptionConnecto = subscriptionConnector) == null ? void 0 : _subscriptionConnecto.productInventoryItems(nacelleEntryIds);
              case 6:
                return _context7.abrupt("return", _context7.sent);
              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);
                if (!onDataError) {
                  _context7.next = 13;
                  break;
                }
                return _context7.abrupt("return", onDataError({
                  method: "productInventoryItems",
                  params: {
                    nacelleEntryIds
                  },
                  error: _context7.t0
                }));
              case 13:
                throw _context7.t0;
              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 9]]);
      }));
      function productInventoryItems(_x9) {
        return _productInventoryItems.apply(this, arguments);
      }
      return productInventoryItems;
    }(),
    productVariantInventoryItems: function() {
      var _productVariantInventoryItems = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee8(nacelleEntryIds) {
        var _subscriptionConnecto2;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                initializeSubscriptionConnector();
                if (subscriptionConnector) {
                  _context8.next = 4;
                  break;
                }
                throw Error(MISSING_SUB_PARAM_MSG);
              case 4:
                _context8.next = 6;
                return (_subscriptionConnecto2 = subscriptionConnector) == null ? void 0 : _subscriptionConnecto2.productVariantInventoryItems(nacelleEntryIds);
              case 6:
                return _context8.abrupt("return", _context8.sent);
              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);
                if (!onDataError) {
                  _context8.next = 13;
                  break;
                }
                return _context8.abrupt("return", onDataError({
                  method: "productVariantInventoryItems",
                  params: {
                    nacelleEntryIds
                  },
                  error: _context8.t0
                }));
              case 13:
                throw _context8.t0;
              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 9]]);
      }));
      function productVariantInventoryItems(_x10) {
        return _productVariantInventoryItems.apply(this, arguments);
      }
      return productVariantInventoryItems;
    }(),
    productSubscription: function productSubscription2(observable, nacelleEntryIds) {
      var _subscriptionConnecto3;
      if (typeof window === "undefined") {
        var msg = "productSubscription can only be called in a browser environment.";
        throw Error(msg);
      }
      initializeSubscriptionConnector();
      if (!subscriptionConnector) {
        throw Error(MISSING_SUB_PARAM_MSG);
      }
      return (_subscriptionConnecto3 = subscriptionConnector) == null ? void 0 : _subscriptionConnecto3.subscribeToProductUpdate(observable, nacelleEntryIds);
    },
    productVariantSubscription: function productVariantSubscription2(observable, nacelleEntryIds) {
      var _subscriptionConnecto4;
      if (typeof window === "undefined") {
        var msg = "productVariantSubscription can only be called in a browser environment.";
        throw Error(msg);
      }
      initializeSubscriptionConnector();
      if (!subscriptionConnector) {
        throw Error(MISSING_SUB_PARAM_MSG);
      }
      return (_subscriptionConnecto4 = subscriptionConnector) == null ? void 0 : _subscriptionConnecto4.subscribeToProductVariantUpdate(observable, nacelleEntryIds);
    },
    query: function() {
      var _query = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee9(queryParams) {
        var result;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return connector.query(queryParams);
              case 3:
                result = _context9.sent;
                return _context9.abrupt("return", applyAfter("query", result));
              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);
                if (!onDataError) {
                  _context9.next = 11;
                  break;
                }
                return _context9.abrupt("return", onDataError({
                  method: "query",
                  params: queryParams,
                  error: _context9.t0
                }));
              case 11:
                throw _context9.t0;
              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 7]]);
      }));
      function query(_x11) {
        return _query.apply(this, arguments);
      }
      return query;
    }(),
    navigation: function() {
      var _navigation = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee10(navigationParams) {
        var _navigation2;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return connector.navigation(navigationParams);
              case 3:
                _navigation2 = _context10.sent;
                return _context10.abrupt("return", applyAfter("navigation", _navigation2));
              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](0);
                if (!onDataError) {
                  _context10.next = 11;
                  break;
                }
                return _context10.abrupt("return", onDataError({
                  method: "navigation",
                  params: navigationParams || null,
                  error: _context10.t0
                }));
              case 11:
                throw _context10.t0;
              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 7]]);
      }));
      function navigation2(_x12) {
        return _navigation.apply(this, arguments);
      }
      return navigation2;
    }(),
    setConfig: function setConfig(setConfigParams) {
      return connector.setConfig(setConfigParams);
    },
    spaceProperties: function() {
      var _spaceProperties = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee11() {
        var _spaceProperties2;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return connector.spaceProperties();
              case 3:
                _spaceProperties2 = _context11.sent;
                return _context11.abrupt("return", applyAfter("spaceProperties", _spaceProperties2));
              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11["catch"](0);
                if (!onDataError) {
                  _context11.next = 11;
                  break;
                }
                return _context11.abrupt("return", onDataError({
                  method: "spaceProperties",
                  params: null,
                  error: _context11.t0
                }));
              case 11:
                throw _context11.t0;
              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 7]]);
      }));
      function spaceProperties() {
        return _spaceProperties.apply(this, arguments);
      }
      return spaceProperties;
    }(),
    after: function after(method, callback) {
      afterSubscriptions.push({
        method,
        callback
      });
    }
  };
}
function checkStorefrontSdkMethod(client, methodName) {
  if (typeof client[methodName] === "undefined") {
    throw new Error(
      `The provided 'params.client' does not have a '${methodName}' method. If using @nacelle/storefront-sdk@2.x major version 2, be sure to initialize the client with the Commerce Queries plugin before passing it to @nacelle/compatibility-connector.`
    );
  }
}
function transformSourceEntryId(sourceEntryId) {
  if (!sourceEntryId.startsWith("gid://shopify/")) {
    return sourceEntryId;
  }
  if (typeof window !== "undefined") {
    return self.btoa(sourceEntryId);
  }
  return Buffer.from(sourceEntryId).toString("base64");
}
function checkVariantAvailability({
  product: product2,
  variantId
}) {
  const targetVariant = product2.variants.find(
    (variant) => transformSourceEntryId(variant.sourceEntryId) === variantId
  );
  if (!targetVariant) {
    return false;
  }
  return typeof targetVariant.availableForSale === "boolean" && targetVariant.availableForSale;
}
function destructureNacelleEntryId(nacelleEntryId) {
  const decodedId = typeof window === "undefined" ? Buffer.from(nacelleEntryId, "base64").toString("ascii") : self.atob(nacelleEntryId);
  if (!decodedId.startsWith("id://")) {
    throw new Error(
      'Expected a `nacelleEntryId` starting with "id://", received: ' + decodedId
    );
  }
  const [, partsOfInterest] = decodedId.split("id://");
  const nacelleEntryIdParts = partsOfInterest.split("/");
  if (nacelleEntryIdParts.length !== 6) {
    throw new Error(
      "Expected nacelleEntryId to contain 6 properties: `sourceName`, `externalId`, `sourceSubset`, `dataType`, `sourceEntryId`, and `locale`. Instead, received:\n" + JSON.stringify(
        {
          sourceName: nacelleEntryIdParts[0],
          externalId: nacelleEntryIdParts[1],
          sourceSubset: nacelleEntryIdParts[2],
          dataType: nacelleEntryIdParts[3],
          sourceEntryId: nacelleEntryIdParts[4],
          locale: nacelleEntryIdParts[5]
        },
        null,
        2
      )
    );
  }
  const nacelleEntryIdProperties = {
    sourceName: nacelleEntryIdParts[0],
    externalId: nacelleEntryIdParts[1],
    sourceSubset: nacelleEntryIdParts[2],
    dataType: nacelleEntryIdParts[3],
    sourceEntryId: nacelleEntryIdParts[4],
    locale: nacelleEntryIdParts[5]
  };
  return nacelleEntryIdProperties;
}
const isV2SdkResponse = (response) => typeof response.data !== "undefined" || typeof response.error !== "undefined";
function graphqlQuery(query, variables, client) {
  return __async(this, null, function* () {
    const response = yield client.query({
      query,
      variables: typeof variables === "object" ? JSON.stringify(variables) : variables
    });
    if (isV2SdkResponse(response)) {
      const { data, error } = response;
      if (error) {
        throw new Error(error.message);
      }
      return data;
    } else {
      return response;
    }
  });
}
function sanitizeIntegerValue(input, defaultValue, minimum = Number.MIN_SAFE_INTEGER, maximum = Number.MAX_SAFE_INTEGER) {
  if (typeof input === "number" && Number.isInteger(input) && minimum <= input && input <= maximum) {
    return input;
  }
  return defaultValue;
}
function toIetfLocale(inputLocale, defaultLocale = "en-US") {
  if (!inputLocale)
    return defaultLocale;
  const [lang, region] = inputLocale.split("-");
  if (!region)
    return lang.toLowerCase();
  return lang.toLowerCase() + "-" + region.toUpperCase();
}
function toUnixTimestamp(input) {
  if (typeof input !== "string") {
    return input;
  }
  const jsTime = new Date(input).getTime();
  if (Number.isNaN(jsTime)) {
    return input;
  }
  return Math.floor(jsTime / 1e3);
}
const createArticleReferenceErrorMessage = (blogHandle, problematicArticles) => `In blog '${blogHandle}', articles with sourceEntryId: ${problematicArticles.join(
  ", "
)} are not valid. Please check your CMS to ensure that these articles are correctly referenced by the '${blogHandle}' blog.`;
function transformArticleLists(articlesInput, blogHandle, locale) {
  if (!articlesInput || !Array.isArray(articlesInput)) {
    return null;
  }
  const problematicArticles = [];
  const handles = articlesInput.map((article) => {
    if ("fields" in article && typeof article.fields !== "undefined") {
      return article.fields.handle;
    }
    const { sourceEntryId } = destructureNacelleEntryId(article.nacelleEntryId);
    problematicArticles.push(sourceEntryId);
    return "";
  });
  if (problematicArticles.length) {
    throw new Error(
      createArticleReferenceErrorMessage(blogHandle, problematicArticles)
    );
  }
  return [
    {
      handles,
      locale: toIetfLocale(locale),
      slug: "default",
      title: "default"
    }
  ];
}
const isContentfulMedia = (x) => typeof (x == null ? void 0 : x.sys) === "object" && x.sys.type === "Asset";
const isSanityMedia = (x) => typeof (x == null ? void 0 : x._type) === "string" && typeof (x == null ? void 0 : x.asset) === "object";
function flattenContentfulMedia(entry) {
  const { file = { url: "", contentType: "" }, description = "" } = entry.fields;
  const { url = "", contentType = "" } = file;
  const { id = "" } = entry.sys;
  return {
    id,
    src: url,
    thumbnailSrc: url,
    type: contentType,
    altText: description
  };
}
function flattenSanityMedia(media2) {
  const {
    asset: { assetId, mimeType, url },
    _type
  } = media2;
  let thumbnailSrc = url;
  if (_type === "image") {
    try {
      const imageUrl = new URL(url);
      if (!imageUrl.searchParams.has("w")) {
        imageUrl.searchParams.append("w", "100");
        thumbnailSrc = imageUrl.toString();
      }
    } catch (e) {
    }
  }
  return {
    id: assetId,
    src: url,
    thumbnailSrc,
    type: mimeType,
    altText: ""
  };
}
function getImageMimeType(extension) {
  const commonImageExtensions = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "svg",
    "webp",
    "avif"
  ];
  const isSupportedExtension = commonImageExtensions.indexOf(extension) !== -1;
  if (!isSupportedExtension) {
    return "";
  }
  switch (extension) {
    case "jpg": {
      return "image/jpeg";
    }
    case "svg": {
      return "image/svg+xml";
    }
    default: {
      return "image/" + extension;
    }
  }
}
function getVideoMimeType(extension) {
  const commonVideoExtensions = ["mp4", "mov", "mpeg", "webm"];
  const isSupportedExtension = commonVideoExtensions.indexOf(extension) !== -1;
  if (!isSupportedExtension) {
    return "";
  }
  if (extension === "mov") {
    return "video/quicktime";
  }
  return "video/" + extension;
}
function formatMedia(mediaInput, cms) {
  if (!cms || !mediaInput) {
    return mediaInput;
  }
  if (cms === "CONTENTFUL" && isContentfulMedia(mediaInput)) {
    return flattenContentfulMedia(mediaInput);
  } else if (cms === "SANITY" && isSanityMedia(mediaInput)) {
    return flattenSanityMedia(mediaInput);
  } else {
    return mediaInput;
  }
}
function transformMedia(mediaInput, cms) {
  var _a;
  if (!mediaInput || typeof mediaInput !== "object" || Array.isArray(mediaInput)) {
    return null;
  }
  const newMedia = {
    altText: null,
    id: null,
    src: "",
    thumbnailSrc: "",
    type: ""
  };
  const formattedMedia = (_a = formatMedia(mediaInput, cms)) != null ? _a : {};
  for (const [key, value] of Object.entries(formattedMedia)) {
    if (value) {
      switch (key) {
        case "id": {
          if (typeof value !== "object") {
            newMedia.id = value;
          }
          break;
        }
        case "type": {
          if (typeof value === "string") {
            newMedia.type = value.toLowerCase();
          }
          break;
        }
        default: {
          if (typeof value === "string") {
            newMedia[key] = value;
          }
        }
      }
    }
  }
  if (!newMedia.thumbnailSrc) {
    newMedia.thumbnailSrc = newMedia.src;
  }
  if (!newMedia.type) {
    let extension = "";
    try {
      const mediaUrl = new URL(newMedia.src);
      extension = mediaUrl.pathname.split(".").pop();
    } catch (e) {
    }
    if (extension) {
      const imageExtension = getImageMimeType(extension);
      const videoExtension = getVideoMimeType(extension);
      const mimeType = imageExtension || videoExtension;
      if (mimeType) {
        newMedia.type = mimeType;
      }
    }
  }
  return newMedia;
}
const isObject = (x) => Boolean(x) && typeof x === "object" && !Array.isArray(x);
const isNacelleContentEntry = (entry) => isObject(entry) && typeof entry.nacelleEntryId === "string" && typeof entry.type === "string" && typeof entry.fields === "object";
function applyContentTransformation(content2, transformers) {
  if (Array.isArray(content2)) {
    return content2.map(
      (entry) => applyContentTransformation(entry, transformers)
    );
  }
  if (isObject(content2)) {
    for (const property of Object.keys(content2)) {
      const key = property;
      if (isObject(content2[key]) || Array.isArray(content2[key])) {
        content2[key] = applyContentTransformation(
          content2[key],
          transformers
        );
      }
    }
    if (isNacelleContentEntry(content2) && transformers.entries) {
      return transformers.entries(content2);
    } else if (transformers.arbitraryContent) {
      return transformers.arbitraryContent(content2);
    }
  }
  return content2;
}
function applyCmsTransforms(data, cms) {
  switch (cms) {
    case "CONTENTFUL": {
      return applyContentTransformation(data, {
        entries: reconstructContentfulEntry
      });
    }
    case "SANITY": {
      return applyContentTransformation(data, {
        arbitraryContent: transformSanityContent,
        entries: transformSanityContent
      });
    }
    default: {
      return data;
    }
  }
}
function transformContent(entries, locale) {
  return entries.filter((entry) => entry.handle).map((entry) => {
    const {
      title,
      handle,
      createdAt,
      updatedAt,
      indexedAt,
      type,
      sourceEntryId,
      nacelleEntryId
    } = entry;
    const { sourceName: cms } = destructureNacelleEntryId(nacelleEntryId);
    const _a = entry.fields || {}, {
      articles = null,
      author = null,
      blogHandle = null,
      collectionHandle = null,
      content: content2 = null,
      contentHtml = null,
      description = null,
      excerpt = null,
      featuredMedia = null,
      publishDate = null,
      relatedArticles = null,
      sections = null,
      tags = null
    } = _a, fields = __objRest(_a, [
      "articles",
      "author",
      "blogHandle",
      "collectionHandle",
      "content",
      "contentHtml",
      "description",
      "excerpt",
      "featuredMedia",
      "publishDate",
      "relatedArticles",
      "sections",
      "tags"
    ]);
    const contentIsString = typeof content2 === "string";
    if (content2 && !contentIsString && typeof content2 === "object") {
      fields.content = content2;
    }
    return {
      articleLists: transformArticleLists(articles, blogHandle, locale),
      author: transformAuthor(author, cms),
      blogHandle,
      cmsSyncSource: cms.toLowerCase(),
      cmsSyncSourceDomain: "",
      cmsSyncSourceContentId: transformSourceEntryId(sourceEntryId),
      collectionHandle,
      content: contentIsString ? content2 : null,
      contentHtml,
      createdAt,
      description,
      excerpt,
      featuredMedia: transformMedia(featuredMedia, cms),
      fields: applyCmsTransforms(fields, cms),
      globalHandle: `${handle}::${locale}`,
      handle,
      id: nacelleEntryId,
      indexedAt: indexedAt || 0,
      locale,
      publishDate: toUnixTimestamp(publishDate),
      relatedArticles: transformRelatedArticles(relatedArticles, cms),
      sections: applyCmsTransforms(sections, cms),
      tags,
      title,
      type: type || "",
      updatedAt
    };
  });
}
const isContentfulEntry = (x) => isObject(x == null ? void 0 : x.fields) && isObject(x == null ? void 0 : x.sys);
function flattenContentfulContent(entry) {
  if (!isObject(entry == null ? void 0 : entry.fields)) {
    return entry;
  }
  const newEntry = {};
  for (const [key, value] of Object.entries(entry.fields)) {
    if (isContentfulMedia(value)) {
      newEntry[key] = flattenContentfulMedia(value);
    } else if (isContentfulEntry(value)) {
      newEntry[key] = flattenContentfulContent(value.fields);
    } else {
      newEntry[key] = value;
    }
  }
  if (isContentfulEntry(entry)) {
    const { createdAt = 0, updatedAt = 0 } = entry.sys;
    newEntry.createdAt = createdAt;
    newEntry.updatedAt = updatedAt;
  } else {
    newEntry.createdAt = 0;
    newEntry.updatedAt = 0;
  }
  return flattenContentfulContent(newEntry);
}
function reconstructContentfulEntry(content2) {
  var _a, _b;
  const { sourceEntryId } = destructureNacelleEntryId(
    content2.nacelleEntryId
  );
  return {
    fields: content2.fields,
    metadata: {
      tags: (_a = content2.tags) != null ? _a : []
    },
    sys: {
      id: sourceEntryId,
      type: "Entry",
      contentType: {
        sys: {
          id: (_b = content2.type) != null ? _b : "",
          linkType: "ContentType",
          type: "Link"
        }
      }
    }
  };
}
function transformAuthor(authorInput, cms) {
  if (!authorInput || typeof authorInput !== "object" || Array.isArray(authorInput)) {
    return null;
  }
  const newAuthor = {
    bio: null,
    email: null,
    firstName: null,
    lastName: null
  };
  const author = cms === "CONTENTFUL" ? flattenContentfulContent(authorInput) : authorInput;
  for (const [key, value] of Object.entries(author)) {
    const property = key;
    if (typeof value === "string" && value.length && typeof newAuthor[property] !== "undefined") {
      newAuthor[key] = value;
    }
  }
  return newAuthor;
}
function transformCollections(collections, locale) {
  return collections.map((collection) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const productHandles = [];
    if (collection.productConnection.edges) {
      const edges = collection.productConnection.edges;
      edges.forEach((product2) => {
        var _a2;
        if ((_a2 = product2.node.content) == null ? void 0 : _a2.handle) {
          productHandles.push(product2.node.content.handle);
        }
      });
    }
    const collectionHandle = (_b = (_a = collection.content) == null ? void 0 : _a.handle) != null ? _b : "";
    const collectionTitle = (_d = (_c = collection.content) == null ? void 0 : _c.title) != null ? _d : "";
    const collectionDescription = (_f = (_e = collection.content) == null ? void 0 : _e.description) != null ? _f : "";
    const featuredMedia = transformMedia((_g = collection.content) == null ? void 0 : _g.featuredMedia);
    return {
      id: collection.nacelleEntryId,
      handle: collectionHandle,
      locale,
      globalHandle: `${collectionHandle}::${locale}`,
      pimSyncSourceDomain: "",
      pimSyncSource: "",
      pimSyncSourceCollectionId: transformSourceEntryId(
        collection.sourceEntryId
      ),
      title: collectionTitle,
      description: collectionDescription,
      featuredMedia,
      productLists: [
        {
          title: "default",
          slug: "default",
          locale,
          handles: productHandles
        }
      ],
      createdAt: collection.createdAt,
      updatedAt: collection.updatedAt,
      indexedAt: collection.indexedAt,
      metafields: collection.metafields
    };
  });
}
function transformProducts(products, locale) {
  return products.map((product2) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    const formatPrice = (price) => {
      if (Number.isInteger(price))
        return price.toFixed(1);
      return price.toString();
    };
    const hasVariant = Array.isArray(product2.variants) && product2.variants.length;
    const variantPrices = hasVariant && ((_a = product2.variants) == null ? void 0 : _a.map((variant) => parseFloat(variant.price)).sort((a, b) => a - b).map((price) => formatPrice(price)));
    const priceCurrency = hasVariant ? (_b = product2.variants[0]) == null ? void 0 : _b.priceCurrency : null;
    return {
      availableForSale: product2.availableForSale,
      createdAt: product2.createdAt,
      description: ((_c = product2.content) == null ? void 0 : _c.description) || null,
      featuredMedia: transformMedia((_d = product2.content) == null ? void 0 : _d.featuredMedia),
      globalHandle: ((_e = product2.content) == null ? void 0 : _e.handle) ? `${(_f = product2.content) == null ? void 0 : _f.handle}::${locale}` : "",
      handle: ((_g = product2.content) == null ? void 0 : _g.handle) || "",
      id: product2.nacelleEntryId,
      indexedAt: product2.indexedAt,
      locale,
      media: ((_i = (_h = product2.content) == null ? void 0 : _h.media) == null ? void 0 : _i.map(
        (media2) => transformMedia(media2)
      )) || null,
      metafields: product2.metafields,
      pimSyncSource: "",
      pimSyncSourceDomain: "",
      pimSyncSourceProductId: transformSourceEntryId(product2.sourceEntryId),
      priceRange: Array.isArray(variantPrices) ? {
        min: variantPrices[0],
        max: variantPrices[variantPrices.length - 1],
        currencyCode: priceCurrency
      } : null,
      productType: product2.productType,
      tags: product2.tags,
      title: ((_j = product2.content) == null ? void 0 : _j.title) || null,
      updatedAt: product2.updatedAt,
      vendor: product2.vendor,
      variants: (_k = product2.variants) == null ? void 0 : _k.map((variant) => {
        var _a2, _b2, _c2, _d2, _e2, _f2;
        const transformedVariant = {
          availableForSale: variant.availableForSale,
          compareAtPrice: variant.compareAtPrice && formatPrice(Number(variant.compareAtPrice)),
          compareAtPriceCurrency: variant.compareAtPrice && formatPrice(Number(variant.compareAtPrice)),
          featuredMedia: transformMedia((_a2 = variant.content) == null ? void 0 : _a2.featuredMedia),
          id: transformSourceEntryId(variant.sourceEntryId),
          metafields: variant.metafields,
          price: formatPrice(Number(variant.price)),
          priceCurrency: variant.priceCurrency,
          priceRules: Array.isArray(variant.priceRules) && variant.priceRules.length ? (_b2 = variant.priceRules) == null ? void 0 : _b2.map((priceRule) => __spreadProps(__spreadValues({}, priceRule), {
            comparedAtPrice: priceRule.comparedAtPrice ? formatPrice(Number(priceRule.comparedAtPrice)) : null,
            price: formatPrice(Number(priceRule.price)),
            priceBreaks: priceRule.priceBreaks && priceRule.priceBreaks.map((priceBreak) => __spreadProps(__spreadValues({}, priceBreak), {
              price: formatPrice(Number(priceBreak.price))
            }))
          })) : [],
          quantityAvailable: variant.quantityAvailable,
          selectedOptions: ((_d2 = (_c2 = variant.content) == null ? void 0 : _c2.selectedOptions) == null ? void 0 : _d2.map(({ name, value }) => ({
            name,
            value
          }))) || null,
          sku: variant.sku,
          swatchSrc: ((_e2 = variant.content) == null ? void 0 : _e2.swatchSrc) || null,
          title: ((_f2 = variant.content) == null ? void 0 : _f2.title) || null,
          weight: variant.weight,
          weightUnit: variant.weightUnit
        };
        return transformedVariant;
      })
    };
  });
}
function transformRelatedArticles(relatesArticlesInput, cms) {
  if (!relatesArticlesInput || !Array.isArray(relatesArticlesInput)) {
    return null;
  }
  return relatesArticlesInput.map((relatedArticle) => {
    const newRelatedArticle = {
      author: null,
      blogHandle: null,
      cmsSyncSourceContentId: null,
      createdAt: 0,
      description: null,
      excerpt: null,
      featuredMedia: null,
      handle: "",
      locale: "",
      publishDate: 0,
      tags: null,
      title: null,
      updatedAt: 0
    };
    const formattedRelatedArticle = cms === "CONTENTFUL" ? flattenContentfulContent(relatedArticle) : relatedArticle;
    for (const [key, value] of Object.entries(
      formattedRelatedArticle
    )) {
      if (value) {
        switch (key) {
          case "author": {
            if (typeof value === "object" && !Array.isArray(value)) {
              newRelatedArticle.author = transformAuthor(value, cms);
            }
            break;
          }
          case "featuredMedia": {
            if (typeof value === "object" && !Array.isArray(value) && typeof value.src !== "undefined") {
              newRelatedArticle.featuredMedia = transformMedia(value, cms);
            }
            break;
          }
          case "createdAt": {
            if (typeof value === "number") {
              newRelatedArticle.createdAt = value;
            }
            break;
          }
          case "publishDate": {
            if (typeof value === "number") {
              newRelatedArticle.publishDate = value;
            }
            break;
          }
          case "updatedAt": {
            if (typeof value === "number") {
              newRelatedArticle.updatedAt = value;
            }
            break;
          }
          case "tags": {
            if (Array.isArray(value)) {
              newRelatedArticle.tags = value;
            }
            break;
          }
          case "locale": {
            if (typeof value === "string") {
              newRelatedArticle.locale = value.toLowerCase();
            }
            break;
          }
          default: {
            newRelatedArticle[key] = value;
          }
        }
      }
    }
    return newRelatedArticle;
  });
}
function transformSanityMedia(media2) {
  const newAsset = __spreadValues({}, media2.asset);
  if (newAsset.metadata && typeof newAsset.metadata.palette !== "undefined") {
    delete newAsset.metadata.palette;
  }
  if (typeof media2.asset._depth === "undefined") {
    newAsset._depth = 1;
  }
  return __spreadProps(__spreadValues({}, media2), {
    asset: newAsset
  });
}
function transformSanityContent(content2) {
  if (Array.isArray(content2)) {
    return content2.map(
      (entry) => transformSanityContent(entry)
    );
  }
  if (isObject(content2)) {
    if (isSanityMedia(content2)) {
      content2 = transformSanityMedia(content2);
    } else {
      for (const [property, value] of Object.entries(content2)) {
        const key = property;
        if (Array.isArray(value) || isObject(value)) {
          content2[key] = transformSanityContent(value);
        }
      }
    }
  }
  return content2;
}
function transformLinks(items) {
  return items.map((item) => {
    var _a;
    return {
      title: item.title,
      to: item.url,
      type: item.type && item.type.charAt(0) + item.type.toLowerCase().slice(1),
      links: ((_a = item == null ? void 0 : item.items) == null ? void 0 : _a.length) ? transformLinks(item.items) : null
    };
  });
}
function transformSpace(space) {
  var _a, _b, _c, _d;
  const metafields = (_c = (_b = (_a = space.spaceProperties) == null ? void 0 : _a.properties) == null ? void 0 : _b.map((property) => {
    var _a2, _b2, _c2;
    const namespace = (_a2 = property == null ? void 0 : property.namespace) != null ? _a2 : "";
    return (_c2 = (_b2 = property == null ? void 0 : property.items) == null ? void 0 : _b2.map((item) => {
      var _a3, _b3;
      return {
        key: (_a3 = item == null ? void 0 : item.key) != null ? _a3 : "",
        value: (_b3 = item == null ? void 0 : item.value) != null ? _b3 : "",
        namespace
      };
    })) != null ? _c2 : [];
  }).flat()) != null ? _c : [];
  const linklists = (_d = space.navigation) == null ? void 0 : _d.map((group) => {
    var _a2;
    return {
      handle: group.groupId,
      links: ((_a2 = group == null ? void 0 : group.items) == null ? void 0 : _a2.length) ? transformLinks(group.items) : null
    };
  });
  return {
    id: space.spaceId,
    name: "",
    domain: "",
    linklists,
    metafields,
    pimSyncSourceDomain: "",
    cmsSyncSourceDomain: ""
  };
}
const allProductCollectionsQuery = `
  query allProductCollections(
    $filter: ProductCollectionFilterInput
  ) {
    allProductCollections(filter: $filter) {
      edges {
        node {
          nacelleEntryId
          sourceEntryId
          indexedAt
          createdAt
          updatedAt
          tags
          metafields {
            id
            namespace
            key
            value
          }
          productConnection {
            edges {
              node {
                content {
                  handle
                }
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
          content {
            collectionEntryId
            createdAt
            description
            featuredMedia {
              altText
              id
              src
              thumbnailSrc
              type
            }
            fields
            handle
            indexedAt
            locale
            metafields {
              id
              namespace
              key
              value
            }
            nacelleEntryId
            sourceEntryId
            title
            updatedAt
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
const allProductCollectionsProductHandlesQuery = `
  query allProductCollections(
    $filter: ProductCollectionFilterInput
    $after: String
  ) {
    allProductCollections(filter: $filter) {
      edges {
        node {
          nacelleEntryId
          productConnection(after: $after) {
            edges {
              node {
                content {
                  handle
                }
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      }
    }
  }
`;
const allProductCollectionsProductsQuery = `
  query allProductCollections(
    $filter: ProductCollectionFilterInput
    $after: String
  ) {
    allProductCollections(filter: $filter) {
      edges {
        node {
          nacelleEntryId
          productConnection(after: $after) {
            edges {
              node {
                availableForSale
                createdAt
                nacelleEntryId
                sourceEntryId
                indexedAt
                metafields {
                  id
                  key
                  namespace
                  value
                }
                productType
                tags
                updatedAt
                vendor
                variants {
                  availableForSale
                  compareAtPrice
                  content {
                    createdAt
                    description
                    featuredMedia {
                      altText
                      id
                      mimeType
                      src
                      thumbnailSrc
                      type
                    }
                    fields
                    indexedAt
                    locale
                    media {
                      altText
                      id
                      mimeType
                      src
                      thumbnailSrc
                      type
                    }
                    metafields {
                      id
                      key
                      namespace
                      value
                    }
                    nacelleEntryId
                    productEntryId
                    productHandle
                    published
                    selectedOptions {
                      label
                      name
                      value
                    }
                    sourceEntryId
                    swatchSrc
                    title
                    updatedAt
                    variantEntryId
                  }
                  createdAt
                  indexedAt
                  metafields {
                    id
                    key
                    namespace
                    value                        
                  }
                  nacelleEntryId
                  price
                  priceCurrency
                  priceRules {
                    availableTo
                    comparedAtPrice
                    handle
                    id
                    metafields {
                      id
                      key
                      namespace
                      value
                    }
                    price
                    priceBreaks {
                      metafields {
                        id
                        key
                        namespace
                        value
                      }
                      price
                      quantityMax
                      quantityMin
                    }
                    priceCurrency
                    title
                  }
                  productEntryId
                  productHandle
                  quantityAvailable
                  sku
                  sourceEntryId
                  updatedAt
                  weight
                  weightUnit
                }
                content {
                  createdAt
                  description
                  featuredMedia {
                    altText
                    id
                    mimeType
                    src
                    thumbnailSrc
                    type
                  }
                  fields
                  handle
                  indexedAt
                  locale
                  media {
                    altText
                    id
                    mimeType
                    src
                    thumbnailSrc
                    type
                  }
                  metafields {
                    id
                    key
                    namespace
                    value
                  }
                  nacelleEntryId
                  options {
                    name
                    values
                  }
                  productEntryId
                  published
                  seo {
                    title
                    description
                  }
                  sourceEntryId
                  title
                  updatedAt
                }
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      }
    }
  }
`;
const notFoundMessages = {
  product: "Product was not found.",
  collection: "Collection was not found.",
  content: "Content was not found."
};
class NacelleCompatibilityConnector extends NacelleGraphQLConnector {
  constructor(params) {
    var _a, _b;
    let token;
    let endpoint;
    if (params.client) {
      token = (_a = params.client.getConfig().token) != null ? _a : "<no-token>";
      endpoint = params.client.getConfig().storefrontEndpoint;
    } else {
      if (!params.token) {
        throw new Error(
          "@nacelle/compatibility-connector requires a valid Nacelle Public Storefront token."
        );
      }
      if (!params.endpoint) {
        throw new Error(
          "@nacelle/compatibility-connector requires a valid Nacelle Storefront Endpoint."
        );
      }
      token = params.token;
      endpoint = params.endpoint;
    }
    const endpointRegex = /\/spaces\/([a-z0-9-]+)\/?/i;
    const endpointMatch = endpointRegex.exec(endpoint);
    if (!endpointMatch) {
      throw new Error(
        "@nacelle/compatibility-connector requires a valid Nacelle Storefront Endpoint."
      );
    }
    super({
      endpoint,
      token,
      spaceId: endpointMatch[1]
    });
    __publicField(this, "client");
    __publicField(this, "locale");
    __publicField(this, "spaceId");
    this.locale = ((_b = params.client) == null ? void 0 : _b.getConfig().locale) || params.locale || "en-us";
    this.spaceId = endpointMatch[1];
    this.client = params.client || Storefront({
      token,
      storefrontEndpoint: endpoint,
      locale: toIetfLocale(this.locale)
    });
    ["content", "navigation", "products", "spaceProperties"].forEach(
      (methodName) => checkStorefrontSdkMethod(this.client, methodName)
    );
  }
  article(params) {
    return __async(this, null, function* () {
      const contentParams = {
        handles: [params.handle],
        type: "article",
        locale: toIetfLocale(params.locale || this.locale),
        maxReturnedEntries: 1
      };
      const entryDepth = sanitizeIntegerValue(params == null ? void 0 : params.entryDepth, 0);
      if (entryDepth) {
        contentParams.entryDepth = entryDepth;
      }
      const articles = yield this.client.content(contentParams);
      if (!articles.length) {
        throw new Error(notFoundMessages.content);
      }
      return transformContent(articles, params.locale || this.locale)[0];
    });
  }
  articles(params) {
    return __async(this, null, function* () {
      const contentParams = {
        handles: params.handles,
        type: "article",
        locale: toIetfLocale(params.locale || this.locale)
      };
      const entryDepth = sanitizeIntegerValue(params == null ? void 0 : params.entryDepth, 0);
      if (entryDepth) {
        contentParams.entryDepth = entryDepth;
      }
      let articles = yield this.client.content(contentParams);
      if (params.blogHandle) {
        articles = articles.filter(
          (article) => {
            var _a;
            return ((_a = article.fields) == null ? void 0 : _a.blogHandle) === params.blogHandle;
          }
        );
      }
      return transformContent(articles, params.locale || this.locale);
    });
  }
  content(params) {
    return __async(this, null, function* () {
      const contentParams = {
        handles: [params.handle],
        type: params.type,
        locale: toIetfLocale(params.locale || this.locale),
        maxReturnedEntries: 1
      };
      const entryDepth = sanitizeIntegerValue(params == null ? void 0 : params.entryDepth, 0);
      if (entryDepth) {
        contentParams.entryDepth = entryDepth;
      }
      const content2 = yield this.client.content(contentParams);
      if (!content2.length) {
        throw new Error(notFoundMessages.content);
      }
      return transformContent(content2, params.locale || this.locale)[0];
    });
  }
  allContent(params) {
    return __async(this, null, function* () {
      const entryDepth = sanitizeIntegerValue(params == null ? void 0 : params.entryDepth, 0);
      const contentParams = {
        maxReturnedEntries: -1,
        type: params == null ? void 0 : params.type
      };
      if (params == null ? void 0 : params.queryLimit) {
        const entriesPerPage = sanitizeIntegerValue(params.queryLimit, 50, 1, 250);
        contentParams.advancedOptions = { entriesPerPage };
      }
      if (entryDepth) {
        contentParams.entryDepth = entryDepth;
      }
      const content2 = yield this.client.content(contentParams);
      const results = transformContent(content2, (params == null ? void 0 : params.locale) || this.locale);
      if ((params == null ? void 0 : params.limit) && params.limit > 0) {
        return results.slice(0, params.limit);
      }
      return results;
    });
  }
  page(params) {
    return __async(this, null, function* () {
      const contentParams = {
        handles: [params.handle],
        type: "page",
        locale: toIetfLocale(params.locale || this.locale),
        maxReturnedEntries: 1
      };
      const entryDepth = sanitizeIntegerValue(params == null ? void 0 : params.entryDepth, 0);
      if (entryDepth) {
        contentParams.entryDepth = entryDepth;
      }
      const content2 = yield this.client.content(contentParams);
      if (!content2.length) {
        throw new Error(notFoundMessages.content);
      }
      return transformContent(content2, params.locale || this.locale)[0];
    });
  }
  pages(params) {
    return __async(this, null, function* () {
      const contentParams = {
        handles: params.handles,
        type: "page",
        locale: toIetfLocale(params.locale || this.locale)
      };
      const entryDepth = sanitizeIntegerValue(params == null ? void 0 : params.entryDepth, 0);
      if (entryDepth) {
        contentParams.entryDepth = entryDepth;
      }
      const content2 = yield this.client.content(contentParams);
      return transformContent(content2, params.locale || this.locale);
    });
  }
  blog(params) {
    return __async(this, null, function* () {
      const contentParams = {
        handles: [params.handle],
        type: "blog",
        locale: toIetfLocale(params.locale || this.locale),
        maxReturnedEntries: 1
      };
      const entryDepth = sanitizeIntegerValue(params == null ? void 0 : params.entryDepth, 0);
      if (entryDepth) {
        contentParams.entryDepth = entryDepth;
      }
      const blogs = yield this.client.content(contentParams);
      if (!blogs.length) {
        throw new Error(notFoundMessages.content);
      }
      return transformContent(blogs, params.locale || this.locale)[0];
    });
  }
  blogPage(params) {
    return __async(this, null, function* () {
      var _a;
      const {
        handle,
        locale,
        index = 0,
        itemsPerPage = 30,
        list = "default",
        paginate
      } = params;
      let { blog } = params;
      let articles = [];
      let handles = [];
      if (!blog) {
        if (!handle) {
          throw new Error("A blog or handle is required");
        }
        blog = yield this.blog({
          handle,
          locale,
          entryDepth: params.entryDepth
        });
      }
      if (Array.isArray(blog.articleLists)) {
        const blogArticleHandles = (_a = blog.articleLists.find(
          (articleList) => articleList.slug === list
        )) == null ? void 0 : _a.handles;
        if (Array.isArray(blogArticleHandles)) {
          handles = blogArticleHandles;
        }
      }
      if (paginate && handles.length) {
        handles = handles.slice(index, index + itemsPerPage);
      }
      const contentParams = {
        handles,
        type: "article",
        locale: toIetfLocale(params.locale || this.locale),
        maxReturnedEntries: handles.length
      };
      const entryDepth = sanitizeIntegerValue(params == null ? void 0 : params.entryDepth, 0);
      if (entryDepth) {
        contentParams.entryDepth = entryDepth;
      }
      articles = handles.length ? yield this.client.content(contentParams) : [];
      return transformContent(articles, params.locale || this.locale);
    });
  }
  product(params) {
    return __async(this, null, function* () {
      const products = yield this.client.products({
        handles: [params.handle],
        locale: toIetfLocale(params.locale || this.locale),
        maxReturnedEntries: 1
      });
      if (!products.length) {
        throw new Error(notFoundMessages.product);
      }
      return transformProducts(products, params.locale || this.locale)[0];
    });
  }
  products(params) {
    return __async(this, null, function* () {
      const products = yield this.client.products({
        handles: params.handles,
        locale: toIetfLocale(params.locale || this.locale)
      });
      return transformProducts(products, params.locale || this.locale);
    });
  }
  allProducts(params) {
    return __async(this, null, function* () {
      const maxReturnedEntries = sanitizeIntegerValue(params == null ? void 0 : params.limit, -1, -1);
      const productsParams = { maxReturnedEntries };
      if (params == null ? void 0 : params.queryLimit) {
        const entriesPerPage = sanitizeIntegerValue(params.queryLimit, 50, 1, 250);
        productsParams.advancedOptions = { entriesPerPage };
      }
      const products = yield this.client.products(productsParams);
      return transformProducts(products, (params == null ? void 0 : params.locale) || this.locale);
    });
  }
  isVariantAvailable(params) {
    return __async(this, null, function* () {
      const [product2] = yield this.client.products({
        nacelleEntryIds: [params.productId],
        locale: toIetfLocale(this.locale),
        maxReturnedEntries: 1
      });
      return checkVariantAvailability({
        product: product2,
        variantId: params.variantId
      });
    });
  }
  space() {
    return __async(this, null, function* () {
      const spaceProperties = yield this.client.spaceProperties();
      const navigation2 = yield this.client.navigation();
      return transformSpace({
        spaceProperties,
        navigation: navigation2,
        spaceId: this.spaceId
      });
    });
  }
  collection(params) {
    return __async(this, null, function* () {
      const response = yield graphqlQuery(
        allProductCollectionsQuery,
        {
          filter: {
            handles: [params.handle],
            locale: toIetfLocale(params.locale || this.locale)
          }
        },
        this.client
      );
      const collections = yield this.paginateProducts(
        response.allProductCollections.edges,
        {
          locale: toIetfLocale(params.locale || this.locale)
        }
      );
      if (!collections.length) {
        throw new Error(notFoundMessages.collection);
      }
      return transformCollections(collections, params.locale || this.locale)[0];
    });
  }
  collectionPage(_0) {
    return __async(this, arguments, function* ({
      handle,
      locale,
      collection,
      paginate,
      index = 0,
      itemsPerPage = 30
    }) {
      var _a;
      if (typeof collection === "undefined" && !handle) {
        throw new Error("A collection or handle is required");
      }
      if (collection) {
        let handles = [];
        if (((_a = collection.productLists) == null ? void 0 : _a.length) && collection.productLists[0].handles) {
          handles.push(...collection.productLists[0].handles);
        }
        if (!handles.length) {
          throw new Error("Selected list does not have array of handles");
        }
        if (paginate) {
          handles = handles.slice(index, index + itemsPerPage);
        }
        const collectionProducts = yield this.client.products({
          handles,
          locale: toIetfLocale(locale || this.locale),
          maxReturnedEntries: -1
        });
        return transformProducts(collectionProducts, locale || this.locale);
      }
      const response = yield graphqlQuery(
        allProductCollectionsProductsQuery,
        {
          filter: {
            handles: [handle],
            locale: toIetfLocale(locale || this.locale)
          }
        },
        this.client
      );
      const collections = yield this.paginateProducts(
        response.allProductCollections.edges,
        {
          locale: toIetfLocale(locale || this.locale)
        },
        true
      );
      let products = [];
      if (collections.length && collections[0].productConnection.edges) {
        const edges = collections[0].productConnection.edges;
        products = edges.map((product2) => product2.node);
      }
      if (paginate && products) {
        products = products.slice(index, index + itemsPerPage);
      }
      return transformProducts(products, locale || this.locale);
    });
  }
  allCollections(params) {
    return __async(this, null, function* () {
      let allCollections = [];
      let keepFetching = true;
      let nextAfter;
      do {
        const first = sanitizeIntegerValue(params == null ? void 0 : params.queryLimit, 50, 1, 250);
        const response = yield graphqlQuery(
          allProductCollectionsQuery,
          {
            filter: {
              first,
              after: nextAfter
            }
          },
          this.client
        );
        const collections = yield this.paginateProducts(
          response.allProductCollections.edges
        );
        allCollections = allCollections.concat(collections);
        nextAfter = response.allProductCollections.pageInfo.endCursor;
        keepFetching = response.allProductCollections.pageInfo.hasNextPage;
      } while (keepFetching);
      if (params == null ? void 0 : params.limit) {
        allCollections = allCollections.slice(0, params.limit);
      }
      return transformCollections(allCollections, (params == null ? void 0 : params.locale) || this.locale);
    });
  }
  paginateProducts(collections, filter, fullProducts) {
    return Promise.all(
      collections.map((collection) => __async(this, null, function* () {
        var _a, _b, _c, _d;
        let productConnection = collection.node.productConnection.edges;
        let hasNextPage = (_a = collection.node.productConnection.pageInfo) == null ? void 0 : _a.hasNextPage;
        let endCursor = (_b = collection.node.productConnection.pageInfo) == null ? void 0 : _b.endCursor;
        while (hasNextPage) {
          const paginatedResponse = yield graphqlQuery(
            fullProducts ? allProductCollectionsProductsQuery : allProductCollectionsProductHandlesQuery,
            {
              filter: __spreadValues({
                nacelleEntryIds: [collection.node.nacelleEntryId]
              }, filter),
              after: endCursor
            },
            this.client
          );
          const paginatedCollection = paginatedResponse.allProductCollections.edges[0];
          const edges = paginatedCollection ? paginatedCollection.node.productConnection.edges : [];
          productConnection = [...productConnection, ...edges];
          hasNextPage = paginatedCollection && ((_c = paginatedCollection.node.productConnection.pageInfo) == null ? void 0 : _c.hasNextPage);
          endCursor = paginatedCollection && ((_d = paginatedCollection.node.productConnection.pageInfo) == null ? void 0 : _d.endCursor);
        }
        collection.node.productConnection.edges = productConnection;
        return collection.node;
      }))
    );
  }
}
export { NacelleCompatibilityConnector as default, notFoundMessages };
//# sourceMappingURL=nacelle-compatibility-connector.es.js.map
